/* halo-ob.js — GÉNÉRÉ par work/halo-object/build_halo_object.py depuis object-scroll.html (session HALO). Ne pas éditer. */

// (drayki v4) the media sit beside this file, in the theme's assets (hob-a-*, hob-v3-*)
const HOB = ((document.currentScript && document.currentScript.src) || "").replace(/[^/]*$/, "");

// ============================================================================
// The object: the slab, its plates, its rim, and the three tabs.
// ============================================================================
(() => {
  "use strict";
  const root = document.getElementById("ob");
  root.classList.add("js");
  // Safari on iOS shows a pressed button (:active) only once the page listens for touches
  root.addEventListener("touchstart", () => {}, { passive: true });
  const $ = (s) => root.querySelector(s);
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  // The interface the plates were photographed from, kept beside them: the
  // shared bundle changes with every release, and the photographs would no
  // longer match it. Both are replaced together (capture.mjs), on purpose.
  const UI_SRC = HOB + "hob-a-halo-ui.js";

  // arrivals
  const rio = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); rio.unobserve(e.target); } }), { threshold: .12 });
  root.querySelectorAll("[data-r]").forEach((el) => rio.observe(el));

  // three ways into the page from the top, and the arrow at the bottom (the
  // ids are in the markup, so the links lead there without the script too)
  root.querySelectorAll('a[href="#features"], a[href="#listen"], a[href="#specs"]').forEach((a) => a.addEventListener("click", (e) => {
    const to = document.getElementById(a.getAttribute("href").slice(1));
    if (!to) return;
    e.preventDefault();
    // (where the scroll puts something together as it comes — the sources'
    // plates set down, the specification drawing drawn — a link lands where
    // it is whole, its word near the top: see "the scroll")
    const y = root.__landAt ? root.__landAt(to) : null;
    if (y != null) { scrollTo({ top: y, behavior: reduce ? "auto" : "smooth" }); return; }
    to.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
  }));

  // ---- the object ---------------------------------------------------------
  // A slab: the running interface on its face, a rounded rim all round, an
  // engraved back — and, lying exactly on the face, plates: the parts of the
  // interface each tab is about, photographed in the very state the running
  // interface is kept in. A plate that is not in use is invisible, because it
  // is the same picture as what lies under it; when its tab comes round it
  // lifts off, and leaves its socket behind, empty (for a SUMMON press, the
  // face carried on under the sources, in their shadow).
  //
  // Every sum below is in the scene's own pixels (W x H). The slab itself is
  // laid out K times larger and scaled back by 1/K in its transform, so each
  // face is rasterised with K times the pixels; only what is written into its
  // style is multiplied by K.
  const stage = $(".stage"), scene = $("#scene"), thing = $("#thing"), front = $("#front"), backFace = $(".back");
  const tabs = [...root.querySelectorAll(".tab")];
  const D = Math.PI / 180;
  const clamp01 = (v) => Math.min(1, Math.max(0, v));
  const lerp = (a, b, u) => a + (b - a) * u;
  const glide = (u) => (u < .5 ? 4 * u * u * u : 1 - Math.pow(-2 * u + 2, 3) / 2);
  const smooth = (u) => { u = clamp01(u); return u * u * (3 - 2 * u); };
  const at = (a, b, x) => a < x && b >= x;   // x was crossed between two moments

  // Where the parts are, in the 1200 x 742 frame they were photographed in.
  // SUMMON's orb is a tile of its own, tight round it, drawn rather than
  // photographed, so that its press — the orbit swelling, the satellite's
  // lap — can be played on it at any size. The name beside it stays in the
  // face and changes there.
  const FW = 1200, FH = 742;
  const ZONES = { orb: [17.1, 11.1, 40, 40], a: [16, 64, 775, 202], b: [16, 325, 775, 202] };
  const ORB = [26.2, 20.2, 21.8];   // the orb's own box in the frame (#summon)
  // the round spot the orb leaves: its shadow, and the face carried on under it
  // (well clear of the "‹" before the preset's name, at 67.6)
  const ORB_SOCK = [ORB[0] + ORB[2] / 2 - 28, ORB[1] + ORB[2] / 2 - 28, 56, 56];
  // The five effects: a plate each, cut round its own module (the widest, RUIN,
  // with 14 of margin; the drawings from 564 to the labels at 670), the same
  // size and left margin for all five, so that between two of them there are
  // 28 of bare slab and their sockets stand apart. (Whole numbers, so the 3x
  // photographs are cut on their own pixels.)
  [12, 247, 481, 715, 950].forEach((x, i) => { ZONES["fx" + i] = [x, 548, 206, 134]; });

  // Three presets SUMMON really draws, each from a fixed seed, so that the
  // photographs and the running interface agree: what the interface reads in
  // each (a fingerprint of its text), the values it holds, and where its
  // parts sit. If it ever reads otherwise, the plates are not used at all and
  // the slab shows the interface simply running.
  const STATES = [
    { seed: 27, name: "pale signal", fp: "6mmfo7.688", v: { blend: .5457627686671912, haloAmount: .5050158604234457, grainAmount: .15689000680577012, ruinAmount: .21371885819826275, ghostAmount: .0540900616440922, spaceAmount: .4397436195518821 } },
    { seed: 31, name: "tidal horizon", fp: "1r3efrj.688", v: { blend: .6518852369859814, haloAmount: .49072002489119765, grainAmount: .409757931092754, ruinAmount: .23924731352599338, ghostAmount: .19650267977267502, spaceAmount: .5666101209819316 } },
    { seed: 33, name: "latent cascade", fp: "xcbjo5.693", v: { blend: .6352515552192926, haloAmount: .47048799723386764, grainAmount: .2990643558977172, ruinAmount: .13903795409714803, ghostAmount: .18647463710512965, spaceAmount: .649621273940429 } },
  ];
  const ANCHORS = [["#summon", [26.2, 20.2, 21.8, 21.8]], ["#preset-name", [86.1, 15.3]], ["#blend-axis", [47.5, 283.7, 527.4, 21.8]],
    [".sources .card", [26.2, 69.8, 755, 190.9]], [".sources .card:last-of-type", [26.2, 330.5, 755, 190.9]], ["#signature", [26.2, 532.4, 1147.7, 139.6]], ["#menu", [1118, 22, 55.8, 20.5]]];
  const FXIDS = ["haloAmount", "grainAmount", "ruinAmount", "ghostAmount", "spaceAmount"];

  // Each photograph comes at five sizes (in frame widths); a plate wears the
  // one nearest the size it is drawn at, so that it is never shrunk much on
  // its way to the screen — shrunk twice over in perspective, small lettering
  // breaks up.
  const SCALES = [.6, .8, 1.05, 1.4, 2];
  const IMG = (k, sc) => `${HOB}hob-a-s${k + 1}-${String(Math.round(sc * 100)).padStart(3, "0")}.webp`;
  const pickScale = (need) => SCALES.find((s) => s >= need / 1.08) || SCALES[SCALES.length - 1];
  // Each plate wears a photograph of its own, cut from the interface filmed
  // at three times its size, at five sizes up to 3x — so that on a retina
  // screen, stood up and brought toward the eye, its smallest lettering is
  // still drawn from more pixels than it covers.
  const PSCALES = [.8, 1.05, 1.4, 2, 3];
  const PIMG = (key, k, sc) => `${HOB}hob-a-p-${key}-s${k + 1}-${String(Math.round(sc * 100)).padStart(3, "0")}.webp`;
  // (never a size under the need: a plate is looked at closely)
  const pickPlate = (need) => PSCALES.find((s) => s >= need) || PSCALES[PSCALES.length - 1];
  // fetched once and kept, so a plate never waits on the network mid-gesture
  const got = new Map(), asked = new Set(), imgs = new Map();
  let dirty = true;
  // (one that fails is asked for again a little later, a few times)
  const failed = new Map();
  function want(url) {
    if (asked.has(url)) return;
    asked.add(url);
    const retry = () => { const n = (failed.get(url) || 0) + 1; failed.set(url, n); if (n <= 4) setTimeout(() => { asked.delete(url); want(url); }, 1500 * n); };
    const done = (src) => { const im = new Image(); im.src = src; (im.decode ? im.decode() : Promise.resolve()).then(() => { got.set(url, src); imgs.set(url, im); dirty = true; }, retry); };
    fetch(url).then((r) => (r.ok ? r.blob() : Promise.reject())).then((b) => done(URL.createObjectURL(b)), () => done(url));
  }

  const pct = (v, of) => `${(v / of) * 100}%`;
  const place = (el, [x, y, w, h]) => Object.assign(el.style, { left: pct(x, FW), top: pct(y, FH), width: pct(w, FW), height: pct(h, FH) });
  const plates = Object.entries(ZONES).map(([key, rect], i) => {
    const el = document.createElement("div"); el.className = "plate"; place(el, rect);
    const pf = document.createElement("i"); pf.className = "pf"; el.appendChild(pf);
    const vec = key === "orb";
    if (vec) { el.classList.add("orb"); pf.appendChild(orbArt(rect)); }
    const pc = vec ? null : document.createElement("i");
    if (pc) { pc.className = "pc"; pf.appendChild(pc); }
    const layers = vec ? [] : STATES.map(() => { const b = document.createElement("b"); pc.appendChild(b); return b; });
    if (!vec) layers[0].classList.add("on");
    thing.appendChild(el);
    const sock = document.createElement("i"); sock.className = vec ? "socket round" : "socket rec"; place(sock, vec ? ORB_SOCK : rect); front.appendChild(sock);
    // (the sources leave the bare face too, for a SUMMON press)
    const bare = key === "a" || key === "b" ? document.createElement("i") : null;
    if (bare) { bare.className = "socket bare"; place(bare, rect); front.appendChild(bare); }
    // its shadow, over its socket
    const shade = vec ? null : document.createElement("i");
    if (shade) { shade.className = "pshade"; place(shade, rect); front.appendChild(shade); }
    return { key, i, el, pf, layers, sock, bare, shade, vec, rect, rim: [], fx: key.startsWith("fx") ? +key.slice(2) : -1, sc: 1.05, url: STATES.map(() => (vec ? "drawn" : "")),
      shown: 0, hold: 0, queue: [], tLift: 0, tTilt: 0, lift: 0, lv: 0, tilt: 0, tv: 0, gk: { x: 1, v: 0 }, z: 0, op: 0, css: "", opCss: "", sockCss: "", bw: 0, bareCss: "", shCss: "", up: false, lapAt: -1e9, lapT: false, lapCss: "", dk: 0, shadeCss: "", rimT: null };
  });
  const P = Object.fromEntries(plates.map((p) => [p.key, p]));
  const FX = plates.filter((p) => p.fx >= 0);
  const veil = document.createElement("i");
  veil.className = "veil"; front.appendChild(veil);
  // (the exploded view's: the face a step down under all its sockets, laid
  // before them, so they stand out of it)
  const xdim = document.createElement("i");
  xdim.className = "xdim"; front.insertBefore(xdim, front.querySelector(".socket"));
  let veilCss = "0";
  const SUMMONED = [P.orb, P.a, P.b];
  const PHOTO = plates.filter((p) => !p.vec);
  // The orb, as the interface draws it (UI/index.html, #summon): a ring, a
  // core, and a satellite, in the interface's text colour, lavender for the
  // length of a press.
  function orbArt([x, y, w]) {
    const NS = "http://www.w3.org/2000/svg", mk = (n, a) => { const e = document.createElementNS(NS, n); Object.entries(a).forEach(([k, v]) => e.setAttribute(k, v)); return e; };
    const sv = mk("svg", { viewBox: "0 0 16 16", class: "orbv" });
    Object.assign(sv.style, { left: pct(ORB[0] - x, w), top: pct(ORB[1] - y, w), width: pct(ORB[2], w), height: pct(ORB[2], w) });
    const zoom = mk("g", {}), core = mk("circle", { cx: 8, cy: 8, r: 2.2, fill: "currentColor" }), sat = mk("g", {});
    zoom.append(mk("circle", { cx: 8, cy: 8, r: 6, fill: "none", stroke: "currentColor", "stroke-width": 1.4 }), core, sat);
    sat.append(mk("circle", { cx: 12.6, cy: 4.2, r: 1.7, fill: "currentColor" }));
    sv.append(zoom);
    sv.parts = { zoom, core, sat };
    return sv;
  }
  // How far the orb, drawn, is seen off the instrument: 0 over the dark face
  // (or over card A, lifted under it), 1 clear of both, over the page, and
  // between the two as it crosses an edge — the eye's line through its
  // centre, followed down to the face and to A in the slab's own frame.
  // m: the slab's turn; sc: its scale; ty: how far it is moved down; w, h:
  // its size; fz: its face's height over its middle; dx, dy, oz: where the
  // orb is carried to over its spot, and how high; g: how much it has grown;
  // a: card A's [dx, dy, height], or null where A is not on the slab
  const ORB_R = ((7 / 16) * ORB[2]) / FW;
  function orbOff(m, sc, ty, w, h, fz, dx, dy, oz, g, a) {
    const Y = (-.04 * h - ty) / sc, Z = (w * PERSP) / sc;
    const ex = m.m12 * Y + m.m13 * Z, ey = m.m22 * Y + m.m23 * Z, ez = m.m32 * Y + m.m33 * Z;
    const o = ZONES.orb, ox = ((o[0] + o[2] / 2) / FW - .5) * w + dx, oy = ((o[1] + o[3] / 2) / FH - .5) * h + dy;
    // (the slab seen all but edge-on, or from behind, turned by a hand: as it is)
    if (ez - oz < w * .1) return 0;
    // (how deep under the line a rounded box lies — less than nothing outside
    // it — and the ring's radius, where the line meets the box's plane)
    const depth = (z, r, bx, by, rc) => {
      const t = (ez - z) / (ez - oz), u = ex + t * (ox - ex), v = ey + t * (oy - ey);
      const cx = ((r[0] + r[2] / 2) / FW - .5) * w + bx, cy = ((r[1] + r[3] / 2) / FH - .5) * h + by;
      const qx = Math.abs(u - cx) - ((r[2] / FW) * w) / 2 + rc, qy = Math.abs(v - cy) - ((r[3] / FH) * h) / 2 + rc;
      return [rc - Math.hypot(Math.max(qx, 0), Math.max(qy, 0)) - Math.min(Math.max(qx, qy), 0), ORB_R * w * g * t];
    };
    let [d, rr] = depth(fz, [0, 0, FW, FH], 0, 0, Math.max(4, w * RADIUS));
    // (A counts only lying under it: above it, A hides what it covers, and
    // what is left of the ring shows over whatever is under A)
    if (a && a[2] < oz) d = Math.max(d, depth(a[2], ZONES.a, a[0], a[1], Math.max(2.5, w * PRADIUS))[0]);
    return smooth((rr - d) / (2 * rr));
  }

  // under reduced motion nothing moves: the tab dims what it is not about
  const DIMS = { header: [0, 0, 1200, 63], src: [0, 63, 792, 465], screen: [792, 63, 408, 465], fx: [0, 528, 1200, 150], foot: [0, 678, 1200, 64] };
  const dims = Object.fromEntries(Object.entries(DIMS).map(([k, r]) => { const e = document.createElement("i"); e.className = "dim"; place(e, r); front.appendChild(e); return [k, e]; }));
  const LIT = [["src"], ["header"], ["fx"]];

  // One pose per tab: how the slab is held (degrees), the most it may grow
  // before it is fitted to the room it has, and which plates leave it —
  // [delay s, lift in slab widths, tilt of the plate, drift down the slab in
  // slab heights, as it rises]. SUMMON's plates rise
  // only for the moment of a press ("brief"). The sources rise high and lean
  // toward the eye, turned nearly face-on while the slab stays at three
  // quarters; each goes straight up over its own socket, so the rest of the
  // socket shows empty under it (B hides what lies above it on the face,
  // the blend among it, and that is fine). A goes a hair higher than B, just
  // enough to clear it: leaning toward the eye, B's upper edge would
  // otherwise cross A's lower one, and the two read as one.
  const POSES = [
    { rx: 50, ry: 0, rz: -24, s: 1.5, at: .35, lift: { a: [0, .115, -20], b: [.14, .1, -20] }, tall: { rx: 40, rz: -8, lift: { a: [0, .1, -20], b: [.14, .1, -20] } } },
    { rx: 16, ry: 9, rz: -1.5, s: 1.2, at: 0, lift: {}, brief: { orb: [0, .045], a: [0, .026], b: [0, .026] } },
    { rx: 61, ry: 0, rz: -6, s: 1.38, at: .4, lift: { fx0: [0, .07, -36], fx1: [.12, .07, -36], fx2: [.24, .07, -36], fx3: [.36, .07, -36], fx4: [.48, .07, -36] }, tall: { rx: 50, rz: -2 },
      // drayki: "qu'à la fin de l'animation de effects ça revienne à un angle
      // un peu moins plat, qu'on voie bien l'UI" — once the five have landed,
      // the slab comes up off its low angle to one the whole interface reads
      // at, and the drawings sweep there
      rest: { rx: 28, ry: -8, rz: 1.5, s: 1.3 } },
  ];
  // (that last pose has a place of its own among the fitted ones)
  const REST = 3;
  // Without plates, the angles alone show each feature, and the instrument
  // does the rest itself.
  const BARE = [{ rx: 18, ry: 28, rz: -3, s: 1 }, { rx: 6, ry: -5, rz: 0, s: 1.08 }, { rx: 52, ry: -4, rz: 3, s: 1.26 }];
  const FLAT = { rx: 0, ry: 0, rz: 0, s: 1.25 };
  const NAMES = ["sources", "summon", "effects"];
  const LABELS = ["The halo interface, tilted back, its two source cards lifted off it", "The halo interface: SUMMON draws a new preset and names it", "The halo interface seen low, its five effect modules rising from it"];
  const PERSP = 3.7;          // the eye's distance, in slab widths
  // ---- the scroll: what the page asks of the object as it travels ------------
  // (written by the scroll script at the foot of the page, read here every
  // frame) x: how far the slab has come apart — every part a tab lifts, lifted
  // at once, the staircase of an exploded view; px: each part's own share of
  // it (they go one after another, and those that stay come home as the slab
  // leaves); turn: the slow turn it makes, held apart, as the page goes on;
  // dep: how far it has gone on its way (lying back and growing smaller);
  // ty: how far it lags the page, in the scene's pixels; gone: a part carried
  // on to its chapter, which the slab no longer draws (its socket stays, bare);
  // away: how far such a part has left its socket, its shadow there going as
  // it leaves (0 still over it, 1 gone from it); on:
  // the page has left its top — from the first pixel the tabs stop taking
  // turns, so the slab never comes apart from a pose it has just begun; vis:
  // where the scroll draws it, some of it can be seen (it keeps the slab's
  // frames going where its box, laid out, is out of sight); eye: how far the
  // eye is raised over the scene (see frame).
  const TRAVEL = { x: 0, px: {}, turn: 0, dep: 0, ty: 0, eye: 0, gone: {}, away: {}, on: false, vis: false, pin: true };
  // The exploded view: the slab at three quarters, every part over its own
  // socket and parallel to it — the effects low, the sources higher, A a
  // little over B, the orb highest and grown, like a satellite of the rest.
  const EXPLODE = { rx: 47, ry: 0, rz: -17, s: 1.3, lift: { fx0: [0, .06, 0], fx1: [0, .06, 0], fx2: [0, .06, 0], fx3: [0, .06, 0], fx4: [0, .06, 0], b: [0, .105, 0], a: [0, .125, 0], orb: [0, .16, 0] } };
  // (held upright — a phone — it turns less, so that it stays wide, and its
  // parts stand further off it, so that the staircase reads at that size)
  EXPLODE.tall = { rx: 46, rz: -8, lift: { fx0: [0, .085, 0], fx1: [0, .085, 0], fx2: [0, .085, 0], fx3: [0, .085, 0], fx4: [0, .085, 0], b: [0, .15, 0], a: [0, .18, 0], orb: [0, .23, 0] } };
  let FITX = { s: 1, y: 0 }, EXS = EXPLODE, drawnT = null, xdimCss = "", Mwas = null;
  const DWELL = [6.2, 6.6, 6.6];   // seconds, at the least, at rest in a pose
  const RADIUS = .0187;       // the corners: 14 px on a slab ~750 px wide
  const PRADIUS = .0068;      // a plate's: 5 px on the same slab
  const PTHICK = .014;        // and its thickness: a little over half the slab's

  let mode = "plates";        // "bare" once the interface turns out not to be the one photographed
  let ROOM = { l: -1, r: 1, t: -1, b: 1 };
  let W = 1, H = 1, DEP = 6, K = 2, FIT = [{ s: 1, y: 0 }, { s: 1, y: 0 }, { s: 1, y: 0 }, { s: 1, y: 0 }], faceSrc = "";
  // On a small screen the running interface would be drawn at a third of its
  // size and less, and its lettering breaks up; there the face stays a
  // photograph (of whichever preset the slab is in), and the interface is not
  // even fetched.
  // (aim: the pose the slab is going to — a tab's, or the effects' last —
  // and aimWas the one it comes from)
  let still = false, uiFailed = false, faceK = 0, faceSc = 1.05, uiAsked = false, rad = 8, aim = 0, aimWas = 0, cvOn = false, cvKey = "";
  let cvDims = [[1, 1], [1, 1], [1, 1], [1, 1]];
  // (asked as the style asks it, so the two never disagree at the edge)
  const narrow = matchMedia("(max-width: 700px)");
  const phone = () => narrow.matches;
  // an upright tablet is sized as a phone is (the same query as the style's)
  const upright = matchMedia("(min-width: 701px) and (max-aspect-ratio: 20/23)");
  const fitted = () => phone() || upright.matches;
  const tall = () => fitted() || stage.clientHeight > stage.clientWidth * 1.1;
  const table = () => (reduce ? [FLAT, FLAT, FLAT] : mode === "bare" ? BARE : POSES);
  const shapeOf = (Q) => (tall() && Q.tall ? { ...Q, ...Q.tall } : Q);
  // every pose the slab can be fitted to: the three tabs', and, with plates,
  // the one the effects come to rest in
  const fits = () => table().map(shapeOf).concat(reduce || mode === "bare" ? [] : [POSES[2].rest]);

  // ---- the rim ----------------------------------------------------------------
  // Thin planes standing round the rounded outline: the four straight runs,
  // and a few short chords at each corner, so the edge follows the rounding.
  // Built when the size changes; each is shaded by the angle its outward face
  // makes with a light fixed in the room (up and to the left, a little in
  // front), so a different edge catches it as the slab turns. The face itself
  // carries no light at all.
  const LIGHT = (() => { const v = [-.55, -.3, .78], m = Math.hypot(...v); return v.map((x) => x / m); })();
  const mix = (a, b, u) => a.map((x, i) => Math.round(x + (b[i] - x) * u));
  const rgb = (c) => `rgb(${c.join(",")})`;
  // The edge stays a dark edge: lit, it only lifts a few shades, and the
  // light it catches is a hairline along the lip at the face — never a pale
  // band under the slab. Its light comes in LV steps (made in measure: as
  // many as the slab is drawn large enough to tell apart, so that on a slow
  // turn it changes by one no eye can see, never by a visible step).
  // The same for a plate's rim, the slab's made smaller: its lip a little
  // wider, for an edge this thin — a long, soft rise to the lip (seen
  // edge-on, a sharp step in so thin a plane would be drawn as a stipple);
  // and seen steeply, only a few pixels across, the same light as one flat
  // colour (the gradient's own mean): so thin, a gradient across it is
  // squeezed into fewer pixels than it has steps, and breaks into dots.
  const SHADES = [], PSTOPS = [], PSHADES = [], PFLAT = [], PMEAN = [], PMIX = new Map();
  let LV = 0;
  function shades(n) {
    if (n === LV) return false;
    LV = n; PMIX.clear();
    SHADES.length = PSTOPS.length = PSHADES.length = PFLAT.length = PMEAN.length = 0;
    for (let i = 0; i <= n; i++) {
      const d = i / n, base = mix([19, 20, 25], [54, 57, 67], Math.pow(d, 1.35)), lip = mix(base, [150, 155, 170], Math.pow(d, 2.4) * .75);
      // the back of the edge darker, the lip at the face catching the light
      SHADES.push(`linear-gradient(to bottom, ${rgb(mix(base, [15, 16, 20], .55))}, ${rgb(base)} 70%, ${rgb(base)} 93%, ${rgb(lip)} 97%, ${rgb(lip)})`);
      const pl = mix(base, [150, 155, 170], Math.pow(d, 2.4) * .7), st = [mix(base, [15, 16, 20], .5), base, mix(base, pl, .4), pl];
      const [a, b, c, e] = st, mean = [0, 1, 2].map((k) => Math.round(.45 * (a[k] + b[k]) / 2 + .37 * (b[k] + c[k]) / 2 + .18 * (c[k] + e[k]) / 2));
      PSTOPS.push(st); PMEAN.push(mean);
      PSHADES.push(`linear-gradient(to bottom, ${rgb(a)}, ${rgb(b)} 45%, ${rgb(c)} 82%, ${rgb(e)})`);
      PFLAT.push(rgb(mean));
    }
    return true;
  }
  // (a light, 0..1, as the slab's rim wears it)
  const shadeOf = (v) => SHADES[Math.round(clamp01(v) * LV)];
  // (a plate's rim between its flat colour and its gradient: the stops drawn
  // toward their mean, in eighths — each made once, then kept)
  function pmix(lv, gq) {
    const k = lv * 9 + gq;
    let s = PMIX.get(k);
    if (!s) {
      const [a, b, c, e] = PSTOPS[lv].map((x) => mix(PMEAN[lv], x, gq / 8));
      s = `linear-gradient(to bottom, ${rgb(a)}, ${rgb(b)} 45%, ${rgb(c)} 82%, ${rgb(e)})`;
      PMIX.set(k, s);
    }
    return s;
  }
  let rim = [], rimKey = "";
  // Each plane stands a hair inside the face's outline (tuck), so that the
  // face's own soft edge is laid over the rim: edge to edge, the two soft
  // edges leave a seam the ground shows through, drawn as a dotted line along
  // the slab's front on a light page.
  const TUCK = .6;
  function buildRim() {
    const key = `${W}x${H}|${K}`;
    if (key === rimKey) return;
    rimKey = key;
    rim.forEach((s) => s.el.remove());
    rim = [];
    const LW = W * K, LH = H * K, R = rad * K, d = DEP * K, over = .6 * K, tuck = TUCK * K, segs = [];
    const add = (cx, cy, len, phi) => segs.push({ cx: cx - tuck * Math.cos(phi), cy: cy - tuck * Math.sin(phi), len, phi });
    add(0, -LH / 2, LW - 2 * R + over, -Math.PI / 2);
    add(LW / 2, 0, LH - 2 * R + over, 0);
    add(0, LH / 2, LW - 2 * R + over, Math.PI / 2);
    add(-LW / 2, 0, LH - 2 * R + over, Math.PI);
    // (on a small slab, three chords round each corner: its corners are a
    // few pixels across, and three are the curve to a quarter of a pixel —
    // every plane fewer is less for the phone to draw each frame)
    const n = W < 520 ? 3 : Math.min(10, Math.max(6, Math.round(rad / 1.5))), step = (Math.PI / 2) / n;
    for (const [ox, oy, a0] of [[LW / 2 - R, -LH / 2 + R, -Math.PI / 2], [LW / 2 - R, LH / 2 - R, 0], [-LW / 2 + R, LH / 2 - R, Math.PI / 2], [-LW / 2 + R, -LH / 2 + R, Math.PI]]) {
      for (let k = 0; k < n; k++) { const a = a0 + (k + .5) * step, rr = R * Math.cos(step / 2); add(ox + rr * Math.cos(a), oy + rr * Math.sin(a), 2 * R * Math.sin(step / 2) + .7 * K, a); }
    }
    const frag = document.createDocumentFragment();
    for (const s of segs) {
      const el = document.createElement("i"); el.className = "rim";
      el.style.cssText = `left:${(LW / 2 + s.cx - s.len / 2).toFixed(2)}px;top:${(LH / 2 + s.cy - d / 2).toFixed(2)}px;width:${s.len.toFixed(2)}px;height:${d.toFixed(2)}px;transform:rotateZ(${(s.phi + Math.PI / 2).toFixed(5)}rad) rotateX(90deg)`;
      frag.appendChild(el);
      rim.push({ el, nx: Math.cos(s.phi), ny: Math.sin(s.phi), cx: s.cx, cy: s.cy, lv: -1, away: false });
    }
    thing.appendChild(frag);
  }
  // (M: the slab's whole turn, the hand's included)
  function shadeRim(M) {
    for (const s of rim) {
      const qx = M.m11 * s.nx + M.m21 * s.ny, qy = M.m12 * s.nx + M.m22 * s.ny, qz = M.m13 * s.nx + M.m23 * s.ny;
      // an edge turned full to the eye is seen at its widest: it is kept the
      // darkest, so the slab's front never reads as a grey band
      const lv = Math.round(Math.max(0, qx * LIGHT[0] + qy * LIGHT[1] + qz * LIGHT[2]) * (1 - .6 * Math.max(0, qz)) * LV);
      if (lv !== s.lv) { s.lv = lv; s.el.style.background = SHADES[lv]; }
    }
  }
  // A plate's rim is the slab's, made smaller: the same thin planes round its
  // own rounded outline, standing behind its face as deep as it is thick, and
  // shaded by the same light (its shades: see the slab's).
  let prad = 3, prKey = "";
  function buildPlateRims() {
    const pt = Math.max(3, W * PTHICK) * K, key = `${W}x${H}|${K}|${prad}`;
    if (key === prKey) return;
    prKey = key;
    for (const p of PHOTO) {
      p.rim.forEach((s) => s.el.remove());
      p.rim = []; p.rimT = null; p.rimD = ""; p.ptL = pt;
      const LW = (W * K * p.rect[2]) / FW, LH = (H * K * p.rect[3]) / FH, R = Math.min(prad * K, LW / 2, LH / 2), over = .5 * K, segs = [];
      const add = (cx, cy, len, phi) => segs.push({ cx, cy, len, phi });
      add(0, -LH / 2, LW - 2 * R + over, -Math.PI / 2);
      add(LW / 2, 0, LH - 2 * R + over, 0);
      add(0, LH / 2, LW - 2 * R + over, Math.PI / 2);
      add(-LW / 2, 0, LH - 2 * R + over, Math.PI);
      // (four planes round each corner; two round an effect's, whose corners
      // are a few pixels across — the same curve, to a third of a pixel — and
      // two round every one on a small slab, where all of them are)
      const n = W < 520 ? 2 : p.fx >= 0 ? 2 : 4, step = (Math.PI / 2) / n;
      for (const [ox, oy, a0] of [[LW / 2 - R, -LH / 2 + R, -Math.PI / 2], [LW / 2 - R, LH / 2 - R, 0], [-LW / 2 + R, LH / 2 - R, Math.PI / 2], [-LW / 2 + R, -LH / 2 + R, Math.PI]]) {
        for (let k = 0; k < n; k++) { const a = a0 + (k + .5) * step, rr = R * Math.cos(step / 2); add(ox + rr * Math.cos(a), oy + rr * Math.sin(a), 2 * R * Math.sin(step / 2) + .6 * K, a); }
      }
      const frag = document.createDocumentFragment();
      for (const s of segs) {
        const el = document.createElement("i"); el.className = "prim";
        // (a pixel larger all round: its clear border, so the part drawn is the same size)
        el.style.cssText = `left:${(LW / 2 + s.cx - s.len / 2 - 1).toFixed(2)}px;top:${(LH / 2 + s.cy - pt / 2 - 1).toFixed(2)}px;width:${(s.len + 2).toFixed(2)}px;height:${(pt + 2).toFixed(2)}px;transform:translateZ(${(-pt / 2).toFixed(2)}px) rotateZ(${(s.phi + Math.PI / 2).toFixed(5)}rad) rotateX(90deg)`;
        frag.appendChild(el);
        p.rim.push({ el, nx: Math.cos(s.phi), ny: Math.sin(s.phi), bg: "", flat: false, ov: -1, rot: `rotateZ(${(s.phi + Math.PI / 2).toFixed(5)}rad) rotateX(90deg)` });
      }
      p.el.insertBefore(frag, p.pf);
    }
  }
  // (a plate's rim made as deep as d, from its face back: each plane
  // squeezed about its own middle, which is brought up to half of d)
  function sinkRim(p, d, none) {
    p.el.classList.toggle("low", none);
    if (none) return;
    const k = d / p.ptL, full = k > .999;
    // (a plane gone out — see shadePlateRim — is set as it comes back)
    p.sinkZ = `translateZ(${(-d / 2).toFixed(2)}px) `; p.sinkS = full ? "" : ` scaleY(${k.toFixed(4)})`;
    for (const s of p.rim) if (!s.out) sunk(p, s);
  }
  const sunk = (p, s) => { const tf = p.sinkZ + s.rot + p.sinkS; if (tf !== s.tf) { s.tf = tf; s.el.style.transform = tf; } };
  // (a plate's own tilt, as it is drawn, turns its rim's normals before the
  // slab's turn does; V: the way to the eye from the plate; k: how much of
  // the rim is left, 1 all of it)
  function shadePlateRim(p, M, V, k = 1) {
    const t = (p.tD ?? p.tilt) * D, c = Math.cos(t), sn = Math.sin(t);
    for (const s of p.rim) {
      const ny = s.ny * c, nz = s.ny * sn;
      const qx = M.m11 * s.nx + M.m21 * ny + M.m31 * nz, qy = M.m12 * s.nx + M.m22 * ny + M.m32 * nz, qz = M.m13 * s.nx + M.m23 * ny + M.m33 * nz;
      // (f: how squarely it faces the eye — 1 full on, 0 edge-on)
      const f = qx * V[0] + qy * V[1] + qz * V[2];
      // a plane seen almost edge-on is only a pixel or two wide, and so thin
      // it would be drawn as a stipple: it goes out (from about a third of its
      // thickness seen down to a tenth), and the face, drawn in its clear
      // margin, draws that edge smoothly
      const ov = (Math.round(clamp01((f - .12) / .18) * k * 100) / 100).toFixed(2);
      if (ov !== s.ov) { s.ov = ov; s.el.style.opacity = ov; }
      // (and one left out altogether is not laid out either: a plane at no
      // opacity is still a layer, handed to the compositor in every frame;
      // nor shaded, nor moved: it takes the light and its place again as it
      // comes back, in the same frame)
      const out = ov === "0.00";
      if (out !== s.out) { s.out = out; s.el.style.display = out ? "none" : ""; if (!out && p.sinkZ != null) sunk(p, s); }
      if (out) continue;
      const lv = Math.round(Math.max(0, qx * LIGHT[0] + qy * LIGHT[1] + qz * LIGHT[2]) * (1 - .6 * Math.max(0, qz)) * LV);
      // (seen steeply it wears its flat colour, squarely its gradient, and
      // between the two the gradient drawn toward the flat one, in eighths,
      // so that it never changes from one to the other at once)
      const g = smooth((f - .4) / .2), gq = Math.round(g * 8);
      const bg = gq >= 8 ? PSHADES[lv] : gq <= 0 ? PFLAT[lv] : pmix(lv, gq);
      if (bg !== s.bg) { s.bg = bg; s.el.style.background = bg; }
    }
  }

  // Where a pose puts things on the screen, around the scene's centre — the
  // same sums the browser does, perspective included.
  function projector(Q, s, y, G) {
    const d = W * PERSP, oy = -.04 * H;
    const m = new DOMMatrix().translateSelf(0, y, 0);
    if (G) m.multiplySelf(G);
    m.rotateAxisAngleSelf(1, 0, 0, Q.rx).rotateAxisAngleSelf(0, 1, 0, Q.ry).rotateAxisAngleSelf(0, 0, 1, Q.rz).scaleSelf(s, s, s);
    return (x, yy, z) => { const q = m.transformPoint(new DOMPoint(x, yy, z)), k = d / Math.max(1, d - q.z); return [q.x * k, oy + (q.y - oy) * k]; };
  }
  function corners(rect, L) {
    const [zx, zy, zw, zh] = rect;
    const x0 = (zx / FW - .5) * W, x1 = x0 + (zw / FW) * W, yb0 = ((zy + zh) / FH - .5) * H, hh = (zh / FH) * H;
    const t = (L[2] || 0) * D, z0 = DEP / 2 + .6 + L[1] * W, yb = yb0 + (L[3] || 0) * H, yt = yb - hh * Math.cos(t), zt = z0 - hh * Math.sin(t);
    return [[x0, yb, z0], [x1, yb, z0], [x1, yt, zt], [x0, yt, zt]];
  }
  const lifted = (Q) => Object.entries({ ...(Q.lift || {}), ...(Q.brief || {}) });
  // (G: the hand's turn, if any — then the plates are home, and only the slab counts)
  function bounds(Q, s, y, G) {
    const pr = projector(Q, s, y, G), b = { l: 1e9, r: -1e9, t: 1e9, b: -1e9 };
    const add = ([X, Y]) => { b.l = Math.min(b.l, X); b.r = Math.max(b.r, X); b.t = Math.min(b.t, Y); b.b = Math.max(b.b, Y); };
    for (const z of [DEP / 2, -DEP / 2]) for (const [x, yy] of [[-W / 2, -H / 2], [W / 2, -H / 2], [W / 2, H / 2], [-W / 2, H / 2]]) add(pr(x, yy, z));
    if (!G) for (const [k, L] of lifted(Q)) for (const c of corners(ZONES[k], L)) add(pr(...c));
    return b;
  }
  // the room it has: between the name and the features, and the page's width
  function room() {
    const st = stage.getBoundingClientRect(), sc = scene.getBoundingClientRect();
    const cx = sc.left + sc.width / 2, cy = sc.top + sc.height / 2;
    const vw = document.documentElement.clientWidth, m = vw < 700 ? 4 : 14, bob = Math.max(3, W * .011);
    return { l: m - cx, r: vw - m - cx, t: st.top + bob - cy, b: st.bottom - bob - cy };
  }
  // the room the exploded view has: the whole screen, once the name and the
  // tabs have gone — where the hero is held (a wide screen) around the scene
  // as it is held; where it is not (a phone), a screen's height about it
  // (the screen's height as kept: a phone's bars coming and going are not a
  // new screen — see resized)
  let keptH = window.innerHeight, keptW = document.documentElement.clientWidth;
  function roomX() {
    const sc = scene.getBoundingClientRect(), vw = document.documentElement.clientWidth, vh = keptH || window.innerHeight, m = vw < 700 ? 8 : Math.max(40, vw * .05);
    const cx = sc.left + sc.width / 2;
    if (!fitted()) { const hr = stage.closest(".hero").getBoundingClientRect(), cy = sc.top - hr.top + sc.height / 2; return { l: m - cx, r: vw - m - cx, t: vh * .08 - cy, b: vh * .94 - cy }; }
    return { l: m - cx, r: vw - m - cx, t: -(vh * .46), b: vh * .4 };
  }
  // A pose grows as far as it asks and no further than the room allows, and
  // is centred in it — lifted plates included.
  function fitPose(Q, R) {
    let s = Q.s, y = 0;
    for (let n = 0; n < 6; n++) {
      const b = bounds(Q, s, y);
      s = Math.min(Q.s, s * Math.min(R.r / b.r, R.l / b.l, (R.b - R.t) / (b.b - b.t)));
      const c = bounds(Q, s, y);
      y += (R.t + R.b) / 2 - (c.t + c.b) / 2;
    }
    return { s, y };
  }
  function measure() {
    W = scene.clientWidth || 1; H = scene.clientHeight || 1; DEP = Math.max(6, W * .024);
    // twice the pixels; on a retina screen, which already has two, 1.5x is
    // enough and keeps the graphics memory reasonable
    K = (window.devicePixelRatio || 1) >= 2 ? 1.5 : 2;
    thing.style.inset = `${(-(K - 1) / 2) * 100}%`;
    // a phone, or an upright tablet: the stage is at least as tall as the
    // tallest pose needs at the full width, and takes whatever more the
    // hero's screen leaves it (the style's), the object centred in it
    if (fitted()) {
      const R0 = room(), bob = Math.max(3, W * .011);
      const need = Math.max(...fits().map((Q) => { const f = fitPose(Q, { ...R0, t: -4 * H, b: 4 * H }), b = bounds(Q, f.s, f.y); return b.b - b.t; }));
      const h = Math.ceil(need + 2 * bob + 16);
      if (Math.abs((parseFloat(stage.style.minHeight) || 0) - h) > 1) stage.style.minHeight = `${h}px`;
    } else if (stage.style.minHeight) stage.style.minHeight = "";
    rad = Math.max(4, W * RADIUS);
    // (the rims' light in finer steps where the slab is drawn larger; made
    // again, every plane is shaded again)
    if (shades(fitted() ? 80 : 160)) { Mwas = null; rim.forEach((s) => { s.lv = -1; }); PHOTO.forEach((p) => { p.shL = -1; p.rim.forEach((s) => { s.bg = ""; }); }); }
    thing.style.setProperty("--k", `${K}`);
    thing.style.setProperty("--w", `${W * K}px`);
    thing.style.setProperty("--h", `${H * K}px`);
    thing.style.setProperty("--depth", `${DEP * K}px`);
    thing.style.setProperty("--half", `${(DEP * K) / 2}px`);
    thing.style.setProperty("--r", `${rad * K}px`);
    // a plate's corners: the slab's rounding, brought down to its size; and
    // the clear margin its face is drawn in (two of the scene's pixels)
    prad = Math.max(2.5, W * PRADIUS);
    thing.style.setProperty("--pr", `${(prad * K).toFixed(2)}px`);
    thing.style.setProperty("--aa", `${2 * K}px`);
    buildRim();
    buildPlateRims();
    scene.style.perspective = `${W * PERSP}px`;
    const R = room();
    ROOM = R;
    FIT = fits().map((Q) => fitPose(Q, R));
    EXS = shapeOf(EXPLODE);
    FITX = fitPose(EXS, roomX());
    // how many screen pixels a frame unit takes, for the face and for each
    // plate at its highest — which picks the size of photograph each wears
    const dpr = Math.min(3, window.devicePixelRatio || 1), need = {}, dimsWas = JSON.stringify(cvDims);
    let face = 0;
    POSES.concat([POSES[2].rest]).forEach((Q0, i) => {
      const Q = i === REST ? Q0 : shapeOf(Q0), f = fitPose(Q, R), pr = projector(Q, f.s, f.y);
      const span = (c, w) => Math.max(Math.hypot(c[1][0] - c[0][0], c[1][1] - c[0][1]), Math.hypot(c[2][0] - c[3][0], c[2][1] - c[3][1])) / w;
      const fc = corners([0, 0, FW, FH], [0, -.6 / W]).map((c) => pr(...c));
      face = Math.max(face, span(fc, FW));
      // the face's size in screen pixels, across and (foreshortened) down,
      // for the picture drawn on a small screen
      const mean = (a, b, c, d) => (Math.hypot(b[0] - a[0], b[1] - a[1]) + Math.hypot(d[0] - c[0], d[1] - c[1])) / 2;
      cvDims[i] = [Math.min(2400, Math.round(mean(fc[0], fc[1], fc[3], fc[2]) * dpr)), Math.min(1484, Math.round(mean(fc[0], fc[3], fc[1], fc[2]) * dpr))];
      for (const [k, L] of lifted(Q)) need[k] = Math.max(need[k] || 0, span(corners(ZONES[k], L).map((c) => pr(...c)), ZONES[k][2]));
    });
    // a face is rasterised at its layout size, K times the scene's: the
    // photographs are at least that large, so the extra pixels are real ones
    // (on a small screen the face is drawn to its screen size instead, and
    // the plates wear the size the screen needs, so no second set is fetched)
    const was = still;
    still = !reduce && (uiFailed || phone() || (face * FW) / 1100 < .55);
    const laid = still ? 0 : (K * W) / FW;
    plates.forEach((p) => { p.sc = pickPlate(Math.max(need[p.key] || face, laid) * dpr); });
    if (still && !was) { faceK = state; liveSync = false; }
    if (!still && was && uiWin && mode === "plates" && liveState !== state) liveSummon(state);
    if (!still) loadUI();
    // (drawn from the smallest photograph that holds enough for every pose)
    const big = Math.max(...cvDims.map(([cw, ch]) => Math.max(cw / FW, ch / FH)));
    faceSc = still ? SCALES.find((sc) => sc >= big) || SCALES[SCALES.length - 1] : pickScale(Math.max(face, laid) * dpr);
    faceSrc = IMG(faceK, faceSc);
    // (the face drawn again only if the size it is drawn at has changed)
    if (JSON.stringify(cvDims) !== dimsWas) cvKey = "";
    if (still) STATES.forEach((st, k) => want(IMG(k, faceSc)));
    // the first photograph goes straight on; a later, sharper one once it is in
    if (!front.dataset.src) { front.style.backgroundImage = `url("${faceSrc}")`; front.dataset.src = faceSrc; }
    else want(faceSrc);
    dirty = true;
    placeProg();
    if (reduce) return;
    PHOTO.forEach((p) => want(PIMG(p.key, 0, p.sc)));
    if (later) wantAll();
  }
  let later = false;
  const wantAll = () => PHOTO.forEach((p) => STATES.forEach((s, k) => want(PIMG(p.key, k, p.sc))));
  if (!reduce) addEventListener("load", () => setTimeout(() => { later = true; wantAll(); }, 200));
  function dress() {
    if (!dirty) return;
    dirty = false;
    for (const p of PHOTO) STATES.forEach((s, k) => {
      const src = got.get(PIMG(p.key, k, p.sc));
      if (src && p.url[k] !== src) { p.layers[k].style.backgroundImage = `url("${src}")`; p.url[k] = src; }
    });
    const f = got.get(faceSrc);
    if (f && front.dataset.src !== f && front.dataset.src !== faceSrc) { front.style.backgroundImage = `url("${f}")`; front.dataset.src = f; }
  }

  // ---- how it moves ----------------------------------------------------------
  // A pose is reached by an eased glide that a spring follows, so it leaves
  // slowly, arrives slowly and settles with the smallest give; it shrinks
  // early and grows late, so no corner swings wider than either pose.
  const KEYS = ["rx", "ry", "rz", "y", "s"];
  const poseOf = (i) => { const Q = i === REST ? POSES[2].rest : shapeOf(table()[i]); return { rx: Q.rx, ry: Q.ry, rz: Q.rz, s: FIT[i].s, y: FIT[i].y }; };
  let cur = null, tgt = null, tw = null;
  const vel = { rx: 0, ry: 0, rz: 0, y: 0, s: 0 };
  function goTo(p, dur) { tw = { from: { ...tgt }, to: p, t: clock, dur }; }
  // the entrance: turned away, a little low and small, still — refitted to
  // the room each time it changes until the slab is first seen
  function enter() {
    const E = poseOf(0);
    cur = { ...E, ry: E.ry - 48, y: E.y + .05 * H, s: E.s * .9 };
    tgt = { ...cur };
    KEYS.forEach((k) => { vel[k] = 0; });
  }
  // a plate is lighter: a spring alone
  function spring(o, t, dt, w, z) {
    const n = Math.max(1, Math.ceil(dt / (1 / 120))), h = dt / n;
    for (let k = 0; k < n; k++) { o.v += (w * w * (t - o.x) - 2 * z * w * o.v) * h; o.x += o.v * h; }
  }

  let state = 0;              // the preset the slab is showing
  let active = 0, poseAt = 0, clock = 0, sT = 0, sPrev = -1, tabClock = 0, holdUntil = 0, gateAt = null, run = {};
  const show = (p, k) => { if (p.shown === k) return; p.shown = k; p.layers.forEach((b, j) => b.classList.toggle("on", j === k)); };
  function select(i, how) {
    if (how !== "init" && i === active) { if (how === "user") holdUntil = Infinity; return; }
    leave();
    aimWas = how === "init" ? i : aim; aim = i;
    active = i; poseAt = clock + (how === "init" ? 900 : 0);
    sT = 0; sPrev = -1; tabClock = 0; gateAt = null; run = {};
    tabs.forEach((t, j) => { t.setAttribute("aria-selected", String(j === i)); t.tabIndex = j === i ? 0 : -1; });
    stage.setAttribute("aria-labelledby", tabs[i].id);
    scene.setAttribute("aria-label", mode === "plates" && !reduce ? LABELS[i] : `The halo interface — ${NAMES[i]}`);
    if (how === "user") holdUntil = Infinity;   // chosen by hand, it stays chosen
    placeProg();
    plates.forEach((p) => {
      const L = mode === "plates" && !reduce && shapeOf(POSES[i]).lift[p.key];
      // SUMMON's plates, if still in view, stay solid until its first press
      p.hold = i === 1 && SUMMONED.includes(p) && p.op > 0 ? clock + 2600 : 0;
      // and it rises showing the preset the slab is going to, never the last
      if (!SUMMONED.includes(p)) show(p, still ? faceK : (liveWant >= 0 ? liveWant : state));
      // the effects land right to left; what the new pose lifts waits until
      // everything else is down
      p.queue = L ? [{ gated: true, base: POSES[i].at, rel: L[0], lift: L[1], tilt: L[2] || 0, drift: L[3] || 0 }] : [{ at: clock + (p.fx >= 0 ? (4 - p.fx) * 70 : 0), lift: 0, tilt: 0 }];
    });
    Object.entries(dims).forEach(([k, e]) => e.classList.toggle("on", reduce && !LIT[i].includes(k)));
    if (reduce && tgt) { Object.assign(cur, poseOf(i)); Object.assign(tgt, cur); }
    else if (how !== "init" && tgt) goTo(poseOf(i), 1250);
  }
  // leaving a feature half-played puts the instrument back as it was
  function leave() {
    if (run.sw && !run.done) {
      if (active === 0) mv("blend", run.from, true);
      if (active === 2) FXIDS.forEach((id, j) => mv(id, run.from[j], true));
    }
    if (active === 1 && run.pressed) cutSummon();
  }

  // ---- the hairline above the active tab ----------------------------------------
  // It fills while the pose is held (the time until the next one comes
  // round), stands still while the tabs are paused, and moves on with the
  // tab. Chosen by hand, the tab stays, and its hairline is simply drawn.
  const rail = $(".rail"), tprog = $(".tprog"), tfill = tprog.querySelector("b");
  let progCss = "";
  function placeProg() {
    const t = tabs[active];
    if (!t || !rail.clientWidth) return;
    const rr = rail.getBoundingClientRect(), tr = t.getBoundingClientRect();
    let x = tr.left - rr.left, w = tr.width;
    if (phone()) { const r2 = t.querySelector(".t").getBoundingClientRect(); x = r2.left - rr.left; w = r2.width; }
    else { const cs = getComputedStyle(t), pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0; x += pl; w -= pl + pr; }
    tprog.style.width = `${Math.max(0, w).toFixed(1)}px`;
    tprog.style.transform = `translate(${x.toFixed(1)}px, ${(tr.top - rr.top).toFixed(1)}px)`;
  }
  function fillProg() {
    const f = reduce || holdUntil === Infinity ? 1 : clamp01(tabClock / DWELL[active]);
    const css = `scaleX(${f.toFixed(3)})`;
    if (css !== progCss) { tfill.style.transform = css; progCss = css; }
  }

  // ---- the instrument, told what to do --------------------------------------
  // The frame's own controls, driven through the hooks it keeps for pages that
  // film it; every value it takes is heard back, so a sweep starts from where
  // the control really is and returns there exactly.
  let uiWin = null, uiDoc = null, uiPaused = false, liveOn = false, liveSync = true, liveShown = false, liveState = -1, liveWant = -1, liveSeenAt = 0, pressedAt = 0, tries = 0, uiAt = -1, origSummon = null;
  const known = { blend: .5, haloAmount: .3, grainAmount: .2, ruinAmount: .1, ghostAmount: .1, spaceAmount: .4 };
  function listen(win) {
    const be = win.__JUCE__ && win.__JUCE__.backend;
    if (!be) return;
    Object.keys(known).forEach((id) => be.addEventListener(`__juce__slider${id}`, (p) => { if (p && p.eventType === "valueChanged") known[id] = +p.value; }));
  }
  const mv = (id, v, force) => { if (!uiWin || (!force && Math.abs(known[id] - v) < .002)) return; try { uiWin.__haloDirect.move(id, v); known[id] = v; } catch (err) {} };
  const from = (id) => (mode === "plates" && liveState === state ? STATES[state].v[id] : known[id]);
  const liveOk = () => !!uiWin && liveOn && liveSync && !still && (mode === "bare" || (liveState === state && liveWant === state));
  const canSummon = () => {
    const k = (state + 1) % STATES.length;
    return mode === "plates" && (still ? imgs.has(IMG(k, faceSc)) : liveOk()) && SUMMONED.every((p) => p.url[k]);
  };
  // On a small screen: the face drawn on a canvas exactly as many pixels as
  // it covers, across and down, so that the compositor never has to shrink
  // it (which it does without smoothing, and small lettering breaks up).
  // While the slab moves between two poses, it is drawn for the smaller of
  // the two.
  const cv = document.createElement("canvas");
  cv.className = "facecv";
  // (where WebKit draws the page, in the face, under all it holds: see the style)
  const ua = navigator.userAgent;
  const flatFace = /AppleWebKit/.test(ua) && !/(Chrome|Chromium|Edg|OPR|Android)\//.test(ua);
  if (flatFace) { front.classList.add("flat"); front.insertBefore(cv, front.firstChild); }
  else thing.insertBefore(cv, thing.firstChild);
  function drawFace() {
    const want2 = still && !reduce;
    let ok = false;
    if (want2) {
      const a = cvDims[aim], b = cvDims[tw ? aimWas : aim], cw = Math.min(a[0], b[0]), ch = Math.min(a[1], b[1]);
      const im = imgs.get(IMG(faceK, faceSc)), key = `${faceK}|${faceSc}|${cw}x${ch}|${W}x${H}`;
      if (im && key !== cvKey) {
        try {
          if (cv.width !== cw) cv.width = cw;
          if (cv.height !== ch) cv.height = ch;
          const x = cv.getContext("2d");
          x.setTransform(cw / W, 0, 0, ch / H, 0, 0);
          x.clearRect(0, 0, W, H);
          x.beginPath();
          if (x.roundRect) x.roundRect(0, 0, W, H, rad); else x.rect(0, 0, W, H);
          x.save(); x.clip();
          x.fillStyle = "#26282f"; x.fillRect(0, 0, W, H);
          x.imageSmoothingEnabled = true; x.imageSmoothingQuality = "high";
          x.drawImage(im, 0, 0, W, H);
          x.restore();
          cvKey = key;
        } catch (err) { cvKey = ""; }
      }
      ok = !!cvKey && cvKey.startsWith(`${faceK}|`);
    }
    if (ok !== cvOn) { cvOn = ok; cv.classList.toggle("on", ok); front.classList.toggle("cv", ok); }
  }
  // the photograph on the face, turned to another preset at once
  function faceTo(k) {
    faceK = k; faceSrc = IMG(k, faceSc);
    const f = got.get(faceSrc);
    if (f) { front.style.backgroundImage = `url("${f}")`; front.dataset.src = f; } else { want(faceSrc); dirty = true; }
  }

  function pauseUI(p) {
    if (!uiDoc || p === uiPaused) return;
    uiPaused = p;
    uiDoc.dispatchEvent(new Event("visibilitychange"));
  }
  function liveSummon(k) {
    liveWant = k;
    if (!uiWin) return;
    try { uiWin.__nextSeed = STATES[k].seed; uiWin.__haloSummon(); pressedAt = clock; liveSeenAt = 0; tries++; } catch (err) { bare(true); }
  }
  // what the interface reads and where its parts sit, as it was photographed
  function fingerprint(d) {
    const q = (s) => [...d.querySelectorAll(s)].map((e) => e.textContent).join("|");
    const t = [q("#preset-name"), q("#preset-tags"), q("#summon-mood"), q("#summon-matter"), q(".sources"), q("#signature")].join("#").replace(/\s+/g, " ").trim();
    let h = 5381;
    for (let i = 0; i < t.length; i++) h = (Math.imul(h, 33) ^ t.charCodeAt(i)) >>> 0;
    return h.toString(36) + "." + t.length;
  }
  function inPlace(d) {
    try {
      const body = d.body.getBoundingClientRect(), k = FW / body.width;
      return ANCHORS.every(([sel, want]) => {
        const e = d.querySelector(sel); if (!e) return false;
        const r = e.getBoundingClientRect(), got = [(r.left - body.left) * k, (r.top - body.top) * k, r.width * k, r.height * k];
        return want.every((v, i) => Math.abs(got[i] - v) < 2.5);
      });
    } catch (err) { return false; }
  }
  // follows the running interface into the preset it was asked for. A press
  // that did not take is pressed once more; an interface that names the
  // preset right but reads differently, or has its parts elsewhere, is not
  // the one photographed — and then the plates are given up.
  let fpAt = -1e9;
  function liveTick() {
    if (!uiWin || mode !== "plates" || liveWant < 0) return;
    // (read at most ten times a second: the whole of the interface's text,
    // read every frame, would cost a screen that runs fast a good part of
    // each frame)
    if (liveState !== liveWant && clock - fpAt >= 100) {
      fpAt = clock;
      let f = "", name = "";
      try { f = fingerprint(uiDoc); name = uiDoc.getElementById("preset-name").textContent.trim().toLowerCase(); } catch (err) {}
      if (f === STATES[liveWant].fp) {
        if (!liveSeenAt) liveSeenAt = clock;
        if (clock - liveSeenAt > 120) { if (inPlace(uiDoc)) { liveState = liveWant; tries = 0; want(IMG(liveState, faceSc)); } else bare(); }
      } else {
        liveSeenAt = 0;
        if (clock - pressedAt > 2400) { if (name === STATES[liveWant].name || tries >= 2) bare(); else liveSummon(liveWant); }
      }
    }
    if (liveState < 0 && uiAt >= 0 && clock - uiAt > 8000) bare();
  }
  // SUMMON in the frame invents its preset with Math.random; for the length
  // of one invocation it is handed a seeded one instead, and its filter
  // values, which it gives as 0..1 where the plug-in takes Hz, are put right.
  // Given up on the plates, SUMMON runs on its own randomness again, but its
  // filters are still put right.
  function seedSummon(w) {
    const rng = (a) => () => { a |= 0; a = a + 0x6D2B79F5 | 0; let t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; };
    const orig = origSummon = w.__haloNative.haloSummon;
    w.__haloNative.haloSummon = function () {
      const seeded = mode === "plates", seed = w.__nextSeed || 1, rnd = rng(seed), M = w.Math, R = M.random, ST = w.setTimeout;
      const ca = seeded ? 0 : R.call(M), cb = seeded ? 0 : R.call(M);
      if (seeded) M.random = rnd;
      w.setTimeout = function (fn, ms) {
        return ST.call(w, () => {
          const R2 = M.random;
          if (seeded) M.random = rnd;
          try { fn(); } finally { M.random = R2; }
          const f = seeded ? rng(seed * 7 + 3) : null, hz = (p) => Math.round(20 + 19980 * Math.pow(p, 4));
          try {
            w.__haloDirect.move("aCutoff", hz(.62 + (f ? f() : ca) * .38));
            w.__haloDirect.move("bCutoff", hz(.55 + (f ? f() : cb) * .45));
          } catch (err) {}
        }, ms);
      };
      try { return orig.apply(this, arguments); } finally { if (seeded) M.random = R; w.setTimeout = ST; }
    };
  }
  // no plates, then: the interface shown running, and the angles alone
  function bare(broken) {
    if (mode === "bare") return;
    mode = "bare";
    // only a SUMMON that threw goes back to the frame's own
    try { if (broken && origSummon && uiWin) uiWin.__haloNative.haloSummon = origSummon; } catch (err) {}
    plates.forEach((p) => { p.queue = [{ at: clock, lift: 0, tilt: 0 }]; p.hold = 0; });
    sT = 0; sPrev = -1; tabClock = 0; run = {};
    aimWas = aim; aim = active;
    scene.setAttribute("aria-label", `The halo interface — ${NAMES[active]}`);
    measure();
    if (tgt && !reduce) goTo(poseOf(active), 1250);
  }
  // (the interface draws itself at most sixty times a second: in the page,
  // each of its frames is the whole page composited again — its hundred and
  // more planes — and a faster screen would have that every few milliseconds
  // for a picture that changes no faster)
  function pace(win) {
    const raf0 = win.requestAnimationFrame.bind(win);
    let q = [], id = 0, pend = 0, at = -1e9;
    const flush = (t) => {
      pend = 0;
      if (!q.length) return;
      if (t - at < 15) { pend = raf0(flush); return; }
      at = t;
      const run = q; q = [];
      for (const [, cb] of run) { try { cb(t); } catch (err) { setTimeout(() => { throw err; }); } }
    };
    win.requestAnimationFrame = (cb) => { q.push([++id, cb]); if (!pend) pend = raf0(flush); return id; };
    win.cancelAnimationFrame = (n) => { q = q.filter((x) => x[0] !== n); };
  }
  function attach(win) {
    try { pace(win); } catch (err) {}
    try {
      const hidden = () => uiPaused || document.hidden;
      Object.defineProperty(win.document, "hidden", { configurable: true, get: hidden });
      Object.defineProperty(win.document, "visibilityState", { configurable: true, get: () => (hidden() ? "hidden" : "visible") });
      uiDoc = win.document;
      pauseUI(!seen.has(scene));
    } catch (err) {}
    try { listen(win); } catch (err) {}
    uiAt = clock;
    try { seedSummon(win); uiWin = win; setTimeout(() => liveSummon(state), 120); } catch (err) { uiWin = win; bare(true); }
  }
  // The running interface comes in as soon as the page has drawn, is put in
  // the first preset, and is shown only once it is in it; until then — and
  // under reduced motion, for good — the face is its photograph.
  function loadUI() {
    if (uiAsked || reduce) return;
    uiAsked = true;
    requestAnimationFrame(() => setTimeout(() => {
    const sc = document.createElement("script");
    sc.src = UI_SRC;
    sc.onerror = failUI;
    sc.onload = () => {
      const frameEl = document.querySelector("#halo-ui iframe");
      if (!frameEl) { failUI(); return; }
      let n = 0;
      const poll = () => {
        let win = null;
        try {
          const w = frameEl.contentWindow, d = w && w.document;
          if (d && d.readyState === "complete" && w.__haloSummon && w.__haloNative && w.__haloNative.haloSummon && w.__haloDirect && d.getElementById("summon") && d.getElementById("preset-name")) win = w;
        } catch (err) {}
        if (win) attach(win); else if (++n < 200) setTimeout(poll, 50); else failUI();
      };
      poll();
    };
    document.body.appendChild(sc);
    }, 30));
  }

  // the interface never came: the face stays its photograph, as on a phone,
  // and SUMMON turns the photographs
  function failUI() { if (uiFailed || uiWin) return; uiFailed = true; resized(); }

  function cutSummon() { SUMMONED.forEach((q) => show(q, state)); if (still) faceTo(state); run.pressed = false; }

  // ---- what each feature does while it is shown ------------------------------
  const SCRIPTS = [
    // sources: the cards stand off, and the blend between them travels,
    // live — to A, to B, to the middle, and back to where SUMMON left it
    (p, t) => {
      if (!run.sw && t > 1.1 && liveOk() && (mode === "bare" || (P.a.lift > .06 && P.b.lift > .02))) { run.sw = t; run.from = from("blend"); }
      if (run.sw) {
        const u = t - run.sw, f = run.from;
        if (u <= .9) mv("blend", lerp(f, .06, smooth(u / .9)));
        else if (u >= 1.1 && u <= 3.1) mv("blend", lerp(.06, .94, glide((u - 1.1) / 2)));
        else if (u >= 3.3 && u <= 4.1) mv("blend", lerp(.94, .5, smooth((u - 3.3) / .8)));
        else if (u >= 4.3 && u <= 4.8) mv("blend", lerp(.5, f, smooth((u - 4.3) / .5)));
        else if (u > 4.8 && !run.done) { mv("blend", f, true); run.done = t; }
      }
      if (!run.sw && !run.done && t > 4.4 && !liveOk()) run.done = t;
    },
    // summon: the orb rises off the face, grows, and is pressed — its orbit
    // swells and the satellite runs its lap — while the two cards rise, turn
    // into the new sounds at the top and drop back, and the name changes in
    // the face. Then all of it is the interface's own preset. Twice.
    (p, t) => {
      if (run.t0 === undefined) { if (t >= .95 && (mode === "bare" || gateAt !== null)) run.t0 = t; else return; }
      const u = t - run.t0, was = p - run.t0;
      for (const x of [.45, 3.6]) {
        if (mode === "bare") { if (at(was, u, x) && uiWin) try { uiWin.__haloSummon(); } catch (err) {} continue; }
        if (at(was, u, x - .35)) { SUMMONED.forEach((q) => { q.hold = Infinity; }); P.orb.queue = [{ at: clock, lift: POSES[1].brief.orb[1], tilt: 0 }]; }
        if (at(was, u, x)) {
          run.now = canSummon();
          if (run.now) {
            run.pressed = true; run.fp = ""; run.nm = null; P.orb.lapAt = clock;
            if (!still) try { run.fp = fingerprint(uiDoc); run.nm = uiDoc.getElementById("preset-name").textContent; } catch (err) {}
            state = (state + 1) % STATES.length;
            if (!still) liveSummon(state);
          }
        }
        if (run.now && at(was, u, x + .08)) SUMMONED.forEach((q, j) => { q.queue = [{ at: clock + j * 50, lift: POSES[1].brief[q.key][1], tilt: 0 }]; });
        // the plates turn into the new sounds in the very frame the interface
        // does (on a photograph, at the top of the lift) — the preset's name
        // read every frame, and the whole of its text only once that changes
        if (run.pressed && run.fp && u >= x && u < x + .85) {
          let nm = run.nm;
          try { nm = uiDoc.getElementById("preset-name").textContent; } catch (err) {}
          if (nm !== run.nm) { run.nm = nm; let f = run.fp; try { f = fingerprint(uiDoc); } catch (err) {} if (f !== run.fp) cutSummon(); }
        }
        if (run.pressed && at(was, u, x + (still ? .62 : .85))) cutSummon();
        if (at(was, u, x + .9)) SUMMONED.forEach((q, j) => { q.queue = [{ at: clock + j * 60, lift: 0, tilt: 0 }]; });
        if (at(was, u, x + 1.35) && x > 1) SUMMONED.forEach((q) => { q.hold = 0; });   // between the two presses they stay, in place
      }
      if (u > 5.2 && !run.done) run.done = t;
    },
    // effects: the modules stand up and settle back; once they have landed,
    // the slab comes up to the angle the whole interface reads at, and there
    // each drawing sweeps up and returns, live, to exactly where it was
    (p, t) => {
      if (mode === "plates" && !run.down) {
        if (!run.up && FX.every((q) => q.lift > .06)) run.up = t;
        if ((run.up && t - run.up > 1.7) || t > 5) { run.down = t; FX.forEach((q) => { q.queue = [{ at: clock + (4 - q.fx) * 70, lift: 0, tilt: 0 }]; }); }
      }
      if (mode === "plates" && run.down && !run.rest && FX.every((q) => q.tLift === 0 && q.lift < .01)) { run.rest = t; aimWas = aim; aim = REST; goTo(poseOf(REST), 1500); }
      // (the drawings wait until the slab is nearly there)
      const home = mode === "bare" ? t > 1.2 : run.down && FX.every((q) => q.op === 0) && run.rest && t - run.rest > 1.2;
      if (!run.sw && home && liveOk()) { run.sw = t; run.from = FXIDS.map(from); }
      if (run.sw) {
        const u = t - run.sw;
        FXIDS.forEach((id, j) => { const v = (u - j * .14) / 1.7; if (v >= 0 && v <= 1) mv(id, v < .4 ? lerp(run.from[j], .92, glide(v / .4)) : lerp(.92, run.from[j], glide((v - .4) / .6))); });
        if (u > 2.35 && !run.done) { FXIDS.forEach((id, j) => mv(id, run.from[j], true)); run.done = t; }
      }
      // (with nothing to sweep, the slab is held there as long)
      if (!run.sw && !run.done && home && !liveOk() && (mode === "bare" || t - run.rest > 3.5)) run.done = t;
    },
  ];

  // ---- a hand can turn it -------------------------------------------------
  // Dragged, it turns like a ball under the hand: sideways about the upright,
  // up and down about the level, on a slant both at once, and all the way
  // round either way — over the top, underneath, to the back. The turn is
  // kept as a quaternion laid outside the pose, so it never locks or flips.
  // Let go, it carries on at the speed it was let go, then comes back round,
  // the short way, to the pose it was showing.
  // A finger turns it only once its first move is sideways (from then on,
  // every way until it lifts); a first move up or down scrolls the page.
  const qmul = (a, b) => [a[0] * b[0] - a[1] * b[1] - a[2] * b[2] - a[3] * b[3], a[0] * b[1] + a[1] * b[0] + a[2] * b[3] - a[3] * b[2],
    a[0] * b[2] - a[1] * b[3] + a[2] * b[0] + a[3] * b[1], a[0] * b[3] + a[1] * b[2] - a[2] * b[1] + a[3] * b[0]];
  const qrot = (x, y, z, deg) => { const m = Math.hypot(x, y, z); if (!m || !deg) return [1, 0, 0, 0]; const h = (deg * D) / 2, k = Math.sin(h) / m; return [Math.cos(h), x * k, y * k, z * k]; };
  const qnorm = (q) => { const m = Math.hypot(...q) || 1; return q.map((v) => v / m); };
  let grip = [1, 0, 0, 0];      // the hand's turn, as it is drawn
  let gripT = [1, 0, 0, 0];     // where the hand has turned it: the turn drawn follows within a few ms
  let gripV = [0, 0, 0];        // its spin, about the room's axes, degrees a second
  let gripA = 0, gripN = [0, 1, 0], gripAV = 0, returning = false;
  let held = false, lastX = 0, lastY = 0, lastT = 0, releasedAt = -1e9, finger = null;
  // the turn as an angle (0..180) about an axis
  function readGrip() {
    if (grip[0] < 0) grip = grip.map((v) => -v);
    const sh = Math.hypot(grip[1], grip[2], grip[3]);
    gripA = (2 * Math.atan2(sh, grip[0])) / D;
    if (sh > 1e-7) gripN = [grip[1] / sh, grip[2] / sh, grip[3] / sh];
  }
  // a move of the hand: across turns about the upright, down turns the near
  // face down (about the level, backwards). (The screen may show several
  // frames between two moves of a mouse, or none: the hand's turn is where
  // the slab is going, and each frame draws it a little nearer — see frame;
  // and the speed it is let go at is the hand's over its last few moves,
  // not its last one.)
  function spin(dx, dy, dt) {
    const a = Math.hypot(dx, dy) * .32;
    if (!a) return;
    gripT = qnorm(qmul(qrot(-dy, dx, 0, a), gripT));
    const v = a / dt, m = Math.hypot(dx, dy), k = 1 - Math.exp(-dt / .045), vn = [(-dy / m) * v, (dx / m) * v, 0];
    gripV = gripV.map((c, i) => c + (vn[i] - c) * k);
  }
  function take(e, x, y) {
    held = true; returning = false; lastX = x; lastY = y; lastT = e.timeStamp; gripV = [0, 0, 0]; gripT = grip.slice();
    keep(performance.now());   // (wherever it rests, a hand wakes it)
    try { scene.setPointerCapture(e.pointerId); } catch (err) {}
    scene.classList.add("held");
  }
  scene.addEventListener("pointerdown", (e) => {
    if (e.button !== 0 || e.ctrlKey) return;   // right/middle click and macOS ctrl-click open menus, not a turn
    gripV = [0, 0, 0]; gripAV = 0;
    if (e.pointerType === "touch") { finger = { id: e.pointerId, x: e.clientX, y: e.clientY }; return; }
    take(e, e.clientX, e.clientY);
  });
  scene.addEventListener("pointermove", (e) => {
    if (finger && e.pointerId === finger.id) {
      const dx = e.clientX - finger.x, dy = e.clientY - finger.y;
      if (Math.hypot(dx, dy) < 7) return;
      const f = finger; finger = null;
      if (Math.abs(dx) > Math.abs(dy) * 1.2) take(e, f.x, f.y); else return;   // up or down: the page's
    }
    if (!held) return;
    // (every move the browser saw since the last event, where it keeps them)
    let evs = null;
    try { evs = e.getCoalescedEvents && e.getCoalescedEvents(); } catch (err) {}
    if (!evs || !evs.length) evs = [e];
    for (const m of evs) {
      const dx = m.clientX - lastX, dy = m.clientY - lastY, dt = Math.max(1, m.timeStamp - lastT) / 1000;
      spin(dx, dy, dt);
      lastX = m.clientX; lastY = m.clientY; lastT = Math.max(lastT, m.timeStamp);
    }
  });
  // once a finger has the slab, the page stays where it is
  scene.addEventListener("touchmove", (e) => { if (held && e.cancelable) e.preventDefault(); }, { passive: false });
  const letGo = (e) => { finger = null; if (!held) return; held = false; if (e.timeStamp - lastT > 80) gripV = [0, 0, 0]; releasedAt = clock; scene.classList.remove("held"); };
  scene.addEventListener("pointerup", letGo);
  // a touch that became a page scroll was never a turn
  scene.addEventListener("pointercancel", () => { finger = null; if (!held) return; held = false; gripV = [0, 0, 0]; releasedAt = -1e9; scene.classList.remove("held"); });

  // the room changes with the window, and when the type arrives and the
  // features reflow
  // held the other way (flat or tall) mid-pose, what is up goes where that
  // shape puts it
  let tallWas = null;
  function retarget() {
    const t = tall(), first = tallWas === null;
    if (t === tallWas) return;
    tallWas = t;
    if (first || mode !== "plates" || reduce) return;
    const lift = shapeOf(POSES[active]).lift;
    plates.forEach((p) => {
      const L = lift[p.key];
      if (!L) return;
      p.queue.forEach((q) => { if (q.gated) { q.lift = L[1]; q.tilt = L[2] || 0; q.drift = L[3] || 0; } });
      if (p.tLift > 0) { p.tLift = L[1]; p.tTilt = L[2] || 0; p.dk = (L[3] || 0) / L[1]; }
    });
  }
  function resized() {
    measure();
    retarget();
    if (!tgt) return;
    if (reduce) { Object.assign(cur, poseOf(active)); Object.assign(tgt, cur); }
    else if (t0 === null) enter();   // not yet seen: still waiting in the entrance pose
    else if (tw) tw.to = poseOf(aim);
    else Object.assign(tgt, poseOf(aim));
  }
  // (a phone's bars coming and going are not a new screen: nothing is
  // fitted again, nor the face drawn again — the same test the head's own
  // and the scroll's make; at the very top of the page, where it cannot be
  // seen, the slab follows them)
  const coarse = matchMedia("(pointer: coarse)");
  const bars = (vw, vh) => vw === keptW && Math.abs(vh - keptH) < 160 && (phone() || coarse.matches) && (window.scrollY || 0) > 2;
  addEventListener("resize", () => {
    const vw = document.documentElement.clientWidth, vh = window.innerHeight;
    if (bars(vw, vh)) return;
    keptW = vw; keptH = vh;
    resized();
  });
  if (window.ResizeObserver) new ResizeObserver(resized).observe(stage);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(resized);

  // ---- every frame, while it can be seen -----------------------------------
  // (prev: the last frame's time, or null for the first frame after a rest —
  // taken as one frame, as is a frame after a long pause: a frame's own time
  // and the clock read when the loop is woken are not the same clock)
  let t0 = null, prev = null, intro = reduce ? 1 : 0, faceOut = null, quietAt = -1e9, opCss = "", facePaintAt = -1e9, eyeWas = "", rimAt = -1e9, XR = 0;
  const FACE_MS = 40;
  function frame(now, first) {
    const dt = prev == null || now - prev > 250 ? 1 / 60 : Math.max(0, Math.min(.05, (now - prev) / 1000)); prev = now;
    if (!first && !seen.has(scene) && !TRAVEL.vis && !settling() && now > keepUntil) { pauseUI(true); return; }
    if (t0 === null && seen.has(scene)) { t0 = now; if (!reduce) goTo(poseOf(active), 1700); }
    clock += dt * 1000;
    const w = W, half = DEP / 2;
    if (t0 !== null && !reduce) intro = Math.min(1, intro + dt / .8);
    dress();

    liveTick();
    if (!liveOn && uiWin && liveState === state && liveWant === state) liveOn = true;
    // given up, the interface shows only once every plate is home and gone
    if (mode === "bare" && !liveOn && uiWin && plates.every((p) => p.op === 0)) liveOn = true;
    if (!liveSync && !still && uiWin && (mode === "bare" || (liveState === state && liveWant === state))) liveSync = true;
    const lv = liveOn && liveSync && !still;
    if (lv !== liveShown) { liveShown = lv; front.classList.toggle("live", lv); }
    // what lies under the plates: the running interface once it is shown,
    // until then (and on a small screen) its photograph
    const base = liveShown ? liveState : faceK;

    // the slab: an eased glide, followed by a spring (held where it is while
    // the scroll has it apart, so it comes apart from one pose, never from a
    // pose still on its way to the next)
    if (tw && !reduce && TRAVEL.x > .001) tw.t += dt * 1000;
    if (tw) {
      const u = Math.min(1, (clock - tw.t) / tw.dur), e = glide(u);
      const es = glide(tw.to.s < tw.from.s ? Math.min(1, u * 1.6) : Math.max(0, (u - .375) * 1.6));
      KEYS.forEach((k) => { tgt[k] = lerp(tw.from[k], tw.to[k], k === "s" ? es : e); });
      if (u >= 1) tw = null;
    }
    if (reduce) Object.assign(cur, tgt);
    else KEYS.forEach((k) => { vel[k] += (56 * (tgt[k] - cur[k]) - 2 * .72 * 7.5 * vel[k]) * dt; cur[k] += vel[k] * dt; });
    if (!held && (gripA > 0 || returning)) {
      if (clock - releasedAt < 700) {
        const v = Math.hypot(...gripV);
        if (v > .01) grip = qnorm(qmul(qrot(...gripV, v * dt), grip));
        gripV = gripV.map((c) => c * Math.pow(.04, dt));
        returning = false;
      } else {
        // home the short way: the angle springs to nothing about its own axis
        readGrip();
        if (!returning) { returning = true; gripAV = gripV[0] * gripN[0] + gripV[1] * gripN[1] + gripV[2] * gripN[2]; gripV = [0, 0, 0]; }
        const S = { x: gripA, v: gripAV };
        spring(S, 0, dt, 3.4, .86);
        gripAV = S.v;
        if (Math.abs(S.x) < .02 && Math.abs(S.v) < .05) { grip = [1, 0, 0, 0]; gripAV = 0; returning = false; }
        else grip = qrot(...gripN, S.x);
      }
    }
    // (held, the turn drawn eases onto the hand's, the short way round;
    // let go, the hand's is wherever the turn is)
    if (held) { const k = 1 - Math.exp(-dt / .022), d = grip.reduce((s, v, i) => s + v * gripT[i], 0) < 0 ? -1 : 1; grip = qnorm(grip.map((v, i) => v + (d * gripT[i] - v) * k)); }
    else gripT = grip.slice();
    readGrip();

    // the features take turns while it is seen, at rest, and nobody is choosing
    if (t0 !== null && !reduce && now > t0 && !TRAVEL.on && !(TRAVEL.x > .001)) {
      sT += dt;
      if (clock >= poseAt) SCRIPTS[active](sPrev, sT);
      sPrev = sT;
      const settled = !held && gripA < 3 && clock - releasedAt > 600 && !paused;
      if (settled) tabClock += dt;
      if (settled && clock >= holdUntil && ((run.done !== undefined && sT - run.done > .4 && tabClock >= DWELL[active]) || tabClock >= 14)) select((active + 1) % 3, "auto");
    }
    fillProg();

    drawFace();

    // what a pose lifts waits for the plates of the last one to be home
    if (gateAt === null) {
      const mine = { ...POSES[active].lift, ...(POSES[active].brief || {}) };
      if (plates.every((p) => mine[p.key] || (p.lift < .004 && Math.abs(p.tilt) < 1.5 && p.tLift === 0 && !p.queue.some((q) => q.lift > 0)))) gateAt = clock;
    }

    // a slow float between gestures (held apart by the scroll, less of it,
    // and none once it is on its way, so that the parts carried off it leave
    // from a slab only the scroll moves); and the pose, drawn toward the
    // exploded view as far as the scroll says
    const X = reduce ? 0 : TRAVEL.x, still2 = reduce ? 0 : Math.min(1, TRAVEL.dep * 4), k2 = reduce ? 0 : (1 - .7 * X) * (1 - still2), tn = TRAVEL.turn, dp = TRAVEL.dep;
    // (the slab's own turn into the exploded pose, where the page holds the
    // hero while it comes apart — a phone: never faster than 90 degrees a
    // second past its first few degrees, however far off its pose is, so that a flick has the parts come
    // apart in place from every tab and the slab finish its turn on its way;
    // held on a wide screen, and out of sight, it is where the scroll says)
    { const g = Math.max(1, Math.hypot(cur.rx - EXS.rx, cur.ry - EXS.ry, cur.rz - EXS.rz) - 4), k = 90 * dt / g; XR = reduce || TRAVEL.pin || !TRAVEL.vis ? X : X < XR ? Math.max(X, XR - k) : Math.min(X, XR + k); }
    const px0 = XR > 0 ? { rx: EXS.rx - 7 * tn + 18 * dp, ry: EXS.ry - 4 * tn, rz: EXS.rz + 8 * tn + 5 * dp, s: FITX.s * (1 - .3 * dp), y: FITX.y } : cur;
    const rx = lerp(cur.rx, px0.rx, XR) + k2 * 1.0 * Math.sin(clock / 2600), rz = lerp(cur.rz, px0.rz, XR) + k2 * .6 * Math.sin(clock / 3300), ry = lerp(cur.ry, px0.ry, XR);
    const cs = lerp(cur.s, px0.s, XR), cy0 = lerp(cur.y, px0.y, XR) + (reduce ? 0 : TRAVEL.ty);
    const bob = k2 * Math.sin(clock / 1900) * w * .006;
    // turned by hand, it is held a little smaller wherever the turn would
    // take it past the room (it may lean over the tabs, never over the name)
    const G = gripA > .05 ? new DOMMatrix().rotateAxisAngleSelf(...gripN, gripA) : null;
    let gs = 1;
    if (G) {
      const Q = { rx, ry, rz }, R = { ...ROOM, b: ROOM.b + 22 }, y0 = cy0;
      for (let n = 0; n < 2; n++) {
        const b = bounds(Q, cs * gs, y0, G);
        gs *= Math.min(1, R.r / b.r, R.l / b.l, (R.t - y0) / Math.min(-1, b.t - y0), (R.b - y0) / Math.max(1, b.b - y0));
      }
    }
    // (where the page holds the hero while it comes apart — a phone — the eye
    // rises over it as far as the page would have taken the hero up, so that
    // it is seen from as high as it always was: the eye is the scene's, and
    // every sum below that looks from it looks from there)
    const eye = reduce ? 0 : TRAVEL.eye || 0, ez = -.04 * H - eye, eyeCss = eye > .05 ? `50% calc(46% - ${eye.toFixed(1)}px)` : "";
    if (eyeCss !== eyeWas) { eyeWas = eyeCss; scene.style.perspectiveOrigin = eyeCss; }
    const s = (cs * gs) / K;
    const turn = G ? `rotate3d(${gripN.map((v) => v.toFixed(5)).join(", ")}, ${gripA.toFixed(3)}deg) ` : "";
    thing.style.transform = `translate3d(0, ${(cy0 + bob).toFixed(2)}px, 0) ${turn}rotateX(${rx.toFixed(3)}deg) rotateY(${ry.toFixed(3)}deg) rotateZ(${rz.toFixed(3)}deg) scale3d(${s.toFixed(5)}, ${s.toFixed(5)}, ${s.toFixed(5)})`;
    // (kept, so that a part carried off the slab starts exactly where it is)
    drawnT = { y: cy0 + bob, G, rx, ry, rz, s, ty: reduce ? 0 : TRAVEL.ty };
    const op = (1 - Math.pow(1 - intro, 3)).toFixed(3);
    if (op !== opCss) { opCss = op; scene.style.opacity = op; }
    const M = (G ? new DOMMatrix(G) : new DOMMatrix()).rotateAxisAngleSelf(1, 0, 0, rx).rotateAxisAngleSelf(0, 1, 0, ry).rotateAxisAngleSelf(0, 0, 1, rz);
    // (its rim is shaded again only once the slab has turned by a hair or
    // more: the shades come in steps, and a smaller turn changes none — and
    // the rims take the light at most sixty times a second: a light that
    // changes by a shade no eye can see gains nothing from a faster screen,
    // and each shade is a plane painted again)
    const rimOk = clock - rimAt >= 15;
    const turned = rimOk && (!Mwas || Math.abs(M.m11 - Mwas[0]) + Math.abs(M.m12 - Mwas[1]) + Math.abs(M.m13 - Mwas[2]) + Math.abs(M.m21 - Mwas[3]) + Math.abs(M.m22 - Mwas[4]) + Math.abs(M.m23 - Mwas[5]) + Math.abs(M.m31 - Mwas[6]) + Math.abs(M.m32 - Mwas[7]) + Math.abs(M.m33 - Mwas[8]) > .0015);
    if (turned) { Mwas = [M.m11, M.m12, M.m13, M.m21, M.m22, M.m23, M.m31, M.m32, M.m33]; shadeRim(M); rimAt = clock; }
    // Only the side of the slab that faces the eye is drawn at all (from a
    // point, a plane is wholly one or the other). A browser leaves the other
    // out by its backface-visibility; a WebKit that sorts the slab's planes
    // wrongly, or not at all, would draw the engraved back through the face.
    const nz = half * cs * gs, facing = M.m31 * (-M.m31 * nz) + M.m32 * (ez - (cy0 + bob) - M.m32 * nz) + M.m33 * (w * PERSP - M.m33 * nz) > 0;
    // (a plane of the rim turned well away from the eye is not drawn at all:
    // its back is never seen, and it is one plane fewer for the page to paint
    // and hand on each frame — it is still shaded, and comes back a good way
    // before it could be seen, wherever the slab is and however it turns)
    const rs = s, ry0 = cy0 + bob, ez0 = w * PERSP;
    for (const r of rim) {
      const qx = M.m11 * r.nx + M.m21 * r.ny, qy = M.m12 * r.nx + M.m22 * r.ny, qz = M.m13 * r.nx + M.m23 * r.ny;
      const vx = -rs * (M.m11 * r.cx + M.m21 * r.cy), vy = ez - ry0 - rs * (M.m12 * r.cx + M.m22 * r.cy), vz = ez0 - rs * (M.m13 * r.cx + M.m23 * r.cy);
      const cos = (qx * vx + qy * vy + qz * vz) / (Math.hypot(vx, vy, vz) || 1), away = r.away ? cos < -.15 : cos < -.2;
      if (away !== r.away) { r.away = away; r.el.style.visibility = away ? "hidden" : ""; }
    }
    if (facing !== faceOut) { faceOut = facing; front.style.visibility = facing ? "" : "hidden"; backFace.style.visibility = facing ? "hidden" : ""; }

    // (what is painted in the face — Chrome: the plates' shadows, its dim and
    // its veil — while the scroll has the slab apart: in fine steps, but
    // painted again at most every FACE_MS, all of it at once — each is the
    // face drawn again, a great many pixels, and a fast screen draws a frame
    // in a few milliseconds — or at once when a step would be too big to
    // wait for it; where they are layers of their own — WebKit — as they
    // are, every frame)
    const paintOk = flatFace || X <= .001 || clock - facePaintAt >= FACE_MS;
    let painted = false;
    const facePend = [];

    // the plates
    const grabbed = held || gripA > 24;
    for (const p of plates) {
      while (p.queue.length) {
        const q = p.queue[0], when = q.gated ? (gateAt === null ? Infinity : Math.max(poseAt + q.base * 1000, gateAt + 100) + q.rel * 1000) : q.at;
        if (when > clock) break;
        p.queue.shift(); p.tLift = q.lift; p.tTilt = q.tilt;
        // (a drift goes with the lift, and comes home with it)
        if (q.lift > 0) p.dk = (q.drift || 0) / q.lift;
      }
      // (the scroll's share of it: its exploded lift, parallel to its socket —
      // laid over what the tab's own spring has, never through it, so that
      // the part is exactly as far along as the slab; a hand on the slab
      // still sends it home, as it always has)
      const XL = (EXS.lift || EXPLODE.lift)[p.key];
      spring(p.gk, grabbed ? 0 : 1, dt, 4.4, .72);
      const xs = reduce ? 0 : (TRAVEL.px[p.key] || 0) * clamp01(p.gk.x);
      // busy until it has come to rest, not merely crossed its resting place
      const busy = xs > .001 || p.tLift > 0 || p.tTilt !== 0 || p.queue.some((q) => q.lift > 0) || Math.abs(p.lift) > .0015 || Math.abs(p.tilt) > .3 || Math.abs(p.lv) > .004 || Math.abs(p.tv) > 1.5;
      // a plate at rest simply follows what is under it — even while solid,
      // since it lies exactly on it (SUMMON's run ahead of the interface on
      // purpose, until they are let go)
      if (!busy && base >= 0 && p.shown !== base && (p.op === 0 || (!SUMMONED.includes(p) && clock >= p.hold))) show(p, base);
      // (given up, a plate still comes home before it goes)
      const need = !!p.url[p.shown] && (mode === "plates" ? busy || p.shown !== base || clock < p.hold : busy && p.op > 0);
      // (the orb takes the place of the face's own at once, and gives it back
      // at once: the two are the same drawing, half a pixel apart, and any
      // mix of them would show two rings)
      if (p.vec) p.op = need ? 1 : 0;
      else {
        p.op += ((need ? 1 : 0) - p.op) * Math.min(1, dt * 13);
        // (the face's own picture: solid before it has risen a hair — over
        // its first steps of the scroll, never on a clock)
        if (xs > 0) p.op = Math.max(p.op, clamp01(xs / .012));
        if (p.op < .004) p.op = 0; else if (p.op > .996) p.op = 1;
      }
      // it lifts once it is solid, and it comes down before it fades — and
      // while a hand has the slab turned, everything sits in its socket
      const solid = p.op > .9 && !grabbed;
      const lvS = { x: p.lift, v: p.lv }, tvS = { x: p.tilt, v: p.tv };
      spring(lvS, solid ? p.tLift : 0, dt, 4.4, .72); spring(tvS, solid ? p.tTilt : 0, dt, 4.4, .74);
      p.lift = lvS.x; p.lv = lvS.v; p.tilt = tvS.x; p.tv = tvS.v;
      if (p.op === 0) { p.lift = p.lv = p.tilt = p.tv = 0; }
      // (what is drawn: the tab's own lift and tilt, drawn toward the
      // exploded view's as far as the scroll has it)
      const L = lerp(p.lift, XL[1], xs), Lt = lerp(p.tilt, XL[2] || 0, xs);
      const float = reduce ? 0 : Math.sin(clock / 1450 + p.i * 1.9) * w * .0035 * Math.min(1, Math.max(0, L) / .03) * (1 - still2);
      // (no plate sinks below its spot as it lands, nor tips its far edge
      // into the face: it would pass through the face, and Safari draws two
      // planes that cross in broken pieces. It waits on the face — the same
      // picture — while its spring settles; and the orb, under the face,
      // would leave the face's own orb covered)
      p.z = half + .6 + Math.max(0, L) * w + float;
      // (the scroll draws the tilt out no faster than the slab turns — a flick
      // would flatten the effects in four frames — but the tab's own spring
      // keeps its pace)
      const tt = p.tTilt > 0 ? Lt : Math.min(0, Lt), lim = (90 + Math.abs(p.tv)) * dt;
      const tilt = p.tD == null || reduce || p.op === 0 ? tt : p.tD + Math.max(-lim, Math.min(lim, tt - p.tD));
      p.tD = tilt;
      // SUMMON's orb grows as it rises, and plays its press: the orbit swells
      // and the core with it, the satellite runs one lap, all in lavender
      let grow = "", gz = 1;
      if (p.vec) {
        // (and in the exploded view larger again, so it reads at its height)
        gz = 1 + .75 * clamp01(L / POSES[1].brief.orb[1]) + .5 * xs;
        grow = ` scale(${gz.toFixed(3)})`;
        const u = (clock - p.lapAt) / 900, on = u >= 0 && u < 1, sv = p.pf.firstChild;
        const lt = u >= 0 && u < 1.25; if (lt !== p.lapT) { p.lapT = lt; sv.classList.toggle("lapt", lt); }
        const e = on ? 1 - Math.pow(1 - u, 4) : 0, sw = on ? (u < .3 ? 1 - Math.pow(1 - u / .3, 3) : 1 - smooth((u - .3) / .7)) : 0;
        const lc = on ? `${sw.toFixed(3)}|${e.toFixed(3)}` : "";
        if (lc !== p.lapCss) {
          p.lapCss = lc;
          sv.parts.zoom.setAttribute("transform", `translate(8 8) scale(${(1 + .18 * sw).toFixed(4)}) translate(-8 -8)`);
          sv.parts.core.setAttribute("r", (2.2 + sw).toFixed(3));
          sv.parts.sat.setAttribute("transform", `rotate(${(360 * e).toFixed(2)} 8 8)`);
          sv.classList.toggle("lap", on);
        }
      }
      let dx = 0, dy = p.dk ? Math.max(0, p.lift) * p.dk * H * K * (1 - xs) : 0;
      // the orb rises toward the eye, over its own spot: what its height would
      // carry it across the screen is taken back along the face (most of it)
      // — but not in the exploded view, where it rises three times as high:
      // there it stands straight over its spot, clear above the sources'
      // corner, a satellite of the rest (taken back that far, it would sink
      // under A); and never more than a press's height is taken back
      if (p.vec && M.m33 > .2) { const zl = Math.min(Math.max(0, L), POSES[1].brief.orb[1]) * w * K * .85 * (1 - xs); dx = (zl * M.m13) / M.m33; dy += (zl * M.m23) / M.m33; }
      const css = `translate3d(${dx.toFixed(2)}px, ${dy.toFixed(2)}px, ${(p.z * K).toFixed(2)}px) rotateX(${tilt.toFixed(2)}deg)${grow}`;
      if (css !== p.css) { p.el.style.transform = css; p.css = css; }
      // its rim stands behind it as deep as it is thick — but never deeper
      // than the height it has risen to, so no plane of it is ever through
      // the face (under a hair of it, none at all)
      if (p.rim.length) {
        const room = ((p.z - half - .25) * K) / Math.max(.3, Math.cos(tilt * D)), d = Math.max(0, Math.min(p.ptL, room));
        // (in half pixels: each depth is every plane of the rim written again)
        const dk = d >= p.ptL - .05 ? "full" : d < .75 ? "none" : (Math.round(d * 2) / 2).toFixed(1);
        if (dk !== p.rimD) { p.rimD = dk; sinkRim(p, dk === "full" ? p.ptL : +dk || 0, dk === "none"); }
      }
      p.dx = dx; p.dy = dy;
      // (seen off the instrument, over the page, the orb wears the page's ink)
      if (p.vec) {
        const A = P.a, off = orbOff(M, cs * gs, cy0 + bob + eye, w, H, half, dx / K, dy / K, p.z, gz, A && !A.gone && A.op > 0 ? [(A.dx || 0) / K, (A.dy || 0) / K, A.z] : null);
        const ov = `${Math.round(off * 100)}%`;
        if (ov !== p.offCss) { p.offCss = ov; p.pf.firstChild.style.setProperty("--off", ov); }
      }
      // a part carried on to its chapter is no longer the slab's to draw
      const gone = TRAVEL.gone[p.key] > 0;
      if (gone !== !!p.gone) { p.gone = gone; p.el.style.visibility = gone ? "hidden" : ""; p.el.classList.toggle("gone", gone); }
      const op = p.op.toFixed(3);
      if (op !== p.opCss) { p.pf.style.opacity = op; p.opCss = op; }
      const up = p.op === 1 && (L > .0015 || Math.abs(tilt) > .3);
      if (up !== p.up) { p.el.classList.toggle("up", up); p.up = up; }
      // (the orb's spot is covered for as long as the orb is drawn, home or
      // not: it rises growing and toward the eye, and the face's own orb,
      // showing through beside it, would make two rings; its shadow still
      // comes and goes with its height. A socket is there within a hair of
      // its plate's rise — any later, and the face's own labels would show
      // through it, a few pixels under the plate's, a second row — and is
      // gone through the landing's overshoot, where the plate is under the
      // face. The sources' bare face, for a SUMMON press, comes in with their
      // height. Which of the two they leave (bw, 1 for the bare face) is
      // settled at once while neither shows; held up from one pose into the
      // other, they pass from one to the other as they go.)
      if (p.bare) {
        const want = active === 1 ? 1 : 0;
        if (p.bw !== want) {
          if (!(+p.sockCss >= .04) && !(+p.bareCss >= .04)) p.bw = want;
          else if (p.tLift > 0) { p.bw += (want - p.bw) * Math.min(1, dt * 6); if (Math.abs(want - p.bw) < .01) p.bw = want; }
        }
        const bo = ((gone ? 1 : Math.min(1, Math.max(0, L / .02, Math.abs(Lt) / 22))) * p.bw).toFixed(3);
        if (bo !== p.bareCss) { p.bare.style.opacity = bo; p.bareCss = bo; }
      }
      // (a plate carried off leaves its socket, or its bare face, whole at once:
      // the face's own picture of it must not show as a second card)
      const so = (p.vec ? p.op : (gone ? 1 : clamp01(Math.max(L / .004, -Lt / 4))) * (1 - p.bw)).toFixed(3);
      if (so !== p.sockCss) { p.sock.style.opacity = so; p.sockCss = so; }
      if (p.vec) {
        const sh = clamp01(L / .02).toFixed(3), sf = clamp01(L / POSES[1].brief.orb[1]).toFixed(2);
        if (sh + sf !== p.shCss) { p.sock.style.setProperty("--sh", sh); p.sock.style.setProperty("--so", sf); p.shCss = sh + sf; }
      }
      // a plate up: its rim takes the light as the plate and the slab stand,
      // and its shadow lies over its socket — tight and dark just above it,
      // wider, fainter and a little off the way the light falls higher up
      if (rimOk && p.up && p.rim.length && (turned || Math.abs(L - (p.shL ?? -1)) > .003 || Math.abs(tilt - (p.shT ?? -99)) > .4)) {
        p.shL = L; p.shT = tilt; rimAt = clock;
        // (where the plate stands in the room, and so the way from it to the eye)
        const sc = cs * gs, r = p.rect, q = M.transformPoint(new DOMPoint(((r[0] + r[2] / 2) / FW - .5) * w, ((r[1] + r[3] / 2) / FH - .5) * H, p.z));
        const vx = -q.x * sc, vy = ez - (cy0 + bob + q.y * sc), vz = w * PERSP - q.z * sc, vm = Math.hypot(vx, vy, vz) || 1;
        shadePlateRim(p, M, [vx / vm, vy / vm, vz / vm]);
      }
      if (p.shade) {
        const h = Math.max(0, L), u = smooth(h / .08);
        // (a part carried off takes its shadow along: the one here goes as it
        // leaves its socket, and none is left on the socket once it has gone)
        let ox = 0, oy = 0, vis = +so * (p.gone ? 1 - (TRAVEL.away[p.key] || 0) : 1);
        const lz = LIGHT[0] * M.m31 + LIGHT[1] * M.m32 + LIGHT[2] * M.m33;
        if (lz > .25 && h > 0) {
          const lx = LIGHT[0] * M.m11 + LIGHT[1] * M.m12 + LIGHT[2] * M.m13, ly = LIGHT[0] * M.m21 + LIGHT[1] * M.m22 + LIGHT[2] * M.m23, k = (-h * w * K * .2) / lz;
          ox = lx * k; oy = ly * k;
        }
        // (while the scroll has the slab apart, where its shadows are painted
        // in the face — Chrome — they move in fine steps, and no more often
        // than the face may be painted: see paintOk; where they are layers
        // of their own — WebKit, see the style — they move as they are)
        let n = 1 - u, f = u;
        if (X > .001 && !flatFace) { const st = (v, s) => Math.round(v / s) * s; n = st(n, 1 / 32); f = st(f, 1 / 32); vis = st(vis, 1 / 32); ox = st(ox, 2 * K); oy = st(oy, 2 * K); }
        n = n.toFixed(3); f = f.toFixed(3);
        const css = `${vis.toFixed(3)}|${n}|${f}|${ox.toFixed(1)}|${oy.toFixed(1)}`;
        if (css !== p.shadeCss) facePend.push([p, css, vis, n, f, ox, oy]);
      }
    }

    // the face further up steps back as the effects stand, and comes back as
    // they land
    let fxUp = 0;
    for (const q of FX) fxUp = Math.max(fxUp, (q.lift / .06) * q.op);
    const vo = (smooth(fxUp) * (1 - X)).toFixed(3);
    // (the face's dim: where it is a layer of its own, as it is; painted in
    // the face, in eightieths, and no more often than the face may be)
    const xq = flatFace ? 1000 : 80, xo = (Math.round(X * (1 - .6 * dp) * xq) / xq).toFixed(3);
    // (a step too big to wait for the face's next paint is painted at once,
    // all of it — but never on two frames running on a fast screen: each is
    // the whole face drawn again)
    const faceNow = paintOk || (clock - facePaintAt >= 12 && (facePend.some((q) => Math.abs(q[2] - (q[0].shVis ?? 0)) > 1 / 16) || Math.abs(+xo - (+xdimCss || 0)) > .03 || Math.abs(+vo - (+veilCss || 0)) > .03));
    if (faceNow) for (const [p, css, vis, n, f, ox, oy] of facePend) {
      p.shadeCss = css; p.shVis = vis; painted = true;
      const st = p.shade.style;
      st.opacity = vis; st.setProperty("--n", n); st.setProperty("--f", f);
      st.transform = `translate(${ox.toFixed(1)}px, ${oy.toFixed(1)}px)`;
    }
    if (vo !== veilCss && faceNow) { veil.style.opacity = vo; veilCss = vo; painted = true; }
    if (xo !== xdimCss && faceNow) { xdim.style.opacity = xo; xdimCss = xo; painted = true; }
    if (painted && !flatFace && X > .001) facePaintAt = clock;

    // the interface rests while its face is turned away or out of sight, and
    // from the page's first step off its top — it wakes only once the page
    // has been back at the top, still, for a moment
    if (TRAVEL.on || X > 0) quietAt = clock;
    pauseUI(still || M.m33 < 0 || !seen.has(scene) || clock - quietAt < 400);
    // (while the slab travels or is apart, the resting interface is hidden
    // behind its own photograph: paused, it is still counted, part by part,
    // in every frame's layers — and it is shown again once the slab is home)
    const uiOut = liveShown && mode !== "bare" && liveState >= 0 && liveState === liveWant && (TRAVEL.on || X > .001) && got.has(IMG(liveState, faceSc));
    if (uiOut !== uiOutWas) {
      uiOutWas = uiOut;
      if (uiOut) faceTo(liveState);
      uiHost.style.visibility = uiOut ? "hidden" : "";
    }
  }
  let uiOutWas = false;
  const uiHost = document.getElementById("halo-ui");

  // ---- the tabs: one of three, chosen by pointer, arrows, Home and End ------
  // They stop taking turns while a key or a pointer is among them.
  const tablist = $(".tabs");
  let focusIn = false, pointerIn = false, paused = false;
  const setPaused = () => { paused = focusIn || pointerIn; };
  tablist.addEventListener("focusin", () => { focusIn = true; setPaused(); });
  tablist.addEventListener("focusout", (e) => { if (!tablist.contains(e.relatedTarget)) { focusIn = false; setPaused(); } });
  rail.addEventListener("pointerenter", (e) => { if (e.pointerType === "mouse") { pointerIn = true; setPaused(); } });
  rail.addEventListener("pointerleave", () => { pointerIn = false; setPaused(); });
  tabs.forEach((t, i) => {
    t.addEventListener("click", () => select(i, "user"));
    t.addEventListener("keydown", (e) => {
      const n = e.key === "ArrowRight" ? (i + 1) % tabs.length : e.key === "ArrowLeft" ? (i + tabs.length - 1) % tabs.length : e.key === "Home" ? 0 : e.key === "End" ? tabs.length - 1 : -1;
      if (n < 0) return;
      e.preventDefault();
      tabs[n].focus();
      select(n, "user");
    });
  });

  // nothing moves while it can't be seen — where it is laid out (seen) or
  // where the scroll draws it (TRAVEL.vis); gone out of sight, it still runs
  // until its parts have come to rest (stopped half-way, a part would stay
  // lifted, rim and all, for nothing), and for a moment whenever the scroll
  // changes what it asks of it (keep)
  const seen = new Set();
  let running = false, keepUntil = 0, stepAt = -1;
  // One frame in one order, whichever loop comes to it first: what the
  // scroll asks of the slab (before), the slab, then what follows it as it
  // is drawn — the parts carried off it, the page (after); see the scroll
  function step(now) {
    if (now === stepAt) return;
    stepAt = now;
    const h = root.__slab;
    if (h.before) h.before(now);
    frame(now);
    if (h.after) h.after(now);
  }
  function loop(now) {
    // (on its way it has nothing of its own left to play — no float, and a
    // glide under way is held while the scroll has it apart, see frame — so
    // there, out of a hand, it rests too once the scroll has stopped asking
    // anything else of it: the scroll's keep, or a hand's take, wakes it)
    const quiet = !settling() && now > keepUntil, away = TRAVEL.dep >= .25 && !held && !returning && !(gripA > 0);
    if ((quiet && (away || (!seen.size && !TRAVEL.vis))) || document.hidden) { running = false; return; }
    step(now);
    requestAnimationFrame(loop);
  }
  const wake = () => { if (!running && (seen.size || TRAVEL.vis) && !document.hidden) { running = true; prev = null; requestAnimationFrame(loop); } };
  // (the scroll has changed what it asks: drawn in this very frame, and for
  // a moment after, seen or not)
  const keep = (now) => { keepUntil = Math.max(keepUntil, now + 750); if (!running && !document.hidden) { running = true; requestAnimationFrame(loop); } };
  const vio = new IntersectionObserver((es) => { es.forEach((e) => e.isIntersecting ? seen.add(e.target) : seen.delete(e.target)); if (!seen.has(scene)) pauseUI(true); wake(); }, { rootMargin: "25% 0px" });
  vio.observe(scene);
  document.addEventListener("visibilitychange", wake);

  // ---- what the scroll script is given ------------------------------------------
  // The travel state it writes; the matrix of a part as it is drawn now, from
  // its own layout pixels to the scene's centre (perspective aside); the rim
  // shading, for a part drawn elsewhere; and the few constants it needs.
  function plateM(key) {
    const p = P[key], L = drawnT;
    if (!p || !L) return null;
    const r = p.rect, pw = (r[2] / FW) * K * W, ph = (r[3] / FH) * K * H, ox = (r[0] / FW) * K * W, oy = (r[1] / FH) * K * H;
    const m = new DOMMatrix().translateSelf(0, L.y, 0);
    if (L.G) m.multiplySelf(L.G);
    m.rotateAxisAngleSelf(1, 0, 0, L.rx).rotateAxisAngleSelf(0, 1, 0, L.ry).rotateAxisAngleSelf(0, 0, 1, L.rz).scaleSelf(L.s, L.s, L.s);
    m.translateSelf(-K * W / 2 + ox + pw / 2, -K * H / 2 + oy + ph, 0).translateSelf(p.dx || 0, p.dy || 0, p.z * K).rotateAxisAngleSelf(1, 0, 0, p.tD ?? p.tilt).translateSelf(-pw / 2, -ph, 0);
    return { m, w: pw, h: ph, ty: L.ty || 0 };
  }
  function shadeRimAs(rimList, Rm, V, k) { shadePlateRim({ tilt: 0, rim: rimList }, Rm, V, k); }
  // (whether the slab, or either source on it, is still settling — its
  // springs catching up with the scroll — so a part carried off it must
  // still follow it)
  const settling = () => plates.some((p) => Math.abs(p.lv) > .0003 || Math.abs(p.tv) > .05 || Math.abs(p.gk.v) > .003) || KEYS.some((k) => Math.abs(vel[k]) > (k === "s" ? .0005 : k === "y" ? .05 : .02));
  // (how far, in degrees, the pose the slab holds is from the exploded one:
  // the scroll takes a pose further off more slowly, so it never turns faster)
  // (on a wide screen, from the pose it is settling to: the entrance's
  // turned-away pose would slow the whole hold)
  const poseGap = (pin) => { const p = pin && tw ? tw.to : cur; return p ? Math.hypot(p.rx - EXS.rx, p.ry - EXS.ry, p.rz - EXS.rz) : 0; };
  root.__slab = { T: TRAVEL, EXPLODE, P, plateM, shadeRimAs, settling, step, keep, poseGap, before: null, after: null, running: () => running, measure: () => resized(),
    dims: () => ({ W, H, K, persp: W * PERSP, still, fitted: fitted() }), orbArt, orbOff, LIGHT, SHADES, shadeOf, LV: () => LV, TUCK, PSHADES, PFLAT, PIMG, IMG, pickPlate, pickScale, ZONES, ORB_SOCK, FW, FH, RADIUS, PRADIUS, PTHICK, PERSP, state: () => state };

  measure();
  retarget();
  select(0, "init");
  // start in the entrance pose (unseen), coming round into the first one
  if (reduce) { cur = poseOf(0); tgt = { ...cur }; } else enter();
  frame(performance.now(), true);
})();

// ============================================================================
// The chapters: the interface filmed doing what the words say.
// ============================================================================
(() => {
  "use strict";
  const root = document.getElementById("ob");
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  // Each film is a real capture (media/v3, filmed from the shipped bundle;
  // a phone gets its own cut, re-laid so it reads at its size). A hairline
  // frame goes to the part the sentence is on and that phrase is underlined,
  // both read off the clip's own clock, a little before the change they
  // mark, so they arrive with it. A clip loads when it comes near, plays only
  // while it can be seen (on a phone, only the one most in view), and rests
  // while the tab is hidden. Under reduced motion no clip is fetched: the
  // film is its first frame, annotated.
  const small = matchMedia("(max-width: 700px)");
  // sizes and boxes in the clip's own units (the interface's css px; the
  // effects' in the clip's own pixels), a box's frame drawn "pad" outside it
  // on every side
  // The effects: drayki: "j'aimerais qu'ils soient centrés par rapport au
  // dessin de l'effet, et qu'ils prennent quasi toute la hauteur aussi,
  // pense à aligner les barres d'en bas avec" — each module's frame stands on
  // the middle of its drawing (halo's bars, grain's grains, ruin's wave,
  // ghost's echoes, space's rings: the middle of each, read off every frame
  // of the clip), all five the same width, as wide as the module's words
  // need with the same margin at their left (the words start the same
  // distance left of the drawing in all five), and all but the whole height
  // of the module, a few pixels in from its top and its foot. The line under
  // each is its frame's own width, on its middle.
  // (Halo's bars are fewer while its frame is on them, at 86, and stand a
  // little left of the middle they have at 22, 192.5: its frame is on the
  // bars as they stand then, 184.5, as nearly as the film's left edge
  // allows — and in a phone's cut, half the way, so that its line all but
  // lines up with ruin's under it.)
  // In the film's own pixels: [middle of the drawing, half the frame's
  // width, its top, its foot]. The film was filmed again at twice the size,
  // 3840 x 512 — the same box, moment and length — so it stays sharp on a
  // 2x screen, across the board or a fifth of it on a tile; its units stay
  // the 1920 x 256 ones.
  const FX_D = { src: HOB + "hob-v3-effects-2x.mp4", poster: HOB + "hob-v3-effects-2x-poster.webp", size: [1920, 256], cut: 16, frames: [[186.5, 182, 8, 248], [576, 182, 8, 248], [960, 182, 8, 248], [1345, 182, 8, 248], [1728, 182, 8, 248]] };
  const FX_CUES = [[0, 0, [0]], [1.1, 1, [1]], [3.7, 2, [2]], [6.3, 3, [3]], [8.9, 4, [4]], [11.5, 0, [0]]];
  const SHOTS = {
    sources: {
      d: { src: HOB + "hob-v3-sources.mp4", size: [779, 472], boxes: { a: [5, 3, 243, 149.5], b: [5, 263.7, 243, 149.5], blend: [5, 216, 769, 37] }, drop: [126, 360] },
      m: { src: HOB + "hob-v3-sources-m.mp4", size: [596, 486], boxes: { a: [9, 1, 243, 147], b: [9, 278, 243, 149], blend: [9, 206, 584, 67] }, drop: [130, 374] },
      // [clip time, part, phrases], each 0.4 s ahead of what it frames
      // A is the oscillator until 4.2 s, then pad glacier; B takes texture drown at 6.0 s; A is the oscillator again at 12.3 s
      cues: [[0, "a", [0]], [3.8, "a", [1]], [5.6, "b", [2]], [8.2, "blend", [3]], [11.9, "a", [0]]],
      drop: [5.3, 6.0, 6.5],   // a .wav comes in, lands as B changes, and goes
      still: [["a", [0]], ["b", [1]]],
    },
    summon: {
      d: { src: HOB + "hob-v3-summon.mp4", size: [779, 528], boxes: { orb: [6, 10, 34, 34], name: [48, 8, 244, 36], body: [5, 59, 769, 464] } },
      m: { src: HOB + "hob-v3-summon-m.mp4", size: [596, 546], boxes: { orb: [10, 10, 34, 34], name: [52, 8, 244, 36], body: [9, 59, 584, 482] } },
      cues: [[0, "orb", [0]], [1.15, "body", [1]], [5.66, "name", [2]], [9.6, "orb", [0]]],
      still: [["orb", [0]], ["name", [2]]],
    },
    // the effects across the board: the one film, the five side by side
    effects: { d: FX_D, cues: FX_CUES },
    // where the board is one column, each module is a tile of its own: its
    // cell is cut out of the film around its frame, "cut" pixels of the
    // film's own dark all round (where the film stops short, the same dark),
    // so every cell has the same margin and the frame sits in each as it sat
    // on the film. On a phone, from the phone's cut (two by two and one, the
    // modules a fifth larger).
    "effects-tiles": {
      tiles: true,
      d: FX_D,
      m: { src: HOB + "hob-v3-effects-m.mp4", poster: HOB + "hob-v3-effects-m-poster.webp", size: [1020, 1008], cut: 16, frames: [[259.5, 222, 46, 336], [758, 222, 46, 336], [263.5, 222, 363, 653], [758, 222, 363, 653], [511, 222, 681, 971]] },
      cues: FX_CUES,
    },
  };
  // (a cut given as frames is boxed by them exactly, with no margin)
  Object.values(SHOTS).forEach((s) => [s.d, s.m].forEach((v) => { if (v && v.frames) { v.boxes = v.frames.map(([c, hw, t, b]) => [c - hw, t, 2 * hw, b - t]); v.pad = 0; } }));
  // (the scroll lays each film in by the part its first words are about: see there)
  root.__films = SHOTS;
  // a film is measured as the page lays it out, never as the scroll happens
  // to be moving it (see "the scroll": what it has moved is put back for the
  // length of the measure)
  const bare = (el, fn) => (root.__bare ? root.__bare(el, fn) : fn());
  const variant = (p) => (small.matches && p.cfg.m) || p.cfg.d;
  const dpr = () => Math.max(1, devicePixelRatio || 1);
  const px = (v) => Math.round(v * dpr()) / dpr();
  // Where the clip's picture lies in the film's box, in the box's own pixels:
  // the box as the browser draws a playing film into it — laid out to the
  // fraction, then moved to start on a whole screen pixel, its size kept
  // (measured: fitted against the clip's own frame, to a tenth of a pixel)
  // — all of it when it is filled, or wherever object-fit puts it, centred.
  // [left, top, width, height]
  function picture(p) {
    const r = bare(p.el, () => p.el.getBoundingClientRect()), vw = p.video.videoWidth, vh = p.video.videoHeight;
    const L = px(r.left) - r.left, T = px(r.top) - r.top, bw = r.width, bh = r.height;
    let w = bw, h = bh;
    const fit = vw && vh ? getComputedStyle(p.video).objectFit : "fill";
    if (fit !== "fill") {
      let s = fit === "cover" ? Math.max(w / vw, h / vh) : fit === "none" ? 1 : Math.min(w / vw, h / vh);
      if (fit === "scale-down") s = Math.min(1, s);
      w = vw * s; h = vh * s;
    }
    return [L + (bw - w) / 2, T + (bh - h) / 2, w, h];
  }
  // a box of the clip, in the film's pixels: [x, y, x2, y2] (its margin the
  // same number of pixels on every side)
  function boxPx(p, b) {
    const v = variant(p), [ox, oy, w, h] = picture(p), kx = w / v.size[0], ky = h / v.size[1], m = (v.pad || 0) * Math.min(kx, ky);
    return [ox + b[0] * kx - m, oy + b[1] * ky - m, ox + (b[0] + b[2]) * kx + m, oy + (b[1] + b[3]) * ky + m];
  }
  // (and its edges put on the screen's own pixels, wherever the film lies,
  // so that the frame's hairlines are drawn sharp)
  function snapPx(p, b) {
    const q = boxPx(p, b), o = bare(p.el, () => p.el.getBoundingClientRect()), sx = (v) => px(o.left + v) - o.left, sy = (v) => px(o.top + v) - o.top;
    return [sx(q[0]), sy(q[1]), sx(q[2]), sy(q[3])];
  }
  // the frame: eight pieces, each only translated (the hairlines also scaled along their length)
  function makeFrame(shot) {
    const hl = document.createElement("i"); hl.className = "hl"; hl.setAttribute("aria-hidden", "true");
    const parts = ["e h", "e h", "e v", "e v", "c tl", "c tr", "c bl", "c br"].map((c) => { const b = document.createElement("b"); b.className = c; hl.append(b); return b; });
    // (inside the film's own plate, so that it rides with it as it lands)
    (shot.querySelector(".fl") || shot).append(hl);
    return {
      hl,
      place(p, q) {
        const [x, y, x2, y2] = q, w = x2 - x, h = y2 - y;
        if (!(w > 0) || !(h > 0)) return;
        const r = parseFloat(getComputedStyle(p.el).getPropertyValue("--r")) || 5;
        const sx = Math.max(0, w - 2 * r) / 100, sy = Math.max(0, h - 2 * r) / 100;
        const T = [
          `translate(${x + r}px, ${y}px) scale(${sx}, 1)`, `translate(${x + r}px, ${y2 - 1}px) scale(${sx}, 1)`,
          `translate(${x}px, ${y + r}px) scale(1, ${sy})`, `translate(${x2 - 1}px, ${y + r}px) scale(1, ${sy})`,
          `translate(${x}px, ${y}px)`, `translate(${x2 - r}px, ${y}px)`, `translate(${x}px, ${y2 - r}px)`, `translate(${x2 - r}px, ${y2 - r}px)`,
        ];
        parts.forEach((e, i) => { e.style.transform = T[i]; });
      },
    };
  }

  // ---- the effects' cards, drawn in -------------------------------------------
  // drayki, of the two arrivals drawn for him: "b". As each effects card
  // comes into view a hairline goes once round it, from its top left corner,
  // while its colour and what it holds come up behind the line (see the
  // style); the film among them starts only once a line has closed round
  // one of them (the first to come in: across the board, the one card), and
  // as it starts, the line fades — a moment later anyway, where it cannot
  // play; a card that comes in while the film plays has its line drawn, then
  // fading. Under reduced motion the cards are simply there.
  const edged = [...root.querySelectorAll("[data-e]")];
  const DRAW = 1550, LATE = 1500;   // ms: the line closed and all come up behind it; then, at the latest, the line fades
  let decide = () => {};
  const fade = (c) => { if (c.classList.contains("drawn")) c.classList.add("lit"); };
  if (reduce) edged.forEach((c) => c.classList.add("in", "drawn", "lit"));
  else {
    const NS = "http://www.w3.org/2000/svg";
    edged.forEach((c) => {
      const svg = document.createElementNS(NS, "svg");
      svg.setAttribute("class", "edge"); svg.setAttribute("aria-hidden", "true");
      svg.append(document.createElementNS(NS, "rect"));
      c.append(svg); c.classList.add("armed");
    });
    const draw = (c) => {
      // (along the card's own edge, half a pixel in, round its own corners;
      // dashed as long as it is, so it can be drawn from nothing)
      const r = c.querySelector(".edge rect"), w = c.offsetWidth, h = c.offsetHeight;
      const rad = Math.max(0, Math.min((parseFloat(getComputedStyle(c).borderTopLeftRadius) || 0) - .5, w / 2 - .5, h / 2 - .5));
      const len = Math.ceil(2 * (w + h - 2) - (8 - 2 * Math.PI) * rad) + 2;
      Object.entries({ x: .5, y: .5, width: Math.max(0, w - 1), height: Math.max(0, h - 1), rx: rad.toFixed(2) }).forEach(([k, v]) => r.setAttribute(k, v));
      r.style.strokeDasharray = `${len} ${len}`; r.style.strokeDashoffset = String(len);
      getComputedStyle(r).strokeDashoffset;   // (it starts from nothing)
      c.classList.add("in");
      r.style.strokeDashoffset = "0";
      setTimeout(() => {
        c.classList.add("drawn");
        // (among a film already playing, it fades at once; and a frame
        // waiting for it goes on)
        shots.forEach((p) => { if (p.cards.includes(c) && !p.video.paused && p.el.classList.contains("playing")) fade(c); hush(p); });
        decide();
        setTimeout(() => c.classList.add("lit"), LATE);
      }, DRAW);
    };
    const eio = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { eio.unobserve(e.target); draw(e.target); } }), { rootMargin: "0px 0px -20% 0px" });
    edged.forEach((c) => eio.observe(c));
  }

  const shots = [...root.querySelectorAll("[data-shot]")].map((el) => {
    const cfg = SHOTS[el.dataset.shot];
    // (its words — the phrases underlined, and for the effects the lines lit
    // with the phrase of the same number — are its own: never the other
    // arrangement's, which lies unseen in the same chapter)
    const own = el.closest(".strip, .fxb, .ch");
    const p = { el, cfg, video: el.querySelector("video"), drop: el.querySelector(".drop"), phs: [...own.querySelectorAll(".say .ph")], lines: [...own.querySelectorAll(".fxs li, .fx figcaption")], cur: -1, want: false, ratio: 0, loaded: "", extra: [] };
    if (cfg.tiles) { p.cells = [...el.querySelectorAll(".fx .scr")]; p.cvs = p.cells.map((c) => c.querySelector("canvas")); p.ims = {}; }
    // (the cards drawn in with it, one of which it waits for)
    const card = el.closest("[data-e]");
    p.cards = card ? [card] : [...el.querySelectorAll("[data-e]")];
    // (the scroll lays a film in its socket before it plays: see there)
    el.__redo = () => redo(p);
    p.frame = makeFrame(el);
    p.video.addEventListener("playing", () => { el.classList.add("playing"); if (p.cvs) paint(p, true); p.cards.forEach(fade); });
    p.video.addEventListener("play", kick);
    return p;
  });
  const boxOf = (p, key) => variant(p).boxes[key];
  // ---- the effects, one tile each ----------------------------------------------
  // One film (under the first cell, drawn over), and each cell painted from
  // it on every new frame of it — the five never drift apart, and only one
  // film is fetched and decoded. Before it plays (or where nothing may play),
  // its poster, cut the same way.
  function cutOf(v, i) { const [c, hw, t, b] = v.frames[i], m = v.cut; return [c - hw - m, t - m, 2 * hw + 2 * m, b - t + 2 * m]; }
  // where the frame goes on a tile: around its module, in the element's pixels, on the screen's pixels
  function tileRect(p, i) {
    const v = variant(p), [, , cw, chh] = cutOf(v, i), [, hw, t, b] = v.frames[i], m = v.cut;
    const o = p.el.getBoundingClientRect(), r = p.cells[i].getBoundingClientRect(), kx = r.width / cw, ky = r.height / chh;
    const x = r.left - o.left + m * kx, y = r.top - o.top + m * ky, x2 = x + 2 * hw * kx, y2 = y + (b - t) * ky;
    const sx = (u) => px(o.left + u) - o.left, sy = (u) => px(o.top + u) - o.top;
    return [sx(x), sy(y), sx(x2), sy(y2)];
  }
  const rectOf = (p, key) => (p.cfg.tiles ? tileRect(p, key) : snapPx(p, boxOf(p, key)));
  function posterOf(p, v) {
    let im = p.ims[v.poster];
    if (!im) { im = p.ims[v.poster] = new Image(); im.decoding = "async"; im.onload = () => paint(p, true); im.src = v.poster; }
    return im;
  }
  function sourceOf(p) {
    const v = variant(p), f = p.video;
    if (p.el.classList.contains("playing") && p.loaded === v.src && f.readyState >= 2 && f.videoWidth) return f;
    const im = posterOf(p, v);
    return im.complete && im.naturalWidth ? im : null;
  }
  // the film's own dark, read once off its top left corner, for the margin where it stops short
  function groundOf(src) {
    try {
      const c = document.createElement("canvas"); c.width = c.height = 1;
      const g = c.getContext("2d", { willReadFrequently: true }); g.drawImage(src, 2, 2, 1, 1, 0, 0, 1, 1);
      const d = g.getImageData(0, 0, 1, 1).data;
      return `rgb(${d[0]}, ${d[1]}, ${d[2]})`;
    } catch (e) { return "#25272f"; }
  }
  function paint(p, force) {
    // (not while the tiles are not shown: the card across the board is)
    if (!p.cvs || !p.ow) return;
    const src = sourceOf(p);
    if (!src) return;
    const v = variant(p), live = src === p.video, t = live ? src.currentTime : -1, id = live ? v.src : src.src;
    if (!force && live && t === p.painted && id === p.paintedOf) return;
    p.painted = t; p.paintedOf = id;
    if (p.groundKey !== id) { p.ground = groundOf(src); p.groundKey = id; }
    const kx = (live ? src.videoWidth : src.naturalWidth) / v.size[0], ky = (live ? src.videoHeight : src.naturalHeight) / v.size[1];
    p.cvs.forEach((c, i) => {
      if (!c.width || !c.height) return;
      const g = c.getContext("2d"), [x, y, w, h] = cutOf(v, i), sx = c.width / w, sy = c.height / h;
      const x0 = Math.max(0, x), y0 = Math.max(0, y), x1 = Math.min(v.size[0], x + w), y1 = Math.min(v.size[1], y + h);
      g.imageSmoothingEnabled = true; g.imageSmoothingQuality = "high";
      g.fillStyle = p.ground; g.fillRect(0, 0, c.width, c.height);
      g.drawImage(src, x0 * kx, y0 * ky, (x1 - x0) * kx, (y1 - y0) * ky, (x0 - x) * sx, (y0 - y) * sy, (x1 - x0) * sx, (y1 - y0) * sy);
    });
  }
  // each cell as many pixels as the screen shows it at
  function sizeTiles(p) {
    if (!p.cvs) return;
    p.cvs.forEach((c) => { const r = c.getBoundingClientRect(), w = Math.round(r.width * dpr()), h = Math.round(r.height * dpr()); if (w && h && (c.width !== w || c.height !== h)) { c.width = w; c.height = h; } });
    paint(p, true);
  }
  // The effects' lines under the film across the board: one line each, never
  // broken, each centred under its own module and exactly as wide as its
  // frame (so its hairline is the frame's width). Their size comes down only
  // if two side by side would come within GAP of each other, or one would
  // run past the film's edge.
  const GAP = 16;
  function seatLines(p) { bare(p.el, () => seatLines0(p)); }
  function seatLines0(p) {
    const ls = p.lines;
    if (p.cfg.tiles || !ls.length) return;
    const ol = ls[0].parentElement, sr = p.el.getBoundingClientRect(), or = ol.getBoundingClientRect();
    if (!sr.width || !or.width) return;
    const dx = sr.left - or.left;
    const bs = variant(p).boxes.map((b) => { const [x, , x2] = snapPx(p, b); return { x: dx + x, w: x2 - x, c: dx + (x + x2) / 2 }; });
    ol.style.fontSize = "";
    ol.classList.add("laid");
    const tw = ls.map((l) => (l.querySelector(".w") || l).getBoundingClientRect().width);
    let f = 1;
    bs.forEach((a, i) => {
      f = Math.min(f, (2 * a.c) / tw[i], (2 * (or.width - a.c)) / tw[i]);
      if (i) f = Math.min(f, (2 * (a.c - bs[i - 1].c - GAP)) / (tw[i] + tw[i - 1]));
    });
    if (f < 1) ol.style.fontSize = `${Math.floor(parseFloat(getComputedStyle(ol).fontSize) * f * 4) / 4}px`;
    ls.forEach((l, i) => { const s = l.style; s.marginLeft = `${bs[i].x.toFixed(2)}px`; s.width = `${bs[i].w.toFixed(2)}px`; });
  }
  function underline(p, list) { p.phs.forEach((s, k) => s.classList.toggle("on", list.includes(k))); p.lines.forEach((s, k) => s.classList.toggle("on", list.includes(k))); }
  function still(p) { p.el.classList.add("still"); requestAnimationFrame(() => requestAnimationFrame(() => p.el.classList.remove("still"))); }
  // Laid in by the scroll, a film's frame is born from the film's own
  // outline: it stands at the film's edge, then closes on the part it points
  // at (the scroll marks the film data-born as it lays it in)
  function born(p) {
    const v = variant(p);
    still(p); p.frame.place(p, snapPx(p, [0, 0, v.size[0], v.size[1]]));
    clearTimeout(p.birth);
    // (seen a moment all round the film, then gone to its part, a little slower than it travels after)
    p.birth = setTimeout(() => {
      if (p.cur < 0 || p.key == null) return;
      p.el.classList.add("birth"); p.frame.place(p, rectOf(p, p.key));
      p.birth = setTimeout(() => p.el.classList.remove("birth"), 800);
    }, 380);
  }
  function cue(p, i, jump) {
    const [, key, phs] = p.cfg.cues[i], q = rectOf(p, key), was = p.at, mid = (r, a) => (r[a] + r[a + 2]) / 2;
    clearTimeout(p.hop); p.el.classList.remove("hop");
    if ((jump || !was) && p.el.dataset.born === "1") { delete p.el.dataset.born; born(p); }
    else if (jump || !was) { still(p); p.frame.place(p, q); }
    // across the whole film, or on the tiles from one row to another: out
    // here, in there (along a row it glides, over the gap)
    else if (key !== p.key && (p.cfg.tiles ? Math.abs(mid(q, 1) - mid(was, 1)) > 2 : Math.abs(mid(q, 0) - mid(was, 0)) > widthOf(p) * .45)) {
      p.el.classList.add("hop");
      p.hop = setTimeout(() => { still(p); p.frame.place(p, rectOf(p, key)); p.el.classList.remove("hop"); }, 170);
    } else if (key !== p.key) {
      const f = p.frame.hl; f.classList.toggle("dip-a", !f.classList.contains("dip-a")); f.classList.toggle("dip-b", !f.classList.contains("dip-a"));
      p.frame.place(p, q);
    }
    p.at = q; p.key = key;
    hush(p);
    underline(p, phs);
    p.el.classList.add("cued");
    p.cur = i;
  }
  // (on the tiles, the frame is not put round a tile that has not been drawn in yet)
  function hush(p) {
    if (!p.cells || p.key == null) return;
    const c = p.cells[p.key].closest("[data-e]");
    p.frame.hl.classList.toggle("wait", !!c && c.classList.contains("armed") && !c.classList.contains("drawn"));
  }
  // (a film's size, read where the page has just been laid out — as it is
  // measured again, see redo — and never in a frame, where the styles the
  // frame has already written would have to be worked out first)
  function sized(p) { p.cw = p.el.clientWidth; p.ow = p.el.offsetWidth; }
  const widthOf = (p) => { if (p.cw == null) sized(p); return p.cw; };
  // the .wav: in from the right, lands on B's waveform as B changes, then fades
  function dropAt(p, t) {
    if (!p.drop) return;
    const v = variant(p), [a, land, gone] = p.cfg.drop, k = widthOf(p) / v.size[0];
    let o = 0, dx = 0, dy = 0;
    if (t >= a && t < gone) {
      const e = 1 - Math.pow(1 - Math.min(1, (t - a) / (land - a)), 3);
      dx = (1 - e) * 130 * k; dy = -(1 - e) * 26 * k;
      o = t < land ? Math.min(1, (t - a) / .25) : Math.max(0, 1 - (t - land) / (gone - land));
    }
    const op = o.toFixed(3), tf = `translate(${dx.toFixed(1)}px, ${dy.toFixed(1)}px)`;
    if (op !== p.dropOp) { p.dropOp = op; p.drop.style.opacity = op; }
    if (tf !== p.dropTf) { p.dropTf = tf; p.drop.style.transform = tf; }
  }
  function seat(p) {   // where the .wav lands, in this cut
    if (!p.drop) return;
    const v = variant(p);
    p.drop.style.left = `${(v.drop[0] / v.size[0]) * 100}%`; p.drop.style.top = `${(v.drop[1] / v.size[1]) * 100}%`;
    dropAt(p, -1);
  }
  function load(p) {
    const v = variant(p);
    if (p.loaded === v.src) return;
    p.loaded = v.src; p.el.classList.remove("playing");
    p.video.src = v.src; p.video.preload = "auto";
    seat(p); p.want ? cue(p, 0, true) : rest(p);
  }
  // a film that is not playing carries no frame and no underline: only the one playing points at anything
  function rest(p) {
    clearTimeout(p.hop); clearTimeout(p.birth); p.el.classList.remove("cued", "hop", "birth");
    underline(p, []); dropAt(p, -1);
    p.cur = -1; p.at = null; p.key = null;
  }
  function cueAt(p, t) { const cs = p.cfg.cues; let i = 0; while (i + 1 < cs.length && cs[i + 1][0] <= t) i++; return i; }
  function sync(p) {
    const t = p.video.currentTime, i = cueAt(p, t);
    if (i !== p.cur) cue(p, i);
    dropAt(p, t);
    paint(p);
  }
  let syncing = false;
  function syncLoop() {
    const live = shots.filter((p) => p.want && !p.video.paused);
    live.forEach(sync);
    if (live.length && !document.hidden) requestAnimationFrame(syncLoop); else syncing = false;
  }
  function kick() { if (!syncing) { syncing = true; requestAnimationFrame(syncLoop); } }
  function run(p) {
    if (reduce) return;
    if (p.want && !document.hidden) {
      load(p);
      if (p.cur < 0) cue(p, cueAt(p, p.video.currentTime || 0), true);   // back from rest: straight to where the clip is
      const go = p.video.play();
      if (go && go.catch) go.catch(() => {});   // no autoplay (low power): the first frame stays, annotated
    } else {
      if (!p.video.paused) p.video.pause();
      if (!p.want) rest(p);   // a hidden tab keeps its place; a film given up for another starts again clean
    }
  }
  // reduced motion: the first frame, with every part it shows marked
  function annotate(p) {
    const list = p.cfg.still || [p.cfg.cues[0].slice(1)];
    p.extra.forEach((f) => f.hl.remove()); p.extra = [];
    list.forEach(([key], k) => { let f = p.frame; if (k) { f = makeFrame(p.el); p.extra.push(f); } f.place(p, rectOf(p, key)); });
    underline(p, list.flatMap((l) => l[1]));
    p.el.classList.add("cued", "still");
  }
  const redo = (p) => { sized(p); sizeTiles(p); seatLines(p); if (reduce) annotate(p); else if (p.cur >= 0) cue(p, p.cur, true); };
  shots.forEach((p) => { sized(p); sizeTiles(p); seatLines(p); if (reduce) annotate(p); else { seat(p); rest(p); } });
  // (the lines are sized to their words: again once the type has come)
  if (document.fonts) { document.fonts.ready.then(() => shots.forEach(seatLines)); document.fonts.addEventListener("loadingdone", () => shots.forEach(seatLines)); }
  // the frame is laid out in pixels: it follows the film (or the tiles) when
  // they change size — and when one arrangement of the effects gives way to
  // the other, the one now shown is laid out from nothing
  if ("ResizeObserver" in window) {
    const ro = new ResizeObserver((es) => { const seen = new Set(); es.forEach((e) => { const p = shots.find((q) => q.el === e.target || (q.cells && q.cells.includes(e.target))); if (p && !seen.has(p)) { seen.add(p); redo(p); } }); });
    shots.forEach((p) => { ro.observe(p.el); if (p.cells) p.cells.forEach((c) => ro.observe(c)); });
  } else addEventListener("resize", () => shots.forEach(redo));
  if (!reduce) {
    const near = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { load(shots.find((q) => q.el === e.target)); near.unobserve(e.target); } }), { rootMargin: "600px 0px" });
    // a film plays from a fifth in view (on a phone, only the one most in
    // view), and among the effects' cards only once one has been drawn in
    // (and the sources' and SUMMON's only once the scroll has laid them in —
    // it tells us so)
    decide = () => {
      const best = shots.reduce((a, b) => (b.ratio > a.ratio ? b : a));
      shots.forEach((p) => { p.want = p.ratio >= .2 && (!small.matches || p === best) && (!p.cards.length || p.cards.some((c) => c.classList.contains("drawn"))) && p.el.dataset.docked !== "0"; run(p); });
    };
    shots.forEach((p) => p.el.addEventListener("halo:dock", decide));
    const inView = new IntersectionObserver((es) => { es.forEach((e) => { shots.find((q) => q.el === e.target).ratio = e.isIntersecting ? e.intersectionRatio : 0; }); decide(); },
      { threshold: [0, .1, .2, .3, .4, .5, .6, .7, .8, .9, 1] });
    shots.forEach((p) => { near.observe(p.el); inView.observe(p.el); });
    document.addEventListener("visibilitychange", () => shots.forEach(run));
    // a phone turned to landscape changes the cut: the other clip, from its start
    small.addEventListener("change", () => { shots.forEach((p) => { sized(p); if (p.loaded) { p.loaded = ""; load(p); } else { seat(p); rest(p); } sizeTiles(p); }); decide(); });
  } else small.addEventListener("change", () => shots.forEach((p) => { sized(p); sizeTiles(p); annotate(p); }));

  // section titles: drawn in once, the first time they are seen
  const tio = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); tio.unobserve(e.target); } }), { threshold: .35 });
  root.querySelectorAll("[data-t]").forEach((el) => (reduce ? el.classList.add("in") : tio.observe(el)));
})();

// ============================================================================
// The drawings: in the hand of the specification drawing, the idea each film
// shows, moving. Each runs on its film's clock while the film plays, on its
// own otherwise, and only while it can be seen; under reduced motion it is
// the film's first frame, whole.
// ============================================================================
(() => {
  "use strict";
  const root = document.getElementById("ob");
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const NS = "http://www.w3.org/2000/svg";
  const clamp01 = (x) => (x < 0 ? 0 : x > 1 ? 1 : x);
  const seg = (t, a, b) => clamp01((t - a) / (b - a));
  const ease = (x) => (x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);
  const out = (x) => 1 - Math.pow(1 - x, 3);
  const smooth = (x) => x * x * (3 - 2 * x);
  const lerp = (a, b, k) => a + (b - a) * k;
  const mk = (tag, attrs, parent) => { const e = document.createElementNS(NS, tag); for (const k in attrs) e.setAttribute(k, attrs[k]); if (parent) parent.appendChild(e); return e; };
  // (in a frame, an attribute is written only when it changes: every write,
  // the same value or not, has the drawing laid out and its card painted again)
  const attr = (e, k, v) => { const m = e.__at || (e.__at = {}); v = String(v); if (m[k] !== v) { m[k] = v; e.setAttribute(k, v); } };
  const f1 = (v) => Math.round(v * 10) / 10;
  const polyD = (pts, n = pts.length) => { let d = ""; for (let i = 0; i < n; i++) d += (i ? "L" : "M") + f1(pts[i][0]) + " " + f1(pts[i][1]); return d; };
  // a polyline that can be drawn up to a fraction of its length
  function trace(pts) {
    const L = [0];
    for (let i = 1; i < pts.length; i++) L.push(L[i - 1] + Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]));
    const total = L[L.length - 1];
    return (f) => {
      if (f <= 0) return "";
      if (f >= 1) return polyD(pts);
      const want = f * total; let i = 1;
      while (i < L.length && L[i] < want) i++;
      const k = (want - L[i - 1]) / (L[i] - L[i - 1] || 1);
      return polyD(pts, i) + "L" + f1(lerp(pts[i - 1][0], pts[i][0], k)) + " " + f1(lerp(pts[i - 1][1], pts[i][1], k));
    };
  }
  // a rounded rectangle as a polyline, starting at the middle of its left side, going up
  function rrect(x, y, w, h, r) {
    const pts = [[x, y + h / 2]], arc = (cx, cy, a0) => { for (let i = 0; i <= 8; i++) { const a = a0 + (i / 8) * Math.PI / 2; pts.push([cx + r * Math.cos(a), cy + r * Math.sin(a)]); } };
    arc(x + r, y + r, Math.PI); arc(x + w - r, y + r, -Math.PI / 2); arc(x + w - r, y + h - r, 0); arc(x + r, y + h - r, Math.PI / 2);
    pts.push([x, y + h / 2]);
    return pts;
  }
  // a keyframed value: [[time, value], ...], eased between keys
  const keyed = (K, t) => { if (t <= K[0][0]) return K[0][1]; for (let i = 1; i < K.length; i++) if (t <= K[i][0]) return lerp(K[i - 1][1], K[i][1], smooth(seg(t, K[i - 1][0], K[i][0]))); return K[K.length - 1][1]; };

  // text in the drawings keeps its size on screen whatever the drawing's scale
  const drawings = [...root.querySelectorAll("svg.dr")];
  // (k: the drawing's units to a screen pixel; what is sized to its text —
  // a tag — is laid out again whenever it changes)
  const kOf = (svg) => parseFloat(svg.style.getPropertyValue("--k")) || 1;
  function fitText() {
    drawings.forEach((svg) => {
      const r = svg.getBoundingClientRect(), vb = svg.viewBox.baseVal;
      if (!r.width || !r.height) return;
      svg.style.setProperty("--k", (1 / Math.min(r.width / vb.width, r.height / vb.height)).toFixed(4));
      if (svg.relayout) svg.relayout(kOf(svg));
      if (svg.redraw) svg.redraw();
    });
  }
  fitText();
  if ("ResizeObserver" in window) { const ro = new ResizeObserver(fitText); drawings.forEach((d) => ro.observe(d)); } else addEventListener("resize", fitText);
  // A hairline pill round a line of text (a tag), sized to the text as it
  // is drawn: its padding, like the text, in screen pixels. Its own box
  // starts at 0 0.
  function pill(parent, parts) {
    const g = mk("g", {}, parent), box = mk("rect", { class: "pill" }, g), tx = mk("text", { class: "tx", "dominant-baseline": "central" }, g);
    parts.forEach(([s, c]) => { mk("tspan", c ? { class: c } : {}, tx).textContent = s; });
    const o = { g, w: 0, h: 0 };
    o.lay = (k) => {
      const tw = tx.getBBox().width, px = 9 * k, h = 22 * k, w = tw + 2 * px, cy = h / 2 + .4 * k;
      box.setAttribute("width", f1(w)); box.setAttribute("height", f1(h)); box.setAttribute("rx", f1(h / 2));
      tx.setAttribute("x", f1(px)); tx.setAttribute("y", f1(cy));
      o.w = w; o.h = h;
      return o;
    };
    return o;
  }

  // ---- sources ----------------------------------------------------------------
  // As the film plays it (13 s): A is an oscillator until 4.2 s, then a
  // sample (pad glacier), then the oscillator again at 12.3 s. Drawn, the
  // oscillator is what it is, a wavetable one: its wave moves through four
  // of its fourteen tables, each one's name under it (the film turns the
  // first table, shapes, from a sine to a square). B is a sample, bell
  // hollow, until a .wav is dropped on it and it becomes texture drown at
  // 6.0 s — the .wav carrying the root found in it, as the film reads it
  // (c2). Between them the blend, in spectral mode, held in the middle, then
  // to A, to B and back; the side it leans to is brighter.
  function sources(svg) {
    const X0 = 70, X1 = 570;
    // four of the tables (Params.cpp: glass, voice, metal, bell), a cycle of
    // each as a hairline draws it, all brought to the same height
    const TABLES = [
      ["glass", (x) => Math.sin(x) + .24 * Math.sin(7 * x + .3)],
      ["voice", (x) => { const u = (((x / (2 * Math.PI)) % 1) + 1) % 1; return .4 * Math.sin(x) + Math.exp(-2.4 * u) * Math.sin(8 * Math.PI * u); }],
      ["metal", (x) => Math.sin(x) + .55 * Math.sin(7 * x + .8) + .3 * Math.sin(13 * x)],
      ["bell", (x) => .8 * Math.sin(x) + .55 * Math.sin(2 * x + .3) + .28 * Math.sin(5 * x + 1.2)],
    ].map(([name, f]) => { let m = 0; for (let i = 0; i < 720; i++) m = Math.max(m, Math.abs(f((i / 720) * 2 * Math.PI))); return [name, (x) => f(x) / m]; });
    // (each table at the points the wave is drawn through, worked out once)
    const TV = TABLES.map(([, f]) => Array.from({ length: 361 }, (_, k) => f((k / 360) * 4 * Math.PI)));
    const SAMPLES = {
      bell: ["bell hollow", (u) => (u < .02 ? u / .02 : Math.exp(-3.6 * (u - .02))), 1.7],
      pad: ["pad glacier", (u) => smooth(clamp01(u / .34)) * (1 - smooth(seg(u, .74, 1))) * (.8 + .2 * Math.sin(u * 11)), .9],
      drown: ["texture drown", (u) => smooth(clamp01(u / .06)) * (1 - smooth(seg(u, .82, 1))) * (.42 + .58 * Math.abs(Math.sin(u * 7.3 + .6))), 2.3],
    };
    const NB = 72;
    const H = Object.fromEntries(Object.entries(SAMPLES).map(([k, [, env, seed]]) => [k, Array.from({ length: NB }, (_, i) => {
      const u = i / (NB - 1), j = .55 + .45 * Math.abs(Math.sin(i * seed) * Math.cos(i * .37 + seed));
      return Math.max(1.2, 40 * env(u) * j);
    })]));
    // (each drawn once, then kept)
    const barsOf = new Map();
    const bars = (key, cy, f) => { const n = Math.round(NB * f), bk = `${key}|${cy}|${n}`; let d = barsOf.get(bk); if (d !== undefined) return d; d = ""; const hs = H[key]; for (let i = 0; i < n; i++) { const x = X0 + (X1 - X0) * (i / (NB - 1)); d += "M" + f1(x) + " " + f1(cy - hs[i]) + "V" + f1(cy + hs[i]); } barsOf.set(bk, d); return d; };
    const gA = mk("g", {}, svg), gB = mk("g", {}, svg), gM = mk("g", {}, svg);
    const tA = mk("text", { class: "tx", x: X0, y: 34 }, gA), tAs = mk("text", { class: "tx", x: X1, y: 34, "text-anchor": "end" }, gA);
    const wave = mk("path", { class: "st" }, gA), aBars = mk("path", { class: "st" }, gA);
    // the table's name, under its wave
    const tT = mk("text", { class: "tx", x: X0, y: 170 }, gA);
    // blend
    mk("text", { class: "tx", x: 46, y: 216, "text-anchor": "middle" }, gM).textContent = "a";
    mk("text", { class: "tx", x: 554, y: 216, "text-anchor": "middle" }, gM).textContent = "b";
    mk("path", { class: "st", d: "M76 211H524" }, gM);
    const knob = mk("rect", { class: "st", width: 10, height: 34, rx: 3, y: 194 }, gM);
    mk("text", { class: "tx", x: 300, y: 256, "text-anchor": "middle" }, gM).textContent = "spectral";
    // b
    const tB = mk("text", { class: "tx", x: X0, y: 296 }, gB), tBs = mk("text", { class: "tx", x: X1, y: 296, "text-anchor": "end" }, gB);
    tB.textContent = "sample";
    const bBars = mk("path", { class: "st" }, gB);
    // the .wav (on the card's colour, so B's bars drawing in never show
    // through it), and the tag it carries once it has landed: its root
    const file = mk("g", {}, svg);
    mk("path", { class: "bg", d: "M0 0H20L28 8V36H0Z" }, file);
    mk("path", { class: "st", d: "M0 0H20L28 8V36H0Z M20 0V8H28 M7 23v-6 M11 26v-12 M15 24v-8 M19 22v-4" }, file);
    const tag = pill(file, [["c2 detected"]]);
    svg.relayout = (k) => { tag.lay(k); tag.g.setAttribute("transform", `translate(${f1(-tag.w - 7 * k)} ${f1(18 - tag.h / 2)})`); };
    svg.relayout(kOf(svg));
    // the oscillator through the film's first four seconds: glass, voice,
    // metal, bell, a morph between each two
    const TBL = [[0, 0], [.75, 0], [1.15, 1], [1.85, 1], [2.25, 2], [2.95, 2], [3.35, 3]];
    const BLEND = [[8.2, .5], [9.3, .12], [10.0, .12], [10.8, .87], [11.3, .87], [12.0, .5]];
    const memo = {};
    const say = (el, k, v) => { if (memo[k] !== v) { memo[k] = v; el.textContent = v; } };
    // (the wave drawn again only when it changes: between two tables' morphs it holds)
    let waveKey = "";
    return (t, still) => {
      if (still) t = 0;
      // A: the oscillator, then a sample, then the oscillator again
      const synth = t < 4.2 || t >= 12.3;
      if (synth) {
        const v = t >= 12.3 ? 0 : keyed(TBL, t), i0 = Math.min(3, Math.floor(v)), i1 = Math.min(3, i0 + 1), fr = v - i0;
        // back from the sample, it draws itself in
        const inF = t >= 12.3 ? ease(seg(t, 12.3, 12.9)) : 1, wo = t < 4.2 ? 1 - seg(t, 4.02, 4.2) : 1;
        const wk = `${i0}|${i1}|${fr}|${inF}`;
        if (wk !== waveKey) {
          waveKey = wk;
          const pts = [];
          for (let k = 0; k <= 360; k++) pts.push([X0 + (X1 - X0) * (k / 360), 100 - 40 * lerp(TV[i0][k], TV[i1][k], fr)]);
          attr(wave, "d", inF >= 1 ? polyD(pts) : trace(pts)(inF));
        }
        attr(wave, "opacity", wo.toFixed(3));
        attr(aBars, "d", "");
        say(tA, "tA", "synth");
        say(tAs, "tAs", "wavetable");
        // the name goes out and the next comes in as the wave passes between two
        say(tT, "tT", TABLES[fr < .5 ? i0 : i1][0]);
        attr(tT, "opacity", (wo * (t >= 12.3 ? seg(t, 12.45, 12.8) : 1) * (1 - .92 * Math.sin(Math.PI * fr))).toFixed(3));
      } else {
        attr(wave, "d", ""); waveKey = "";
        attr(tT, "opacity", "0");
        attr(aBars, "d", bars("pad", 100, ease(seg(t, 4.2, 4.9))));
        attr(aBars, "opacity", (1 - seg(t, 12.1, 12.3)).toFixed(3));
        say(tA, "tA", "sample");
        say(tAs, "tAs", SAMPLES.pad[0]);
      }
      // the labels dip as A changes what it is
      const dipA = still ? 1 : 1 - Math.sin(Math.PI * seg(t, 4.05, 4.45)) * .9 - Math.sin(Math.PI * seg(t, 12.15, 12.55)) * .9;
      attr(tA, "opacity", dipA.toFixed(3)); attr(tAs, "opacity", dipA.toFixed(3));
      // B: bell hollow, then the .wav lands and it becomes texture drown
      const drown = !still && t >= 6.0;
      attr(bBars, "d", drown ? bars("drown", 352, ease(seg(t, 6.0, 6.8))) : bars("bell", 352, 1));
      attr(bBars, "opacity", (drown ? 1 : 1 - seg(t, 5.8, 6.0)).toFixed(3));
      say(tBs, "tBs", SAMPLES[drown ? "drown" : "bell"][0]);
      attr(tBs, "opacity", (still ? 1 : 1 - Math.sin(Math.PI * seg(t, 5.8, 6.3)) * .9).toFixed(3));
      // (it comes in from the drawing's own right edge — all of it inside the
      // viewBox, so it never shows outside its card, whatever the card's
      // width — and stays a moment where it landed, so its tag can be read)
      const fx = lerp(572, 432, ease(seg(t, 5.3, 6.0))), fo = still ? 0 : Math.min(seg(t, 5.25, 5.5), 1 - seg(t, 7.4, 7.8));
      const bump = Math.sin(Math.PI * seg(t, 5.9, 6.2)) * 5;
      attr(file, "transform", `translate(${f1(fx)} ${f1(334 + bump)})`);
      attr(file, "opacity", fo.toFixed(3));
      attr(tag.g, "opacity", seg(t, 6.08, 6.35).toFixed(3));
      // the blend
      const b = keyed(BLEND, t);
      attr(knob, "x", f1(76 + 448 * b - 5));
      attr(gA, "opacity", (.3 + .7 * Math.min(1, 2 * (1 - b))).toFixed(3));
      attr(gB, "opacity", (.3 + .7 * Math.min(1, 2 * b)).toFixed(3));
    };
  }

  // ---- summon ---------------------------------------------------------------
  // Your sounds, drifting in two folders, and an oscillator. As in the film,
  // each press lifts one file out of a folder and the oscillator into the
  // orb; the orb swells, its satellite does one lap, and a preset takes shape
  // beside it holding the two — a sample's bars, an oscillator's wave — and its five
  // effects. It is not named here: the name is the film's. On the film's
  // clock (13.5 s, a press at 1.03, 5.53 and 10.03 s), each preset laid out
  // as the film lays it out: pale signal (A a sample, B an oscillator), glass
  // tide and hollow orbit (A an oscillator, B a sample).
  function summon(svg) {
    const T = 4.5, OX = 305, OY = 196;
    const folder = (x, y, w, h) => `M${x} ${y + 16}V${y + 4}Q${x} ${y} ${x + 4} ${y}H${x + 52}L${x + 62} ${y + 10}H${x + w - 6}Q${x + w} ${y + 10} ${x + w} ${y + 16}V${y + h - 6}Q${x + w} ${y + h} ${x + w - 6} ${y + h}H${x + 6}Q${x} ${y + h} ${x} ${y + h - 6}Z`;
    const FOLD = [[28, 52, 186, 128], [28, 224, 186, 128]];
    FOLD.forEach(([x, y, w, h]) => mk("path", { class: "st", d: folder(x, y, w, h) }, svg));
    // the sounds: a loose grid in each folder, each drifting on its own
    const dots = FOLD.map(([x, y, w], fi) => {
      const list = [];
      for (let r = 0; r < 2; r++) for (let c = 0; c < 4; c++) {
        const s = fi * 17 + r * 5 + c * 3;
        list.push({ bx: x + 34 + c * ((w - 68) / 3) + (r ? 12 : -6), by: y + 50 + r * 44, ax: 5 + (s % 4), ay: 4 + (s % 3), w1: .5 + (s % 5) * .09, w2: .43 + (s % 7) * .07, p1: s * 1.7, p2: s * 2.3,
          o: mk("circle", { class: "st", r: 4.5 }, svg), f: mk("circle", { class: "dot", r: 4.5, opacity: 0 }, svg) });
      }
      return list;
    });
    const pos = (d, time) => [d.bx + d.ax * Math.sin(time * d.w1 + d.p1), d.by + d.ay * Math.cos(time * d.w2 + d.p2)];
    // the oscillator: a wave under the orb, its sound a dot on its middle
    const SX = OX, SY = 322;
    mk("path", { class: "st", d: polyD(Array.from({ length: 49 }, (_, i) => [SX - 30 + 60 * i / 48, SY - 8 * Math.sin(i / 48 * Math.PI * 3)])) }, svg);
    const oscDot = mk("circle", { class: "dot", cx: SX, cy: SY, r: 4.5, opacity: 0 }, svg);
    const trails = [0, 1].map(() => mk("path", { class: "st" }, svg)), movers = [0, 1].map(() => mk("circle", { class: "dot", r: 4.5, opacity: 0 }, svg));
    // the orb: a ring, a core and a satellite, as the interface draws it
    const ripple = mk("circle", { class: "st", cx: OX, cy: OY, r: 30, opacity: 0 }, svg);
    const ring = mk("circle", { class: "st", cx: OX, cy: OY, r: 30 }, svg);
    const core = mk("circle", { class: "st", cx: OX, cy: OY, r: 10 }, svg);
    const coreFill = mk("circle", { class: "dot", cx: OX, cy: OY, r: 10, opacity: 0 }, svg);
    const sat = mk("circle", { class: "dot", r: 3.2 }, svg);
    // the preset
    const P = { x: 392, y: 58, w: 186, h: 272 };
    const card = mk("g", {}, svg);
    const link = mk("path", { class: "st" }, card), linkT = trace([[OX + 38, OY], [P.x - 8, OY]]);
    const outline = mk("path", { class: "st" }, card), outT = trace(rrect(P.x, P.y, P.w, P.h, 10));
    // its header, as the interface's: the orb's small ring, and a rule
    const glyph = mk("circle", { class: "st", cx: P.x + 26, cy: P.y + 30, r: 6 }, card);
    const rule = mk("path", { class: "st" }, card), ruleT = trace([[P.x + 18, P.y + 54], [P.x + P.w - 18, P.y + 54]]);
    const lanes = [mk("path", { class: "st" }, card), mk("path", { class: "st" }, card)];
    const fxg = mk("g", {}, card);
    // the five effects in miniature, drawn as the interface draws them
    const gx = P.x + 18, gy = P.y + 226, gw = (P.w - 36 - 4 * 10) / 5;
    const G = (i) => gx + i * (gw + 10);
    // halo: a falling series of lines; grain: scattered grains; ruin: a clipped wave; ghost: fading echoes; space: rings
    mk("path", { class: "st", d: [0, 1, 2, 3].map((k) => `M${f1(G(0) + 2 + k * 6)} ${gy + 17}v${-(17 - k * 3.6)}`).join("") }, fxg);
    [[3, 6], [11, 3], [17, 10], [6, 14], [14, 16]].forEach(([dx, dy]) => mk("circle", { class: "dot", cx: f1(G(1) + dx), cy: gy + dy, r: 1.7 }, fxg));
    mk("path", { class: "st", d: `M${f1(G(2))} ${gy + 14}C${f1(G(2) + 1)} ${gy + 3} ${f1(G(2) + 4)} ${gy + 3} ${f1(G(2) + 8)} ${gy + 3}S${f1(G(2) + 11)} ${gy + 14} ${f1(G(2) + 14)} ${gy + 14}S${f1(G(2) + gw - 1)} ${gy + 14} ${f1(G(2) + gw)} ${gy + 4}` }, fxg);
    mk("path", { class: "st", d: [0, 1, 2].map((k) => `M${f1(G(3) + 3 + k * 8)} ${gy + 16 - k * 1.5}l${(1 + k).toFixed(1)} ${-(15 - k * 4)}`).join("") }, fxg);
    [8.5, 4].forEach((r) => mk("circle", { class: "st", cx: f1(G(4) + gw / 2), cy: gy + 8.5, r }, fxg));
    // the film's three presses: which folder and file, and what each source became
    const KIND = [["s", "o"], ["o", "s"], ["o", "s"]], PICK = [[0, 1], [1, 6], [0, 5]];
    const LANE = KIND.map((ks, n) => ks.map((kind, k) => {
      const cy = P.y + 100 + k * 64, x0 = P.x + 18, w = P.w - 36;
      if (kind === "o") return trace(Array.from({ length: 81 }, (_, i) => { const u = i / 80; return [x0 + w * u, cy - 16 * Math.min(1, u / .25) * Math.sin(u * Math.PI * 2 * (3 + n))]; }));
      const hs = Array.from({ length: 26 }, (_, i) => { const u = i / 25, e = [smooth(clamp01(u / .4)) * (1 - smooth(seg(u, .7, 1))), Math.exp(-3.4 * u), .5 + .5 * Math.abs(Math.sin(u * 8))][n]; return Math.max(1, 20 * e * (.55 + .45 * Math.abs(Math.sin(i * 1.9 + n)))); });
      return (f) => { let d = ""; const nb = Math.round(26 * f); for (let i = 0; i < nb; i++) { const x = x0 + w * i / 25; d += `M${f1(x)} ${f1(cy - hs[i])}V${f1(cy + hs[i])}`; } return d; };
    }));
    // each sound's way into the orb
    const way = (x, y, bend) => { const cx = lerp(x, OX, .55) + 10, cy = y + (OY - y) * .15 + bend, pts = []; for (let j = 0; j <= 40; j++) { const u = j / 40, a = (1 - u) * (1 - u), b = 2 * (1 - u) * u, c = u * u; pts.push([a * x + b * cx + c * OX, a * y + b * cy + c * OY]); } return pts; };
    return (time, still, drift) => {
      const cyc = Math.floor(time / T), t = still ? T : time - cyc * T, n = still ? 2 : ((cyc % 3) + 3) % 3;
      // until the new preset is laid out, the last one stays, faint
      const fresh = still || t >= 1.8, cn = fresh ? n : (n + 2) % 3;
      const [fi, di] = PICK[n], back = still ? 0 : seg(t, 3.9, 4.4);
      let from = null;
      dots.forEach((list, f) => list.forEach((d, i) => {
        const [x, y] = pos(d, drift);
        const picked = f === fi && i === di;
        if (picked) from = [x, y];
        const oo = !picked || still ? 1 : t < .45 ? 1 : back.toFixed(3), fo = !picked ? 0 : still ? 1 : (seg(t, .15, .4) * (t < .5 ? 1 : 0)).toFixed(3);
        // (a sound not seen, its ring or its fill, is not moved: it is put
        // where it is as it comes back)
        if (+oo) { attr(d.o, "cx", f1(x)); attr(d.o, "cy", f1(y)); }
        if (+fo) { attr(d.f, "cx", f1(x)); attr(d.f, "cy", f1(y)); }
        attr(d.o, "opacity", oo);
        attr(d.f, "opacity", fo);
      }));
      attr(oscDot, "opacity", still ? 1 : (t < .5 ? seg(t, .15, .4) : back).toFixed(3));
      // lifted out, into the orb, leaving a trace that fades
      [way(from[0], from[1], fi ? 24 : -24), way(SX, SY, 0)].forEach((pts, k) => {
        const f = still ? 1 : ease(seg(t, .45 + k * .1, 1.2 + k * .1));
        const to = (still ? .4 : .7 * (1 - seg(t, 1.35, 1.9))).toFixed(3), mo = !still && t >= .45 && f < .97 ? 1 : 0;
        // (nor a trace, nor a sound on its way)
        if (+to) attr(trails[k], "d", trace(pts.slice(0, 37))(f));
        attr(trails[k], "opacity", to);
        if (mo) { const m = pts[Math.round(f * 40)]; attr(movers[k], "cx", f1(m[0])); attr(movers[k], "cy", f1(m[1])); attr(movers[k], "r", (4.5 * (1 - .6 * f)).toFixed(2)); }
        attr(movers[k], "opacity", mo);
      });
      // the orb breathes, then answers: it swells, its satellite does one lap
      const hit = still ? 0 : seg(t, 1.3, 2.1), sw = hit < .3 ? out(hit / .3) : 1 - out((hit - .3) / .7);
      const rr = 30 + 1.2 * Math.sin(drift * 1.4) + 5 * sw;
      attr(ring, "r", f1(rr));
      attr(core, "r", f1(10 + 4 * sw));
      const co = (still ? 0 : .9 * Math.sin(Math.PI * seg(t, 1.25, 1.95))).toFixed(3);
      if (+co) attr(coreFill, "r", f1(10 + 4 * sw));
      attr(coreFill, "opacity", co);
      const rp = still ? 0 : seg(t, 1.3, 2.4), ro = (rp > 0 && rp < 1 ? 1 - rp : 0).toFixed(3);
      if (+ro) attr(ripple, "r", f1(30 + 70 * ease(rp)));
      attr(ripple, "opacity", ro);
      const a = (-40 + 360 * out(hit)) * Math.PI / 180;
      attr(sat, "cx", f1(OX + rr * Math.cos(a))); attr(sat, "cy", f1(OY + rr * Math.sin(a)));
      // the preset: its outline, its header, then what it holds
      const at = (x, y) => (!fresh || still ? 1 : ease(seg(t, x, y)));
      attr(card, "opacity", (still ? 1 : t < 1.8 ? .3 * (1 - seg(t, 1.62, 1.8)) : 1 - .7 * seg(t, 3.9, 4.4)).toFixed(3));
      attr(link, "d", linkT(at(1.8, 1.95)));
      attr(outline, "d", outT(at(1.82, 2.3)));
      attr(glyph, "opacity", at(2.0, 2.25).toFixed(3));
      attr(rule, "d", ruleT(at(2.05, 2.4)));
      lanes.forEach((ln, k) => attr(ln, "d", LANE[cn][k](at(2.15 + k * .12, 2.6 + k * .12))));
      attr(fxg, "opacity", (!fresh || still ? 1 : seg(t, 2.45, 2.85)).toFixed(3));
    };
  }

  // ---- effects ------------------------------------------------------------------
  // The five, side by side, in the hand of the other drawings, each named
  // under it; on the film's clock (13 s) each turns up in its turn, as its
  // module does in the film — halo's resonators ring longer, grain's grains
  // scatter wider and more of them, ruin's wave is driven into a square,
  // ghost's echoes last, space's rings open — and the one turned up is drawn
  // in the full ink, the others in the soft.
  function effects(svg) {
    const CX = [60, 180, 300, 420, 540], MY = 66, BY = 104;
    // when each is turned up (from its cue, 0.4 s ahead of the film, to the next)
    const WIN = [[11.5, 14.1], [1.1, 3.7], [3.7, 6.3], [6.3, 8.9], [8.9, 11.5]];
    const level = (t, [a, b]) => { const u = a > 10 && t < 2 ? t + 13 : t, x = clamp01((u - a - .3) / (b - a)); return Math.pow(Math.sin(Math.PI * x), .7); };
    const gs = CX.map((x, i) => { const g = mk("g", {}, svg); mk("text", { class: "tx", x, y: 136, "text-anchor": "middle" }, g).textContent = ["halo", "grain", "ruin", "ghost", "space"][i]; return g; });
    const halo = mk("path", { class: "st" }, gs[0]);
    // (the grains: a fixed scatter, each drifting a little on its own)
    const GR = Array.from({ length: 14 }, (_, i) => { const a = Math.sin(i * 12.9898 + 1.3) * 43758.5453, b = Math.sin(i * 78.233 + .7) * 12543.1; return [2 * (a - Math.floor(a)) - 1, 2 * (b - Math.floor(b)) - 1, i * 1.37]; });
    const grains = GR.map(() => mk("circle", { class: "dot" }, gs[1]));
    const ruin = mk("path", { class: "st" }, gs[2]);
    const ghosts = [0, 1, 2, 3, 4].map(() => mk("path", { class: "st" }, gs[3]));
    const rings = [0, 1, 2, 3].map(() => mk("circle", { class: "st", cx: CX[4], cy: MY }, gs[4]));
    return (time, still, drift) => {
      const t = still ? 0 : time, k = WIN.map((w) => (still ? .45 : level(t, w)));
      gs.forEach((g, i) => attr(g, "opacity", (.42 + .58 * k[i]).toFixed(3)));
      // halo: ten resonators, the first the longest; turned up, they all ring
      { const r = lerp(.5, .05, k[0]); let d = ""; for (let j = 0; j < 10; j++) { const x = CX[0] - 50 + j * 11, h = 12 + 60 * Math.exp(-j * r); d += `M${x} ${BY}V${f1(BY - h)}`; } attr(halo, "d", d); }
      // grain: more of them, further apart
      { const s = lerp(.5, 1, k[1]), n = 6 + 8 * k[1]; grains.forEach((c, j) => { const [gx, gy, ph] = GR[j], go = clamp01(n - j).toFixed(3); if (+go) { attr(c, "cx", f1(CX[1] + gx * 46 * s + 2 * Math.sin(drift * .9 + ph))); attr(c, "cy", f1(MY + gy * 30 * s + 2 * Math.cos(drift * .7 + ph))); attr(c, "r", f1(lerp(2.4, 3.3, k[1]))); } attr(c, "opacity", go); }); }
      // ruin: a sine, driven toward a square
      { const dv = lerp(1.1, 9, k[2]), tn = Math.tanh(dv), pts = []; for (let j = 0; j <= 60; j++) { const u = j / 60; pts.push([CX[2] - 50 + 100 * u, MY - 30 * Math.tanh(dv * Math.sin(2 * Math.PI * u)) / tn]); } attr(ruin, "d", polyD(pts)); }
      // ghost: echoes of one line, fading out behind it; turned up, they last
      ghosts.forEach((g, j) => { const h = 72 * (1 - j * lerp(.2, .07, k[3])), x = CX[3] - 44 + j * 21; attr(g, "d", `M${f1(x)} ${BY}l${f1(2 + j * .9)} ${f1(-h)}`); attr(g, "opacity", Math.max(0, 1 - j * lerp(.23, .1, k[3])).toFixed(3)); });
      // space: rings, opening
      { const R = lerp(22, 38, k[4]); rings.forEach((c, j) => attr(c, "r", f1(R * (j + 1) / 4))); }
    };
  }

  // ---- one clock each, and only while seen ------------------------------------
  function drive(svg, render, film, LOOP, OFF) {
    if (!svg) return;
    // (still, it is drawn again when what is sized to its text moves)
    if (reduce) { svg.redraw = () => render(0, true, 0); svg.redraw(); return; }
    let on = false, raf = 0, last = 0, clock = 0, drift = 0;
    const tick = (now) => {
      raf = 0;
      if (!on || document.hidden) return;
      // (drawn at most sixty times a second: a line drawing gains nothing
      // from a faster screen, and every drawing is its card painted again)
      if (now - last < 15) { raf = requestAnimationFrame(tick); return; }
      // never backwards: a frame can be stamped before wake() read the time
      const dt = Math.max(0, Math.min(.05, (now - last) / 1000));
      last = now; drift += dt;
      if (film && !film.paused && film.readyState >= 2) clock = (film.currentTime + OFF) % LOOP;
      else clock = (clock + dt) % LOOP;
      render(Math.max(0, clock), false, drift);
      raf = requestAnimationFrame(tick);
    };
    const wake = () => { if (on && !document.hidden && !raf) { last = performance.now(); raf = requestAnimationFrame(tick); } };
    render(0, false, 0);
    new IntersectionObserver((es) => { on = es[es.length - 1].isIntersecting; wake(); }).observe(svg);
    document.addEventListener("visibilitychange", wake);
  }
  const dSrc = root.querySelector("#dr-src"), dSum = root.querySelector("#dr-sum");
  if (dSrc) drive(dSrc, sources(dSrc), root.querySelector('[data-shot="sources"] video'), 13, 0);
  if (dSum) drive(dSum, summon(dSum), root.querySelector('[data-shot="summon"] video'), 13.5, .27);
  const dFx = root.querySelector("#dr-fx");
  if (dFx) drive(dFx, effects(dFx), root.querySelector('[data-shot="effects-tiles"] video'), 13, 0);
  // the tags and selects are measured again once the font is in
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitText);
})();

// ============================================================================
// Listen: thirteen tracks made with halo, one player.
// ============================================================================
(() => {
  "use strict";
  const root = document.getElementById("ob");
  const box = root.querySelector("#la");
  if (!box) return;
  const $ = (id) => root.querySelector("#" + id);
  const CDN = "https://cdn.shopify.com/s/files/1/0941/9548/3007/files/";
  // Loudness is each file's own, measured (EBU R128). The files are left as
  // they are; playback brings the loud ones down to LEVEL, so moving down the
  // list is not a jump of 12 dB from one track to the next. The quiet ones
  // are never pushed up — that is where a boost would clip. The lengths are
  // the files' own, measured, so the list costs no request before a press;
  // and so is each one's shape: the peak of each 170th of it, one base-36
  // digit a bin (0 silent, z full), as index.html draws its rows.
  const LEVEL = -18;
  // (drayki v4) the tracks: the admin's (metaobject track, halovst-01..13), printed by snippets/tracks-json
  const TRACKS = (() => { try { const el = root.querySelector("script[data-tracks]"); return JSON.parse(el.textContent).map((t) => ({ name: t.title, by: t.by, lufs: +t.lufs || LEVEL, src: t.src, len: +t.len || 0, shape: t.shape || "" })); } catch (e) { return []; } })();
  const fmt = (s) => { if (!isFinite(s) || s < 0) return "0:00"; const m = Math.floor(s / 60); return `${m}:${String(Math.floor(s % 60)).padStart(2, "0")}`; };
  const clamp01 = (v) => Math.min(1, Math.max(0, v));

  // One element for the page; the graph is built on the first press,
  // because a browser will not start audio without one.
  const audio = new Audio();
  audio.crossOrigin = "anonymous";
  audio.preload = "none";
  let AC = null, GN = null, VN = null, cur = -1, pendingSeek = null;
  function graph() {
    if (AC) return;
    const K = window.AudioContext || window.webkitAudioContext;
    if (!K) return;
    try {
      AC = new K();
      const src = AC.createMediaElementSource(audio);
      // level (per track) → the listener's volume → out
      GN = AC.createGain(); VN = AC.createGain();
      src.connect(GN); GN.connect(VN); VN.connect(AC.destination);
    } catch (err) { AC = GN = VN = null; }
  }
  // The track's level and the listener's volume, each a gain of its own in
  // the graph (a phone often keeps the element's own volume where it is,
  // never the graph's). Without Web Audio the element's own volume carries
  // both, and its own mute the mute.
  let lvl = 1, vol = .8, muted = false, lastVol = .8;
  try { const v = parseFloat(localStorage.getItem("halo.volume")); if (v >= 0 && v <= 1) vol = v; } catch (e) {}
  if (vol > 0) lastVol = vol;
  function applyGain(now) {
    const v = muted ? 0 : vol;
    if (GN) {
      GN.gain.value = lvl; audio.volume = 1; audio.muted = false;
      // (eased over a few milliseconds, so a drag or a mute never clicks)
      const g = VN.gain, t = AC.currentTime;
      g.cancelScheduledValues(t);
      if (now) g.setValueAtTime(v, t);
      else { g.setValueAtTime(g.value, t); g.setTargetAtTime(v, t, .015); }
    } else { audio.volume = Math.min(1, lvl * vol); audio.muted = muted; }
  }
  const dur = () => (isFinite(audio.duration) && audio.duration > 0 ? audio.duration : cur >= 0 ? TRACKS[cur].len : TRACKS[0].len);

  // ---- the list ----------------------------------------------------------------
  const list = $("lp-list"), play = $("lp-play"), prev = $("lp-prev"), next = $("lp-next"), prog = $("lp-prog");
  const nameEl = $("lp-name"), byEl = $("lp-by"), atEl = $("lp-at"), durEl = $("lp-dur");
  // the player kept at hand (see the style): the same controls, small
  const mini = $("lp-mini"), mPlay = $("lpm-play"), mPrev = $("lpm-prev"), mNext = $("lpm-next"), mProg = $("lpm-prog"), mClose = $("lpm-close");
  const mName = $("lpm-name"), mBy = $("lpm-by"), mAt = $("lpm-at");
  // the volume, on both: a speaker that mutes, and a hairline
  const vEls = [$("lp-vol"), $("lpm-vol")].filter(Boolean), mutes = [$("lp-mute"), $("lpm-mute")].filter(Boolean);
  // started: a track has been started (by a press); closed: its × was pressed since
  let started = false, closed = false, miniOn = false;
  const rows = TRACKS.map((tr, i) => {
    const li = document.createElement("li");
    li.innerHTML = `<button class="row" type="button"><span class="n">${String(i + 1).padStart(2, "0")}</span><span class="t"></span><span class="a"></span><span class="d">${fmt(tr.len)}</span></button>`;
    li.querySelector(".t").textContent = tr.name;
    li.querySelector(".a").textContent = tr.by;
    const b = li.querySelector("button");
    b.setAttribute("aria-label", `Play ${tr.name}, by ${tr.by}`);
    b.addEventListener("click", () => toggle(i));
    list.appendChild(li);
    return { li, b };
  });

  function start(i, at) {
    started = true; closed = false;
    // (the graph's volume is set outright the first time, never eased in)
    const fresh = !AC;
    graph();
    if (AC && AC.state === "suspended") AC.resume();
    // (a track that could not be fetched is asked for again)
    if (cur !== i || audio.error) { cur = i; audio.src = TRACKS[i].src; pendingSeek = null; }
    lvl = Math.min(1, Math.pow(10, (LEVEL - TRACKS[i].lufs) / 20));
    applyGain(fresh);
    if (at != null) seek(at);
    const go = audio.play();
    if (go && go.catch) go.catch(() => {});
    sync();
  }
  function toggle(i) { if (cur === i && !audio.paused) audio.pause(); else start(i); sync(); }
  // on, round the list; back, to the start of the track once it has played
  // a few seconds, else to the one before it (as a player's back does)
  const step = (d) => (cur < 0 ? (d > 0 ? 0 : TRACKS.length - 1) : (cur + d + TRACKS.length) % TRACKS.length);
  const goNext = () => start(step(1));
  const goBack = () => { if (cur >= 0 && !audio.error && audio.currentTime > 3) start(cur, 0); else start(step(-1)); };
  function seek(f) {
    f = clamp01(f);
    if (isFinite(audio.duration) && audio.duration > 0) audio.currentTime = f * audio.duration;
    else pendingSeek = f;
    paint();
  }
  audio.addEventListener("loadedmetadata", () => {
    if (pendingSeek != null) { audio.currentTime = pendingSeek * audio.duration; pendingSeek = null; }
    paint();
  });
  audio.addEventListener("ended", goNext);
  // whatever starts the sound (a press here, or the keyboard's or the
  // system's own play key) brings the small player back with it: the sound
  // never plays with no way to stop it in view (but for the top of the
  // page on a screen the hero fills, where the player stays off the object
  // and a little scroll brings it back — see below)
  audio.addEventListener("play", () => { started = true; closed = false; });
  ["play", "pause", "playing", "waiting"].forEach((ev) => audio.addEventListener(ev, sync));
  // a track that cannot be fetched (offline, blocked) is not left showing
  // as playing: both players go back to play, and the next press asks again
  audio.addEventListener("error", () => { if (!audio.paused) audio.pause(); sync(); });

  play.addEventListener("click", () => toggle(cur < 0 ? 0 : cur));
  prev.addEventListener("click", goBack);
  next.addEventListener("click", goNext);
  mPlay.addEventListener("click", () => toggle(cur < 0 ? 0 : cur));
  mPrev.addEventListener("click", goBack);
  mNext.addEventListener("click", goNext);
  // the system's own back and next (a keyboard's keys, a phone's lock
  // screen) do what the two buttons do, and it is told what is playing
  const ms = navigator.mediaSession;
  let msAt = -1;
  if (ms) { try { ms.setActionHandler("previoustrack", goBack); ms.setActionHandler("nexttrack", goNext); } catch (e) {} }
  // closed, it stops the sound and stays away until a track is started again
  mClose.addEventListener("click", () => {
    const had = mini.contains(document.activeElement);
    closed = true; audio.pause(); placeMini();
    if (had) play.focus({ preventScroll: true });
  });

  // the time, clicked or dragged, or moved by keys (on either player)
  function seekable(bar) {
    let dragging = false;
    const fromX = (e) => { const r = bar.getBoundingClientRect(); return (e.clientX - r.left) / r.width; };
    bar.addEventListener("pointerdown", (e) => {
      if (e.button !== 0) return;
      dragging = true; try { bar.setPointerCapture(e.pointerId); } catch (err) {}
      if (cur < 0) start(0, fromX(e)); else seek(fromX(e));
    });
    bar.addEventListener("pointermove", (e) => { if (dragging) seek(fromX(e)); });
    const drop = () => { dragging = false; };
    bar.addEventListener("pointerup", drop);
    bar.addEventListener("pointercancel", drop);
    bar.addEventListener("keydown", (e) => {
      const d = dur(), t = cur >= 0 ? audio.currentTime : 0;
      const to = e.key === "ArrowRight" || e.key === "ArrowUp" ? t + 5 : e.key === "ArrowLeft" || e.key === "ArrowDown" ? t - 5 : e.key === "Home" ? 0 : e.key === "End" ? d - .5 : null;
      if (to === null) return;
      e.preventDefault();
      if (cur < 0) start(0, to / d); else seek(to / d);
    });
  }
  seekable(prog); seekable(mProg);

  // the volume, one for both players, kept for the next visit (a mute is
  // not: it lasts the visit). Muted, both hairlines read nothing, and the
  // speakers a cross; dragged again, or moved by a key, it comes back.
  const VKEYS = { ArrowUp: .05, ArrowRight: .05, ArrowDown: -.05, ArrowLeft: -.05, PageUp: .1, PageDown: -.1 };
  function paintVol() {
    const v = muted ? 0 : vol, lv = v <= 0 ? 0 : v < .5 ? 1 : 2, txt = muted ? "muted" : `${Math.round(vol * 100)} %`;
    vEls.forEach((el) => { el.value = String(v); el.style.setProperty("--v", `${v * 100}%`); el.setAttribute("aria-valuetext", txt); });
    mutes.forEach((b) => { b.setAttribute("data-lv", String(lv)); b.setAttribute("aria-pressed", String(muted)); });
  }
  function setVol(v) {
    vol = Math.round(clamp01(v) * 100) / 100; muted = false;
    if (vol > 0) lastVol = vol;
    applyGain(); paintVol();
    try { localStorage.setItem("halo.volume", String(vol)); } catch (e) {}
  }
  vEls.forEach((el) => {
    el.addEventListener("input", () => setVol(+el.value));
    // (by the keys a twentieth at a time, a tenth by the page keys)
    el.addEventListener("keydown", (e) => {
      if (!Object.prototype.hasOwnProperty.call(VKEYS, e.key)) return;
      e.preventDefault();
      setVol((muted ? 0 : vol) + VKEYS[e.key]);
    });
  });
  // pressed, a speaker mutes, or brings the sound back as it was (from a
  // volume of nothing, to the last one heard)
  mutes.forEach((b) => b.addEventListener("click", () => {
    if (vol <= 0) { setVol(lastVol); return; }
    muted = !muted;
    applyGain(); paintVol();
  }));
  paintVol();

  // ---- the time, drawn as the track's own sound ------------------------------------
  // drayki: "j'aime pas l'animation de la barre de listen qui charge ... à la
  // place d'une simple forme, tu peux me dessiner la waveform précalculée ?"
  // Both players' time is the track's shape: a hairline bar for each bin
  // (never more than one to every two and a half pixels — narrower, a bar
  // takes the loudest of the bins it covers), mirrored about the middle, a
  // silent one a single hairline; what has played in the accent, the rest in
  // the page's line colour, the bar the time is in split at it. Drawn on a
  // canvas as many pixels as it covers, sized only when the bar changes size,
  // redrawn only when the time has moved by a pixel, the track changes, or
  // the palette does (its colours are read once for each palette).
  const PEAKS = TRACKS.map((tr) => [...tr.shape].map((c) => parseInt(c, 36) / 35));
  const waves = [prog, mProg].map((bar) => {
    const cv = document.createElement("canvas");
    cv.setAttribute("aria-hidden", "true");
    bar.appendChild(cv);
    return { bar, cv, w: 0, h: 0, dpr: 1, key: "" };
  });
  let inks = null;
  function ink() {
    if (!inks) { const cs = getComputedStyle(box); inks = { on: cs.getPropertyValue("--accent").trim() || "#7c91fe", off: cs.getPropertyValue("--line").trim() || "rgba(243, 244, 249, .45)" }; }
    return inks;
  }
  function seatWave(v, w, h) {
    const dpr = Math.min(3, window.devicePixelRatio || 1);
    if (w === v.w && h === v.h && dpr === v.dpr) return;
    v.w = w; v.h = h; v.dpr = dpr; v.key = "";
    v.cv.width = Math.max(1, Math.round(w * dpr)); v.cv.height = Math.max(1, Math.round(h * dpr));
  }
  function drawWave(v, p) {
    if (!v.w || !v.h) return;
    const pk = PEAKS[Math.max(0, cur)], W = v.cv.width, H = v.cv.height, n = Math.max(8, Math.min(pk.length, Math.floor(v.w / 2.5)));
    const at = Math.round(p * W), key = `${Math.max(0, cur)}|${W}x${H}|${at}`;
    if (key === v.key) return;
    v.key = key;
    const x = v.cv.getContext("2d"), c = ink(), lw = Math.max(1, Math.round(v.dpr)), pitch = W / n;
    x.clearRect(0, 0, W, H);
    for (let k = 0; k < n; k++) {
      const a = Math.floor((k * pk.length) / n), b = Math.max(a + 1, Math.floor(((k + 1) * pk.length) / n));
      let m = 0;
      for (let j = a; j < b; j++) m = Math.max(m, pk[j]);
      const bx = Math.round(k * pitch + (pitch - lw) / 2), bh = Math.max(lw, 2 * Math.round((m * H * .47))), by = Math.round((H - bh) / 2);
      if (bx + lw <= at) { x.fillStyle = c.on; x.fillRect(bx, by, lw, bh); }
      else if (bx >= at) { x.fillStyle = c.off; x.fillRect(bx, by, lw, bh); }
      else { x.fillStyle = c.on; x.fillRect(bx, by, at - bx, bh); x.fillStyle = c.off; x.fillRect(at, by, bx + lw - at, bh); }
    }
  }
  const drawWaves = () => waves.forEach((v) => drawWave(v, +lastP || 0));
  if ("ResizeObserver" in window) { const ro = new ResizeObserver((es) => { es.forEach((e) => { const v = waves.find((q) => q.bar === e.target); if (v) seatWave(v, e.contentRect.width, e.contentRect.height); }); drawWaves(); }); waves.forEach((v) => ro.observe(v.bar)); }
  else { const fit = () => { waves.forEach((v) => seatWave(v, v.bar.clientWidth, v.bar.clientHeight)); drawWaves(); }; addEventListener("resize", fit); fit(); }
  // (a palette chosen: its colours)
  new MutationObserver(() => { inks = null; waves.forEach((v) => { v.key = ""; }); drawWaves(); }).observe(root, { attributes: true, attributeFilter: ["data-theme"] });

  // ---- what is shown ------------------------------------------------------------
  let lastP = "", lastAt = "", lastDur = "";
  function paint() {
    const d = dur(), t = cur >= 0 ? audio.currentTime : 0, p = clamp01(t / d).toFixed(4);
    if (p !== lastP) { box.style.setProperty("--p", p); mini.style.setProperty("--p", p); lastP = p; }
    waves.forEach((v) => drawWave(v, +p));
    const a = fmt(t), dd = fmt(d);
    if (a !== lastAt || dd !== lastDur) {
      atEl.textContent = a; durEl.textContent = dd; mAt.textContent = a; lastAt = a; lastDur = dd;
      [prog, mProg].forEach((bar) => {
        bar.setAttribute("aria-valuemax", String(Math.round(d)));
        bar.setAttribute("aria-valuenow", String(Math.round(t)));
        bar.setAttribute("aria-valuetext", `${a} of ${dd}`);
      });
      if (cur >= 0 && isFinite(audio.duration)) rows[cur].li.querySelector(".d").textContent = dd;
    }
  }
  function sync() {
    const playing = cur >= 0 && !audio.paused && !audio.error, tr = TRACKS[Math.max(0, cur)];
    box.classList.toggle("playing", playing);
    rows.forEach((r, i) => { r.li.classList.toggle("on", i === cur); if (i === cur) r.b.setAttribute("aria-current", "true"); else r.b.removeAttribute("aria-current"); });
    nameEl.textContent = tr.name; byEl.textContent = tr.by;
    play.setAttribute("aria-label", `${playing ? "Pause" : "Play"} ${tr.name}, by ${tr.by}`);
    mini.classList.toggle("playing", playing);
    mName.textContent = tr.name; mBy.textContent = tr.by; fitBy();
    mPlay.setAttribute("aria-label", play.getAttribute("aria-label"));
    if (ms && cur >= 0 && cur !== msAt && window.MediaMetadata) { msAt = cur; try { ms.metadata = new MediaMetadata({ title: tr.name, artist: tr.by }); } catch (e) {} }
    placeMini(); paint(); wake();
  }
  // The small player shows only once a track has been started, not closed
  // since, while listen is out of view and the object is not across its
  // place (see below; the foot of the page leaves it room as long as it may
  // show). A control gone while it has the keyboard hands it to the big
  // player's play.
  // (its artist, whole or not at all: see the style)
  function fitBy() { mini.classList.toggle("noby", mBy.scrollWidth > mBy.clientWidth); }
  function placeMini() {
    const on = started && !closed && !seen && !onObject(), had = document.activeElement;
    if (on !== miniOn) {
      miniOn = on;
      // (at its place before it shows: it fades in there, never glides in)
      if (on) { place(performance.now(), true); paint(); }
      mini.classList.toggle("on", on);
    }
    if (!on && had && mini.contains(had)) play.focus({ preventScroll: true });
    root.classList.toggle("mini-room", started && !closed);
  }
  // Where it sits: it keeps clear of the get halo pill (with its price, and
  // the trial's line once there is one), wherever that lies across its
  // column. Where it comes under its place, it
  // rides just above it, carried as the page scrolls; once that is past, it
  // goes back down to its place — a hop across, eased like a weight on a
  // spring, never a jump (at once, where motion is reduced). Measured only
  // in the frames the page moves while it shows: its own box and two others.
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const keep = [[".buy .go", ".buy .from", ".buy .try"]].map((g) => g.map((s) => root.querySelector(s)).filter(Boolean));
  const GAP = 12, HOLD = 10;
  const riding = new Set();
  let lift = 0, vel = 0, gliding = false, frame = 0, tPrev = 0, rode = "", moved = -1e9;
  // The hero is another matter: just above its tabs lies the object itself,
  // its near corner coming down on the left, where the player is. So
  // wherever the hero's tabs (and their arrow), or the object over them,
  // come across its place — at the top of the page, on a screen the hero
  // fills — it stays away rather than lie over the object: it goes out, and
  // comes back in at its place once they are past (with a little to spare
  // before it does, so it never wavers). Measured as the page moves while
  // the hero is on screen: its own box and two others.
  // And the foot, where the object comes back over the get halo pill: while
  // the object (its parts lifted a little above it), or the pill and its
  // price under it, lie across its column, it stays away as well — riding
  // above the pill there would lay it over the object — and comes back once
  // they are past.
  const heroEl = root.querySelector(".hero"), heroSpan = [".hero .stage", ".hero .rail"].map((s) => root.querySelector(s)).filter(Boolean);
  const endEl = root.querySelector(".buy"), endSpan = [".buy .cthing", ".buy .go", ".buy .from", ".buy .try"].map((s) => root.querySelector(s)).filter(Boolean);
  let heroNear = false, endNear = false, overObject = false;
  function onObject() {
    if (!(heroNear && heroSpan.length) && !(endNear && endSpan.length)) return (overObject = false);
    const m = mini.getBoundingClientRect(), top = m.top + lift, bot = m.bottom + lift, l = m.left - GAP, r = m.right + GAP;
    let t = Infinity, b = -Infinity;
    if (heroNear) heroSpan.forEach((el) => { const q = el.getBoundingClientRect(); if (q.height) { t = Math.min(t, q.top); b = Math.max(b, q.bottom); } });
    if (endNear) endSpan.forEach((el, i) => { const q = el.getBoundingClientRect(); if (q.height && q.right > l && q.left < r) { t = Math.min(t, q.top - (i ? 0 : .2 * q.height)); b = Math.max(b, q.bottom); } });
    return (overObject = t < bot + GAP && b > top - GAP - (overObject ? HOLD : 0));
  }
  if (heroEl) new IntersectionObserver((es) => { heroNear = es[es.length - 1].isIntersecting; placeMini(); }).observe(heroEl);
  if (endEl) new IntersectionObserver((es) => { endNear = es[es.length - 1].isIntersecting; placeMini(); }).observe(endEl);
  // (the middle of its place, and of each of them across its column)
  let mid = 0;
  const mids = [];
  function aim() {
    const m = mini.getBoundingClientRect(), top = m.top + lift, bot = m.bottom + lift, l = m.left - GAP, r = m.right + GAP;
    let want = 0;
    mid = (top + bot) / 2; mids.length = 0;
    keep.forEach((g, i) => {
      let t = Infinity, b = -Infinity;
      g.forEach((el) => { const q = el.getBoundingClientRect(); if (q.width && q.height && q.right > l && q.left < r) { t = Math.min(t, q.top); b = Math.max(b, q.bottom); } });
      if (t !== Infinity) mids.push((t + b) / 2);
      // (clear once wholly below its place or above it — with a little to
      // spare before it lets go of one it rides on, so it never wavers)
      if (t === Infinity || t >= bot + GAP || b <= top - GAP - (riding.has(i) ? HOLD : 0)) { riding.delete(i); return; }
      riding.add(i);
      want = Math.max(want, bot + GAP - t);
    });
    // (and never off the top of the screen)
    return Math.min(want, Math.max(0, top - GAP));
  }
  function place(now, snap) {
    frame = 0;
    if (!miniOn) { gliding = false; return; }
    const want = aim(), key = [...riding].join();
    if (snap || reduce) gliding = false;
    // it hops only where it has to pass over one of them (on its way back
    // down under one it rode on, or up over one come down from above);
    // pushed up from below, it is simply carried, however fast the page goes
    else if (!gliding && key !== rode) {
      const a = mid - Math.max(lift, want), z = mid - Math.min(lift, want);
      if (mids.some((y) => y > a && y < z)) { gliding = true; vel = 0; tPrev = now - 1000 / 60; }
    }
    rode = key;
    if (gliding) {
      // (a spring damped just enough never to overshoot, in small steps)
      const W = 17;
      let dt = Math.min(.05, Math.max(0, (now - tPrev) / 1000));
      tPrev = now;
      while (dt > 0) { const h = Math.min(dt, 1 / 240); vel += (W * W * (want - lift) - 2 * W * vel) * h; lift += vel * h; dt -= h; }
      if (Math.abs(want - lift) < .4 && Math.abs(vel) < 8) gliding = false;
    }
    if (!gliding) { lift = want; vel = 0; }
    mini.style.transform = lift > .05 ? `translate3d(0, ${(-lift).toFixed(2)}px, 0)` : "";
    // (and a moment after the page stops, while what it keeps clear of may
    // still be settling — the get halo pill comes in rising a little)
    if (gliding || now - moved < 1200) frame = requestAnimationFrame(place);
  }
  addEventListener("scroll", () => { moved = performance.now(); if ((heroNear || endNear) && started && !closed && !seen) placeMini(); if (miniOn && !frame) frame = requestAnimationFrame(place); }, { passive: true });
  addEventListener("resize", () => { fitBy(); placeMini(); if (miniOn) place(performance.now(), true); });
  // the hairlines follow the time only while a player can be seen and plays
  let seen = false, raf = 0;
  const shown = () => seen || miniOn;
  const tick = () => { raf = 0; if (!shown() || audio.paused || document.hidden) return; paint(); raf = requestAnimationFrame(tick); };
  function wake() { if (!raf && shown() && !audio.paused && !document.hidden) raf = requestAnimationFrame(tick); }
  // (a sliver of listen left at an edge of the screen, as a link scrolled to
  // the next section can leave it, is not listen in view)
  new IntersectionObserver((es) => { seen = es[es.length - 1].isIntersecting; placeMini(); if (seen) paint(); wake(); }, { rootMargin: "-2px 0px" }).observe(box);
  document.addEventListener("visibilitychange", wake);
  paint();
})();

// ============================================================================
// Questions: one answer open at a time, its row's height eased open and shut.
// The rows are <details>, so without this they still open (all of them, at
// once); with it, a press on a question is taken over: the answer's height
// runs from wherever it is now (mid-way included, if pressed again before it
// has finished) to its full height or to nothing, and the row is closed only
// once it has folded. The class "on" says which way it is going, so the cross
// and the words turn at the press, not at the end.
// ============================================================================
(() => {
  "use strict";
  const root = document.getElementById("ob");
  const qs = [...root.querySelectorAll(".faq .q")];
  if (!qs.length || !Element.prototype.animate) return;
  const reduce = matchMedia("(prefers-reduced-motion: reduce)");
  const EASE = "cubic-bezier(.65, 0, .35, 1)";
  const run = new Map();
  function slide(q, open) {
    const a = q.querySelector(".a");
    const from = q.open ? a.getBoundingClientRect().height : 0;
    const was = run.get(q);
    if (was) { was.onfinish = null; was.cancel(); run.delete(q); }
    q.classList.toggle("on", open);
    if (open) q.open = true;
    const to = open ? a.scrollHeight : 0;
    if (reduce.matches || from === to) { if (!open) q.open = false; return; }
    // (a longer way takes a little longer, never more than about half a second)
    const ms = Math.round(Math.min(520, 300 + Math.abs(to - from) * .8));
    const an = a.animate([{ height: from + "px" }, { height: to + "px" }], { duration: ms, easing: EASE });
    run.set(q, an);
    // (the scroll's layout waits for the answer to be still, then measures once)
    an.onfinish = () => { run.delete(q); if (!open) q.open = false; root.dispatchEvent(new Event("halo:faq")); };
  }
  qs.forEach((q) => {
    if (q.open) q.classList.add("on");
    q.querySelector("summary").addEventListener("click", (e) => {
      e.preventDefault();
      const open = !q.classList.contains("on");
      if (open) qs.forEach((o) => { if (o !== q && o.classList.contains("on")) slide(o, false); });
      slide(q, open);
    });
    // (opened by the browser itself — its find, a link to it — it is simply open)
    q.addEventListener("toggle", () => { if (!run.has(q)) q.classList.toggle("on", q.open); });
  });
})();

// ============================================================================
// Try halo: three days of the whole instrument, begun from this page.
// The licence server is asked once, as the page opens, whether the trial is
// open (GET /halo/trial/open, given four seconds). Until it says so — and
// whenever it cannot be reached, or says anything else — nothing of it
// shows, and the first question keeps its first answer. Open, the lines
// under the two pills open the sheet: an email, sent as { trial, email },
// and the server hands back the installers a serial would, the visitor's
// system first. The trial itself starts inside halo, with that email. On a
// phone, where halo does not run, the sheet says so and copies the page's
// link instead — which, opened on a computer, opens the sheet.
// (?try=preview shows all of it whatever the server says, for drayki to see
// it before the trial opens: a closed server's answer is then simply said.
// On this computer alone — localhost — ?api= points it at another server,
// the bench's.)
// ============================================================================
(() => {
  "use strict";
  const root = document.getElementById("ob");
  const sheet = root.querySelector("#try"), lines = [...root.querySelectorAll(".try")];
  if (!sheet || !lines.length || typeof sheet.showModal !== "function" || !window.fetch) return;
  const $ = (s) => sheet.querySelector(s);
  const form = $(".tf"), field = $(".te"), ask = $(".tf .tpill"), say = $(".terr");
  const onPhone = $(".tph"), copyB = $(".tph .tpill"), copyL = $(".tph .lb"), done = $(".tdone"), dl = $(".tdl"), em = $(".tem");
  const q = new URLSearchParams(location.search);
  const here = /^(localhost|127\.0\.0\.1)$/.test(location.hostname);
  const API = (here && /^https?:\/\/\S+$/i.test(q.get("api") || "") ? q.get("api") : "https://halo-api.draykimusic.workers.dev").replace(/\/+$/, "");
  const preview = q.get("try") === "preview";
  const reduce = matchMedia("(prefers-reduced-motion: reduce)");
  // (a phone, or a tablet: halo runs on neither)
  const ua = navigator.userAgent || "";
  const mobile = /Android|iPhone|iPad|iPod|Mobile|Silk|Kindle|BlackBerry|IEMobile|Opera Mini/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  const phone = mobile && (matchMedia("(pointer: coarse)").matches || matchMedia("(max-width: 900px)").matches);
  // (the visitor's system: its installer first, in the accent)
  const plat = `${(navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || ""} ${ua}`;
  const mine = /Win/i.test(plat) ? "windows" : /Mac/i.test(plat) ? "mac" : "";
  const LOST = "no answer — try again in a moment";

  // ---- is it open? ----
  // (a fetch that has not answered in four seconds is a trial not open; the
  // preview asks too, so that an email sent while the server is closed — or
  // is still the worker from before the trial route — is answered here with
  // the closed server's words, never with the serial door's)
  function isOpen() {
    const ctl = window.AbortController ? new AbortController() : null;
    let timer = 0;
    const late = new Promise((res) => { timer = setTimeout(() => { if (ctl) ctl.abort(); res(false); }, 4000); });
    const asked = fetch(`${API}/halo/trial/open`, { cache: "no-store", credentials: "omit", signal: ctl ? ctl.signal : undefined })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => !!(d && d.ok === true && d.open === true), () => false);
    return Promise.race([asked, late]).then((v) => { clearTimeout(timer); return v; });
  }
  let live = false, really = false;
  isOpen().then((open) => {
    really = open;
    if (!open && !preview) return;
    live = true;
    lines.forEach((b) => { b.hidden = false; });
    // (the first question's answer becomes the trial's; the page is measured
    // again, as when an answer opens)
    const was = root.querySelector('.faq [data-try="closed"]'), now = root.querySelector('.faq [data-try="open"]');
    if (was && now) { now.hidden = false; was.hidden = true; root.dispatchEvent(new Event("halo:faq")); }
    // (the link a phone copied, opened here: the sheet at once — and so does
    // any link to #try followed on the page)
    if (location.hash === "#try") show(null);
  });
  addEventListener("hashchange", () => { if (live && location.hash === "#try") show(null); });

  // ---- the sheet ----
  let opener = null, closing = 0, pageWas = null, downOn = null;
  let files = null, sentTo = "", got = 0, busy = false, copied = 0;
  // the page behind stays where it is: its scroll held while the sheet is
  // open, and the room of its scroll bar kept as padding, so nothing behind
  // the dark moves. (Never as a stable gutter: Chrome takes a gutter kept on
  // the page off its vw, and every length the page sets in vw would shrink
  // with it — the page a few dozen pixels shorter, and one scrolled to its
  // foot pulled up by as much.)
  const html = document.documentElement;
  function holdPage(on) {
    const s = html.style;
    if (on && !pageWas) {
      pageWas = [s.overflow, s.paddingRight];
      const bar = window.innerWidth - html.clientWidth;
      if (bar > 0) s.paddingRight = `${(parseFloat(getComputedStyle(html).paddingRight) || 0) + bar}px`;
      s.overflow = "hidden";
    } else if (!on && pageWas) { [s.overflow, s.paddingRight] = pageWas; pageWas = null; }
  }
  function show(from) {
    // (pressed again while it goes: it comes back)
    if (closing) { clearTimeout(closing); closing = 0; sheet.classList.add("in"); return; }
    if (sheet.open) return;
    opener = from;
    onPhone.hidden = !phone;
    form.hidden = phone || !!files;
    done.hidden = phone || !files;
    holdPage(true);
    sheet.showModal();
    // (what there is to do first has the keyboard: the field, the first
    // installer, or the link to copy)
    const first = phone ? copyB : files ? dl.querySelector("a") : field;
    if (first) first.focus({ preventScroll: true });
    if (reduce.matches) sheet.classList.add("in");
    else requestAnimationFrame(() => requestAnimationFrame(() => { if (sheet.open && !closing) sheet.classList.add("in"); }));
  }
  function hide() {
    if (!sheet.open || closing) return;
    sheet.classList.remove("in");
    if (reduce.matches) { sheet.close(); return; }
    closing = setTimeout(() => { closing = 0; if (sheet.open) sheet.close(); }, 300);
  }
  // (however it was closed — the cross, Esc, the dark around it — the page
  // is let go, and the line that opened it has the keyboard again)
  sheet.addEventListener("close", () => {
    clearTimeout(closing); closing = 0;
    sheet.classList.remove("in");
    holdPage(false);
    const back = opener; opener = null;
    if (back && !back.hidden && document.contains(back)) back.focus({ preventScroll: true });
  });
  // (Esc goes the cross's way; asked twice, the browser closes it at once)
  sheet.addEventListener("cancel", (e) => { e.preventDefault(); hide(); });
  // (a press on the dark around it — one that began there too: a selection
  // dragged out of the sheet is not a press outside it)
  sheet.addEventListener("pointerdown", (e) => { downOn = e.target; });
  sheet.addEventListener("click", (e) => {
    const on = downOn; downOn = null;
    if (e.target !== sheet || on !== sheet) return;
    const r = sheet.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) hide();
  });
  $(".tclose").addEventListener("click", hide);
  lines.forEach((b) => b.addEventListener("click", () => show(b)));
  // (the keyboard goes round inside it: past its last control, back to its
  // first, and the other way — never out to the page, nor to the browser)
  sheet.addEventListener("keydown", (e) => {
    if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey) return;
    const all = [...sheet.querySelectorAll("a[href], button, input, textarea, select, [tabindex]")].filter((el) => !el.disabled && el.tabIndex >= 0 && el.getClientRects().length);
    if (!all.length) return;
    const first = all[0], last = all[all.length - 1], at = document.activeElement;
    if (e.shiftKey ? (at === first || !sheet.contains(at) || at === sheet) : at === last) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
  });

  // ---- the email, and what comes back ----
  const tell = (t) => { say.textContent = t || ""; };
  function trial(email) {
    const ctl = window.AbortController ? new AbortController() : null;
    const timer = setTimeout(() => { if (ctl) ctl.abort(); }, 20000);
    return fetch(`${API}/halo/download`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ trial: true, email }), cache: "no-store", credentials: "omit", signal: ctl ? ctl.signal : undefined })
      .then((r) => r.json().then((d) => [r, d], () => [r, null]))
      .then(([r, d]) => {
        // (only links of its own kind are followed: an address on the web, for one of the two systems)
        const fs = r.ok && d && d.ok === true && Array.isArray(d.files) ? d.files.filter((f) => f && typeof f.url === "string" && /^https?:\/\//i.test(f.url) && (f.platform === "mac" || f.platform === "windows")) : [];
        if (fs.length) return { files: fs };
        const why = d && typeof d.error === "string" ? d.error.trim().slice(0, 160) : "";
        return { error: why || LOST, email: r.status === 400 && /email/i.test(why) };
      }, () => ({ error: LOST }))
      .then((v) => { clearTimeout(timer); return v; });
  }
  function wait(on) { busy = on; ask.setAttribute("aria-disabled", String(on)); form.setAttribute("aria-busy", String(on)); }
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    if (busy) return;
    const email = field.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { field.setAttribute("aria-invalid", "true"); tell("enter an email address"); field.focus(); return; }
    field.removeAttribute("aria-invalid");
    if (!really) { tell("the trial is not open yet"); return; }
    tell("");
    wait(true);
    trial(email).then((d) => {
      wait(false);
      if (!d.files) {
        tell(d.error);
        if (d.email) { field.setAttribute("aria-invalid", "true"); field.focus(); }
        return;
      }
      files = d.files; sentTo = email; got = Date.now();
      paint();
      form.hidden = true; done.hidden = false;
      const a = dl.querySelector("a");
      if (a) a.focus({ preventScroll: true });
    });
  });
  field.addEventListener("input", () => { if (field.hasAttribute("aria-invalid")) { field.removeAttribute("aria-invalid"); tell(""); } });

  // the two installers: the visitor's system first, in the accent, the other
  // in a hairline; each named by its system, with its size, the pill's arrow
  // turned to point down
  const SVG = "http://www.w3.org/2000/svg";
  function weigh(bytes) {
    const mb = (+bytes || 0) / 1048576;
    if (!mb) return "";
    if (mb >= 1024) return `${(mb / 1024).toFixed(2)} GB`;
    if (mb >= 1) return `${Math.round(mb)} MB`;
    return `${Math.max(1, Math.round(mb * 1024))} KB`;
  }
  function arrow() {
    const s = document.createElementNS(SVG, "svg");
    s.setAttribute("class", "arr"); s.setAttribute("viewBox", "0 0 14 24"); s.setAttribute("aria-hidden", "true");
    [["sh", "M7 0V23"], ["", "M1 17l6 6 6-6"]].forEach(([c, d]) => { const p = document.createElementNS(SVG, "path"); if (c) p.setAttribute("class", c); p.setAttribute("d", d); s.appendChild(p); });
    return s;
  }
  function paint() {
    const fs = files.slice().sort((a, b) => (b.platform === mine) - (a.platform === mine));
    dl.textContent = "";
    fs.forEach((f, i) => {
      const a = document.createElement("a");
      a.className = i ? "talt tpill" : "go tpill";
      a.href = f.url;
      a.dataset.platform = f.platform;
      // (named by the server too; a browser that follows a link takes this one)
      if (f.name) a.setAttribute("download", String(f.name));
      const lb = document.createElement("span"); lb.className = "lb"; lb.textContent = f.platform;
      a.appendChild(lb);
      const w = weigh(f.size);
      if (w) { const sz = document.createElement("span"); sz.className = "sz"; sz.textContent = w; a.appendChild(sz); }
      a.appendChild(arrow());
      dl.appendChild(a);
    });
    em.textContent = sentTo;
  }
  // (a link is good for fifteen minutes: one pressed later than that is
  // asked for again first, then followed)
  dl.addEventListener("click", (e) => {
    const a = e.target.closest("a");
    if (!a || Date.now() - got < 13 * 60000) return;
    e.preventDefault();
    if (busy) return;
    busy = true; tell("");
    const p = a.dataset.platform;
    trial(sentTo).then((d) => {
      busy = false;
      if (!d.files) { tell(d.error); return; }
      files = d.files; got = Date.now();
      paint();
      const again = dl.querySelector(`[data-platform="${p}"]`);
      if (again) { again.focus({ preventScroll: true }); location.href = again.href; }
    });
  });

  // on a phone: the page's link to take to a computer (copied as the
  // system allows; where it cannot be, it is written out in the quiet line)
  function legacy(text) {
    const t = document.createElement("textarea");
    t.value = text; t.setAttribute("readonly", ""); t.style.cssText = "position:fixed;left:0;top:0;width:1px;height:1px;opacity:0;";
    sheet.appendChild(t); t.select(); t.setSelectionRange(0, text.length);
    let ok = false;
    try { ok = document.execCommand("copy"); } catch (e) {}
    t.remove(); copyB.focus({ preventScroll: true });
    return ok;
  }
  copyB.addEventListener("click", () => {
    const link = `${location.href.split("#")[0]}#try`;
    // (the pill keeps its size while its word changes)
    const ok = () => { tell(""); copyB.style.minWidth = `${copyB.offsetWidth}px`; copyL.textContent = "copied"; clearTimeout(copied); copied = setTimeout(() => { copyL.textContent = "copy the link"; }, 2400); };
    const no = () => { if (legacy(link)) ok(); else tell(link); };
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) navigator.clipboard.writeText(link).then(ok, no); else no();
  });
})();
// ==scroll js==
// ============================================================================
// The scroll: the object travels (see the style, "the scroll").
// One loop, woken by the scroll and asleep once the page is still. The page
// itself scrolls exactly as it always does: what is to stay put on the
// screen is held there by the page (sticky), what rides the page lies in it.
// The scroll position is read as the page scrolls, and followed: a little
// behind, smoothly, for what lies on the page (never more than a little over
// half a screen behind — a link or the End key is followed at the page's own
// speed, never jumped); and on clocks of their own, never faster than they
// can be read, for the object and its parts, the object come back over the
// pill, and the specification drawing — so that a flick plays them through
// as they are meant to be seen, and a slow scroll moves them without a
// step. Each frame in one order, with the slab's own: what the scroll asks
// of the slab, the slab, then what follows it. Where things are on the page
// is read only when the page changes size.
// ============================================================================
(() => {
  "use strict";
  const root = document.getElementById("ob");
  const slab = root.__slab;
  if (!slab) return;
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  // (where the system draws its own colours, the page is as it always was)
  const forced = matchMedia("(forced-colors: active)").matches;
  const $ = (s, el = root) => el.querySelector(s), $$ = (s, el = root) => [...el.querySelectorAll(s)];
  const clamp01 = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);
  const lerp = (a, b, u) => a + (b - a) * u;
  const seg = (v, a, b) => clamp01((v - a) / (b - a));
  const smooth = (u) => { u = clamp01(u); return u * u * (3 - 2 * u); };
  const ease = (u) => { u = clamp01(u); return u < .5 ? 4 * u * u * u : 1 - Math.pow(-2 * u + 2, 3) / 2; };
  const out3 = (u) => 1 - Math.pow(1 - clamp01(u), 3);
  const out2 = (u) => 1 - Math.pow(1 - clamp01(u), 2);
  const dpr = () => Math.max(1, window.devicePixelRatio || 1);
  const rpx = (v) => Math.round(v * dpr()) / dpr();
  const f1 = (v) => v.toFixed(1), f2 = (v) => v.toFixed(2), f3 = (v) => v.toFixed(3);
  const narrow = matchMedia("(max-width: 700px)");
  // (the features' board in one column: see the style)
  const board1 = matchMedia("(max-width: 1100px)");
  const upright = matchMedia("(min-width: 701px) and (max-aspect-ratio: 20/23)");
  const coarse = matchMedia("(pointer: coarse)");
  const fitted = () => narrow.matches || upright.matches;
  // (a style written only when it changes)
  const put = (el, prop, v) => { const k = "_" + prop; if (el[k] !== v) { el[k] = v; el.style[prop] = v; } };
  const putVar = (el, name, v) => { const k = "_" + name; if (el[k] !== v) { el[k] = v; el.style.setProperty(name, v); } };
  // (what fades and moves is a layer of its own from a little before it
  // moves until the page is still again: made once on the way in, let go
  // only at rest — a layer made or dropped mid-scroll is a card painted
  // again, in the frame that can least afford it)
  const lifted = new Set();
  const moving = (el, on) => { el._near = on; if (on && !lifted.has(el)) { lifted.add(el); put(el, "willChange", "transform, opacity"); } };
  const letGo = () => lifted.forEach((el) => { if (!el._transform || !el._near) { put(el, "willChange", ""); lifted.delete(el); } });
  // A critically damped follower: it sets off and comes to rest without a
  // jolt — its speed changes smoothly — moved by the frame's own time in
  // small steps, and never faster than `cap` a second (or than `cap(x)`, a
  // speed that depends on where it is)
  function follower(w, eps) {
    const f = { x: 0, v: 0, to: 0,
      step(to, dt, cap = Infinity, ww = w) {
        f.to = to;
        const n = Math.max(1, Math.ceil(dt * 240)), h = dt / n;
        for (let i = 0; i < n; i++) {
          f.v += (ww * ww * (to - f.x) - 2 * ww * f.v) * h;
          const k = typeof cap === "function" ? cap(f.x) : cap;
          if (f.v > k) f.v = k; else if (f.v < -k) f.v = -k;
          f.x += f.v * h;
        }
        if (Math.abs(to - f.x) < eps && Math.abs(f.v) < eps * 10) { f.x = to; f.v = 0; }
        return f.x;
      },
      jump(x) { f.x = f.to = x; f.v = 0; return x; },
      get busy() { return f.x !== f.to || f.v !== 0; } };
    return f;
  }
  // (an idle moment, where the browser has one; soon, where it has not)
  const idle = (fn, ms = 200) => (window.requestIdleCallback ? requestIdleCallback(fn, { timeout: ms }) : setTimeout(fn, ms));

  // ---- the object, come back whole, over the pill ---------------------------------
  // A second slab, lighter than the first: the face a photograph (the first
  // preset's, as the hero starts), the engraved back, the rim, and the parts,
  // each over its own socket — the exploded view the page began with — which
  // come home one after another as the slab rises into its place, turns to
  // face you and settles, the pill under it. Built once it comes near, and
  // put in its first pose the moment it is built (never seen before that).
  function makeCoda() {
    const box = $(".coda");
    if (!box) return null;
    const cs = $(".cscene", box), th = $(".cthing", box), ground = $(".cground", box);
    const { FW, FH, ZONES, LIGHT, SHADES, PERSP } = slab;
    const lift0 = slab.EXPLODE.lift;
    let built = false, K = 2, W = 1, H = 1, DEP = 6, key = "", plates = [], rim = [], front = null, lastC = -1;
    const pre = [];
    const pct = (v, of) => `${(v / of) * 100}%`;
    const place = (el, [x, y, w, h]) => Object.assign(el.style, { left: pct(x, FW), top: pct(y, FH), width: pct(w, FW), height: pct(h, FH) });
    function build() {
      if (built) return;
      built = true;
      front = document.createElement("div"); front.className = "face front";
      const back = $(".thing .back").cloneNode(true);
      th.append(front, back);
      plates = Object.keys(ZONES).map((k) => {
        const rect = ZONES[k], vec = k === "orb";
        const el = document.createElement("div"); el.className = vec ? "plate orb" : "plate"; place(el, rect);
        const pf = document.createElement("i"); pf.className = "pf"; el.appendChild(pf);
        if (vec) pf.appendChild(slab.orbArt(rect));
        else { const pc = document.createElement("i"); pc.className = "pc"; const b = document.createElement("b"); b.className = "on"; pc.appendChild(b); pf.appendChild(pc); el.b = b; }
        th.appendChild(el);
        const sock = document.createElement("i"); sock.className = vec ? "socket round" : "socket rec"; place(sock, vec ? slab.ORB_SOCK : rect); front.appendChild(sock);
        const shade = vec ? null : document.createElement("i");
        if (shade) { shade.className = "pshade"; place(shade, rect); front.appendChild(shade); }
        return { k, rect, vec, el, pf, sock, shade, rim: [], css: "", o: "" };
      });
    }
    // sizes: laid out K times larger and brought down in the transform, as the first is
    function measure() {
      if (!built) return;
      lastC = -1;
      W = cs.offsetWidth || 1; H = W * 680 / 1100; DEP = Math.max(6, W * .024);
      K = dpr() >= 2 ? 1.5 : 2;
      const rad = Math.max(4, W * slab.RADIUS), prad = Math.max(2.5, W * slab.PRADIUS);
      th.style.inset = `${(-(K - 1) / 2) * 100}%`;
      const set = (n, v) => th.style.setProperty(n, v);
      set("--k", `${K}`); set("--w", `${W * K}px`); set("--h", `${H * K}px`); set("--half", `${(DEP * K) / 2}px`); set("--r", `${rad * K}px`); set("--pr", `${(prad * K).toFixed(2)}px`); set("--aa", `${2 * K}px`);
      cs.style.perspective = `${(W * PERSP).toFixed(0)}px`;
      const k2 = `${W}|${K}`;
      if (k2 === key) return;
      key = k2;
      // the photographs, at the size they are drawn at
      const d = dpr(), need = (K * W) / FW;
      const fsc = [.6, .8, 1.05, 1.4, 2].find((s) => s >= need / 1.08) || 2;
      front.style.backgroundImage = `url("${slab.IMG(0, fsc)}")`;
      const psc = slab.pickPlate(Math.max(need, (W / FW) * d * 1.2));
      plates.forEach((p) => { if (p.el.b) p.el.b.style.backgroundImage = `url("${slab.PIMG(p.k, 0, psc)}")`; p.css = p.o = p.sc = ""; p.shaded = false; });
      // (its photographs fetched and decoded now, while it is not laid out:
      // not laid out, the page would not fetch them until it is shown)
      [slab.IMG(0, fsc), ...plates.filter((p) => p.el.b).map((p) => slab.PIMG(p.k, 0, psc))].forEach((u) => { const im = new Image(); im.src = u; if (im.decode) im.decode().catch(() => {}); pre.push(im); });
      // the rims: the slab's, then each plate's
      rim.forEach((s) => s.el.remove()); rim = [];
      // (fewer planes round each corner than the hero's: it is drawn smaller —
      // fewer still on a phone)
      rim = ring(th, W * K, H * K, rad * K, DEP * K, W < 520 ? 3 : 5, 0, "rim", .7 * K);
      const pt = Math.max(3, W * slab.PTHICK) * K;
      plates.forEach((p) => {
        p.rim.forEach((s) => s.el.remove()); p.rim = [];
        if (p.vec) return;
        const LW = (W * K * p.rect[2]) / FW, LH = (H * K * p.rect[3]) / FH;
        p.rim = ring(p.el, LW, LH, Math.min(prad * K, LW / 2, LH / 2), pt, 2, -pt / 2, "prim", .6 * K, p.pf);
      });
    }
    // thin planes standing round a rounded outline (straight runs and a few chords at each corner)
    function ring(parent, LW, LH, R, d, n, z, cls, overlap, before) {
      const segs = [], add = (cx, cy, len, phi) => segs.push({ cx, cy, len, phi });
      add(0, -LH / 2, LW - 2 * R + overlap, -Math.PI / 2); add(LW / 2, 0, LH - 2 * R + overlap, 0);
      add(0, LH / 2, LW - 2 * R + overlap, Math.PI / 2); add(-LW / 2, 0, LH - 2 * R + overlap, Math.PI);
      const step = (Math.PI / 2) / n;
      for (const [ox, oy, a0] of [[LW / 2 - R, -LH / 2 + R, -Math.PI / 2], [LW / 2 - R, LH / 2 - R, 0], [-LW / 2 + R, LH / 2 - R, Math.PI / 2], [-LW / 2 + R, -LH / 2 + R, Math.PI]]) {
        for (let k = 0; k < n; k++) { const a = a0 + (k + .5) * step, rr = R * Math.cos(step / 2); add(ox + rr * Math.cos(a), oy + rr * Math.sin(a), 2 * R * Math.sin(step / 2) + overlap, a); }
      }
      const frag = document.createDocumentFragment(), out = [], pad = cls === "prim" ? 1 : 0;
      // (the slab's planes a hair inside its outline, as the hero's are)
      const tk = cls === "rim" ? slab.TUCK * K : 0;
      segs.forEach((s) => { s.cx -= tk * Math.cos(s.phi); s.cy -= tk * Math.sin(s.phi); });
      for (const s of segs) {
        const el = document.createElement("i"); el.className = cls;
        el.style.cssText = `left:${(LW / 2 + s.cx - s.len / 2 - pad).toFixed(2)}px;top:${(LH / 2 + s.cy - d / 2 - pad).toFixed(2)}px;width:${(s.len + 2 * pad).toFixed(2)}px;height:${(d + 2 * pad).toFixed(2)}px;transform:${z ? `translateZ(${z.toFixed(2)}px) ` : ""}rotateZ(${(s.phi + Math.PI / 2).toFixed(5)}rad) rotateX(90deg)`;
        frag.appendChild(el);
        out.push({ el, nx: Math.cos(s.phi), ny: Math.sin(s.phi), cx: s.cx, cy: s.cy, lv: -1, bg: "", flat: false, ov: -1 });
      }
      if (before) parent.insertBefore(frag, before); else parent.appendChild(frag);
      return out;
    }
    // the parts come home: the effects from the right, then B, A, and the orb last
    const REST_M = new DOMMatrix().rotateAxisAngleSelf(1, 0, 0, 28).rotateAxisAngleSelf(0, 1, 0, -8).rotateAxisAngleSelf(0, 0, 1, 1.5);
    const HOME = { fx4: [.3, .6], fx3: [.34, .64], fx2: [.38, .68], fx1: [.42, .72], fx0: [.46, .76], b: [.5, .8], a: [.55, .85], orb: [.62, .92] };
    // how fast its clock may run at c: a whole return in .6 s at the most,
    // but its turn — eased over the first .7, quickest a third of the way —
    // never faster than the slab's, about 2° a 60 Hz frame
    const cap = (c) => { const u = clamp01(c / .7), e = 12 * Math.min(u, 1 - u) ** 2; return Math.min(1 / .6, 1.8 / Math.max(e, 1e-3)); };
    // c: 0 as it comes into view, 1 home
    function render(c) {
      if (!built || Math.abs(c - lastC) < 1e-4) return;
      lastC = c;
      const a = ease(seg(c, 0, .7)), rise = out3(seg(c, 0, .72)), settle = smooth(seg(c, .78, 1));
      const rx = lerp(62, 31, a) - 3 * settle, ry = lerp(-30, -7, a) - 1 * settle, rz = lerp(-15, 1.5, a), s = lerp(.84, 1, ease(seg(c, 0, .8)));
      const y = (1 - rise) * H * .7;
      th.style.transform = `translate3d(0, ${y.toFixed(2)}px, 0) rotateX(${rx.toFixed(3)}deg) rotateY(${ry.toFixed(3)}deg) rotateZ(${rz.toFixed(3)}deg) scale3d(${(s / K).toFixed(5)}, ${(s / K).toFixed(5)}, ${(s / K).toFixed(5)})`;
      const M = new DOMMatrix().rotateAxisAngleSelf(1, 0, 0, rx).rotateAxisAngleSelf(0, 1, 0, ry).rotateAxisAngleSelf(0, 0, 1, rz);
      // the slab's rim, shaded by the room's light as the hero's is (in its
      // steps) — a plane turned well away from the eye not drawn, nor shaded,
      // until it comes back a good way before it could be seen (see the hero's)
      const rk = s / K, ez = -.04 * H, ed = W * PERSP;
      for (const r of rim) {
        const qx = M.m11 * r.nx + M.m21 * r.ny, qy = M.m12 * r.nx + M.m22 * r.ny, qz = M.m13 * r.nx + M.m23 * r.ny;
        const vx = -rk * (M.m11 * r.cx + M.m21 * r.cy), vy = ez - y - rk * (M.m12 * r.cx + M.m22 * r.cy), vz = ed - rk * (M.m13 * r.cx + M.m23 * r.cy);
        const cos = (qx * vx + qy * vy + qz * vz) / (Math.hypot(vx, vy, vz) || 1), away = r.away ? cos < -.15 : cos < -.2;
        if (away !== r.away) { r.away = away; r.el.style.visibility = away ? "hidden" : ""; }
        if (away) continue;
        const bg = slab.shadeOf(Math.max(0, qx * LIGHT[0] + qy * LIGHT[1] + qz * LIGHT[2]) * (1 - .6 * Math.max(0, qz)));
        if (bg !== r.bg) { r.bg = bg; r.el.style.background = bg; }
      }
      const half = DEP / 2;
      for (const p of plates) {
        const [h0, h1] = HOME[p.k], k = ease(seg(c, h0, h1)), L = lift0[p.k][1] * (1 - k);
        const z = half + .6 + L * W;
        const gz = 1 + .75 * clamp01(L / .045) + .5 * clamp01(L / lift0.orb[1]);
        const grow = p.vec ? ` scale(${gz.toFixed(3)})` : "";
        const css = `translate3d(0, 0, ${(z * K).toFixed(2)}px)${grow}`;
        if (css !== p.css) { p.css = css; p.el.style.transform = css; }
        // (seen off the slab, over the page, the orb wears the page's ink, as the hero's does)
        if (p.vec) {
          const kA = ease(seg(c, HOME.a[0], HOME.a[1])), off = slab.orbOff(M, s, y, W, H, half, 0, 0, z, gz, [0, 0, half + .6 + lift0.a[1] * (1 - kA) * W]);
          const ov = `${Math.round(off * 100)}%`;
          if (ov !== p.ov) { p.ov = ov; p.pf.firstChild.style.setProperty("--off", ov); }
        }
        const up = L > .0015, o = up ? "1" : "0";
        if (o !== p.o) { p.o = o; p.pf.style.opacity = o; p.el.classList.toggle("up", up); }
        // (its socket, its shadow: written only when they change, as the hero's are)
        const so = clamp01(L / .004).toFixed(3), u = smooth(L / .08);
        const sc = `${so}|${p.vec ? `${clamp01(L / .02).toFixed(3)}|${clamp01(L / .045).toFixed(2)}` : `${(1 - u).toFixed(3)}|${u.toFixed(3)}`}`;
        if (sc !== p.sc) {
          p.sc = sc;
          p.sock.style.opacity = so;
          if (p.vec) { p.sock.style.setProperty("--sh", clamp01(L / .02).toFixed(3)); p.sock.style.setProperty("--so", clamp01(L / .045).toFixed(2)); }
          if (p.shade) { p.shade.style.opacity = so; p.shade.style.setProperty("--n", (1 - u).toFixed(3)); p.shade.style.setProperty("--f", u.toFixed(3)); }
        }
        // (a plate's rim is shaded once, as the slab holds it at rest: small
        // as it is here, it need not follow the light every frame)
        if (up && p.rim.length && !p.shaded) { p.shaded = true; slab.shadeRimAs(p.rim, REST_M, [0, -.2, .98]); }
      }
      if (ground) { ground.style.opacity = (seg(c, .25, .9) * .9).toFixed(3); ground.style.transform = `translate3d(0, ${(y * .15).toFixed(1)}px, 0) scale(${lerp(.7, 1, a).toFixed(3)}, ${lerp(.5, 1, a).toFixed(3)})`; }
      // (seen only once it is in a pose: laid out, it is twice its size and flat)
      th.classList.add("on");
    }
    // (built ahead of time, but not laid out at all — none of its planes left
    // for the compositor — until it is about to come into view)
    let shown = null;
    function show(on) { if (on === shown) return; shown = on; th.style.display = on ? "" : "none"; if (ground) ground.style.display = on ? "" : "none"; if (on) { lastC = -1; } }
    return { build, measure, render, show, box, cap, get built() { return built; }, get shown() { return shown === true; } };
  }
  const coda = makeCoda();
  // With reduced motion the page is the page as it was, everything where it
  // ends: the object over the pill stands there, whole, and nothing moves.
  if (reduce || forced) {
    if (coda) {
      const still = () => { coda.build(); coda.measure(); coda.render(1); };
      still(); addEventListener("resize", still);
    }
    return;
  }
  root.classList.add("trav");
  // (where the browser runs animations on the scroll itself, the flat things
  // that come up with it — the words, the cards, the player, the questions —
  // are left to it: see .sd in the style)
  let sd = false;
  try { sd = CSS.supports("(animation-timeline: view()) and (timeline-scope: --a)"); } catch (e) {}
  root.classList.toggle("sd", sd);
  // (a part the scroll's own animation moves, or not — its own style cleared
  // as it is handed over)
  const byScroll = (el, on, clear) => { if (el.classList.contains("sd") === on) return; el.classList.toggle("sd", on); if (on) clear.forEach(([e, p]) => put(e, p, "")); };
  const T = slab.T;
  // (what the scroll has moved is put back for the length of a measure: the
  // films' frames and the effects' lines are laid by what the page lays out)
  root.__bare = (el, fn) => {
    const up = [];
    for (let e = el; e && e !== root; e = e.parentElement) if (e.style && (e.style.transform || e.style.clipPath)) up.push(e);
    if (!up.length) return fn();
    const was = up.map((e) => [e.style.transform, e.style.clipPath]);
    up.forEach((e) => { e.style.transform = "none"; e.style.clipPath = "none"; });
    try { return fn(); } finally { up.forEach((e, i) => { e.style.transform = was[i][0]; e.style.clipPath = was[i][1]; }); }
  };

  const hero = $(".hero"), rail = $(".rail"), scene = $("#scene");
  // a page offset, from the layout alone (a transform never moves it)
  const pageOf = (el) => { let x = 0, y = 0; for (let e = el; e && e !== root; e = e.offsetParent) { x += e.offsetLeft; y += e.offsetTop; } return { x, y, w: el.offsetWidth, h: el.offsetHeight }; };

  // whatever the keyboard is on is shown as it ends, however far the scroll
  // has brought it: nothing is ever focused half there
  let held = null;
  const hold = (el) => !!held && !!el && el.contains(held);

  // ---- the films ----------------------------------------------------------------
  // The sources' and SUMMON's: each is laid in before it plays (it plays only
  // once it is in — the chapters are told), and taken up again it starts from
  // its first frame the next time. Laid in, its frame is born from its
  // outline (see the chapters). (The effects' are not the scroll's: their
  // cards are drawn in by a hairline, as on the page without it.)
  const FILMS = root.__films || {};
  const shots = $$('[data-shot="sources"], [data-shot="summon"]').map((el) => ({ el, key: el.dataset.shot, fl: $(".fl", el), fso: $(".fso", el), video: $("video", el), docked: null, q: -1, r: null, b0: null, rad: 5 }));
  const dock = (s, on) => {
    const v = on ? "1" : "0";
    if (s.docked === v) return;
    s.docked = v; s.el.dataset.docked = v;
    if (on) s.el.dataset.born = "1";
    else {
      delete s.el.dataset.born;
      const vd = s.video;
      try { if (vd && vd.readyState > 0) { vd.pause(); vd.currentTime = 0; } } catch (e) {}
    }
    // (what the chapters do when a film is laid in — measure its frame,
    // start its film — is done just after this frame is drawn, never in it)
    clearTimeout(s.told);
    s.told = setTimeout(() => s.el.dispatchEvent(new Event("halo:dock")), 0);
  };
  shots.forEach((s) => { s.el.dataset.docked = "0"; s.docked = "0"; });
  const SRC = shots.find((s) => s.key === "sources");
  const cut = (s) => { const c = FILMS[s.key]; return c && ((narrow.matches && c.m) || c.d); };

  // ---- the parts carried on: the two sources, from the slab to their film ----
  // A copy of each plate as the slab draws it — its face, its rounded corners,
  // its rim — laid in the page, not in the slab: it starts exactly where the
  // slab's own is (the same transform, seen from the same eye) and ends lying
  // flat in the film, on the film's own pixels, wearing the film's own first
  // frame, where each of the two lands in it (the plates lie on 775 x 202 of
  // its 779 x 472, at these places).
  const LAND = { a: [2, 3.5], b: [2, 264.5] };
  const travel = document.createElement("div");
  travel.className = "travel"; travel.setAttribute("aria-hidden", "true");
  root.appendChild(travel);
  const carried = { a: null, b: null };
  const poster = () => { const img = SRC && $("img", SRC.el); return img ? img.getAttribute("src") : ""; };
  // (made while the page is idle, before it is needed — a copy made as the
  // flight sets off is a frame missed there — and made again only when the
  // slab's own plate is: its rim changes with the slab's size)
  function copy(key) {
    const p = slab.P[key], d = slab.dims(), rk = `${d.W}x${d.H}|${d.K}|${p.rim.length}|${p.ptL}`;
    let c = carried[key];
    if (c && c.rk === rk) return c;
    if (c) { c.el.remove(); c.sh.remove(); }
    const el = p.el.cloneNode(true);
    el.style.visibility = ""; el.style.transform = ""; el.style.left = el.style.top = "0"; el.style.display = "none"; el.classList.add("up");
    const pf = $(".pf", el); if (pf) pf.style.opacity = "1";
    const pc = $(".pc", el), ff = document.createElement("b");
    ff.className = "ff"; ff.style.opacity = "0";
    ff.style.backgroundImage = `url("${poster()}")`;
    ff.style.backgroundPosition = `50% ${((LAND[key][1] / (472 - 202)) * 100).toFixed(3)}%`;
    if (pc) pc.appendChild(ff);
    const prims = $$(".prim", el);
    el.classList.remove("low", "gone");
    prims.forEach((e, i) => { const s = p.rim[i]; e.style.display = ""; if (s) e.style.transform = `translateZ(${(-p.ptL / 2).toFixed(2)}px) ${s.rot}`; });
    const rim = p.rim.map((s, i) => ({ el: prims[i], nx: s.nx, ny: s.ny, bg: "", flat: false, ov: -1 }));
    const sh = document.createElement("i"); sh.className = "cshade"; sh.style.display = "none";
    travel.append(sh, el);
    c = carried[key] = { el, pc, rim, face: "", sh, ff, css: "", rk, bs: pc ? [...pc.querySelectorAll("b:not(.ff)")] : [] };
    return c;
  }
  function carry(key) {
    const p = slab.P[key];
    const face = p.url[p.shown];
    if (!face) return null;
    const c = copy(key);
    // (the face it wears: the slab's plate's own, dressed again where it has
    // changed — never a copy made again)
    if (c.face !== face) {
      c.face = face;
      c.bs.forEach((b, j) => { const bi = p.layers[j]; if (!bi) return; if (b.style.backgroundImage !== bi.style.backgroundImage) b.style.backgroundImage = bi.style.backgroundImage; b.classList.toggle("on", j === p.shown); });
    }
    return c;
  }
  // the parts' own custom properties (their corners, their clear margin), as the slab has them
  const syncVars = () => { const th = $("#thing"); ["--pr", "--aa", "--w", "--k"].forEach((n) => travel.style.setProperty(n, th.style.getPropertyValue(n))); };

  // a rotation matrix's quaternion [w, x, y, z]; the way from it to no turn at all; and back to an axis and an angle
  function quat(m, s) {
    const a = m.m11 / s, b = m.m21 / s, c = m.m31 / s, d = m.m12 / s, e = m.m22 / s, f = m.m32 / s, g = m.m13 / s, h = m.m23 / s, k = m.m33 / s;
    const tr = a + e + k;
    let q;
    if (tr > 0) { const r = .5 / Math.sqrt(tr + 1); q = [.25 / r, (h - f) * r, (c - g) * r, (d - b) * r]; }
    else if (a > e && a > k) { const r = 2 * Math.sqrt(1 + a - e - k); q = [(h - f) / r, .25 * r, (b + d) / r, (c + g) / r]; }
    else if (e > k) { const r = 2 * Math.sqrt(1 + e - a - k); q = [(c - g) / r, (b + d) / r, .25 * r, (f + h) / r]; }
    else { const r = 2 * Math.sqrt(1 + k - a - e); q = [(d - b) / r, (c + g) / r, (f + h) / r, .25 * r]; }
    const n = Math.hypot(...q); return q.map((v) => v / n);
  }
  function slerpId(q, u) {
    let [w, x, y, z] = q;
    if (w < 0) { w = -w; x = -x; y = -y; z = -z; }
    const th = Math.acos(Math.min(1, w));
    if (th < 1e-5) return [1, 0, 0, 0];
    const s0 = Math.sin((1 - u) * th) / Math.sin(th), s1 = Math.sin(u * th) / Math.sin(th);
    return [w * s0 + s1, x * s0, y * s0, z * s0];
  }
  const axisAngle = (q) => { const [w, x, y, z] = q, s = Math.hypot(x, y, z); return s < 1e-7 ? [0, 0, 1, 0] : [x / s, y / s, z / s, 2 * Math.atan2(s, w)]; };

  // ---- the section words ---------------------------------------------------------
  const titles = $$(".ttl").map((el) => {
    const h2 = $("h2", el), cw = document.createElement("i"), cur = document.createElement("i");
    cw.className = "cw"; cw.setAttribute("aria-hidden", "true"); cur.className = "cur"; cw.appendChild(cur); h2.appendChild(cw);
    return { el, h2, cw, cur, ix: $(".ix", el), feat: !!el.closest(".feat"), top: 0, ww: 0 };
  });

  // ---- the cards, listen, the specifications, the questions, the pill ------------
  // (the board's cards, each by its own top: a row of them comes up together;
  // the effects' are not among them — they are drawn in, and never move)
  const benches = $$(".board .card[data-r]").map((el) => ({ el, top: 0, h: 0 }));
  const la = $("#la");
  // (the questions: the two lines at their side and each question's row —
  // its number, its words, its cross and the hairline under it — uncovered by
  // the titles' own curtain, one after another as they come up; inside a
  // window as wide as the row, which clips it)
  const rows = $$(".qa .side > p, .qa .q").map((el) => {
    const host = el.matches(".q") ? $("summary", el) : el, cw = document.createElement("i"), cur = document.createElement("i");
    cw.className = "cw"; cw.setAttribute("aria-hidden", "true"); cur.className = "cur"; cw.appendChild(cur); host.appendChild(cw);
    return { el, host, cw, cur, top: 0, w: 0, e: 0 };
  });
  // (each line of the list uncovered by the titles' own curtain, as its part is drawn)
  const specLis = $$(".spec ul li").map((el) => { const cur = document.createElement("i"); cur.className = "cur"; cur.setAttribute("aria-hidden", "true"); el.appendChild(cur); return { el, cur, k: +el.dataset.step || 0, j: 0, n: 1, top: 0, tw: 0, g: 0 }; });
  specLis.forEach((l) => { const same = specLis.filter((m) => m.k === l.k); l.j = same.indexOf(l); l.n = same.length; });
  const drawing = $(".spec .drawing"), dsvg = drawing && $("svg", drawing);
  const pair = $(".buy .pair"), go = $(".buy .go"), from = $(".buy .from");
  // (the pill, its price and the trial's line under them come up as one)
  const rise = [go, from, $(".buy .try")].filter(Boolean);
  // the drawing, part by part in the order the list names them: each part's
  // strokes from its left, each with its own length; its words and solid keys
  // brought up with it
  const WEIGHT = [1.35, 1.35, .8, 1.3, 1, .85, 1.1, .6], CUM = [0];
  // (the least time a line's curtain takes to cross it, in s)
  const LINE = .2;
  // (and a film's window never opened, nor shut, faster than this, in s)
  const OPEN = .4;
  WEIGHT.forEach((w, i) => CUM.push(CUM[i] + w / WEIGHT.reduce((a, b) => a + b, 0)));
  const parts = dsvg ? $$("g[data-step]", dsvg).map((g) => ({ g, k: +g.dataset.step, ms: $$(".st, .tx, .kf", g).map((e) => ({ e, st: e.classList.contains("st"), len: 0, s: 0, css: "" })) })) : [];

  // ---- the geometry, read when the page changes size ---------------------------------
  let G = null;
  function layout() {
    const vw = document.documentElement.clientWidth;
    let vh = window.innerHeight;
    // (a phone's or a tablet's bars coming and going are not a new screen:
    // the page keeps its length, and nothing moves under the reader)
    if (G && (narrow.matches || coarse.matches) && vw === G.vw && Math.abs(vh - G.vh) < 160) vh = G.vh;
    // (the hero is held a screen's worth only where it fits the screen: a
    // phone held across, or a window too short for it, takes the phone's way
    // instead — held only while the object comes apart, the features drawn
    // up under it by as much — rather than hold a hero taller than the
    // screen, its tabs below it and a screen of nothing after it)
    const pin = !fitted() && vh >= 600;
    const run = pin ? Math.round(vh * .6) : 0;
    root.classList.toggle("pin", pin);
    root.style.setProperty("--run", `${run}px`);
    // (the sources fly down to their film only where the board lays its card
    // beside the one of their words, just under the features word: where the
    // board is one column — a tablet, a small window, a phone held across —
    // it opens from card A instead)
    const g = { vw, vh, pin, run, fly: pin && !board1.matches, heroH: hero.offsetHeight };
    // (widened past it, or a tablet turned, with the sources' film opened
    // from card A part of the way: what the opening left on the film's box
    // goes — the flight carries it only its own way, see there)
    if (g.fly && SRC && (SRC.opening || SRC.el._transform || SRC.el._visibility)) {
      SRC.opening = false; SRC.el.classList.remove("opening"); SRC.st = null;
      put(SRC.el, "transform", ""); put(SRC.fl, "transform", ""); put(SRC.el, "visibility", "");
    }
    // the scene, in the hero (which is held at the top of the screen while the runway lasts)
    let sy = 0, sx = 0;
    for (let e = scene; e && e !== hero; e = e.offsetParent) { sy += e.offsetTop; sx += e.offsetLeft; }
    g.scene = { x: sx, y: sy, w: scene.offsetWidth, h: scene.offsetHeight };
    shots.forEach((s) => {
      s.r = pageOf(s.el); s.q = -1;
      s.rad = parseFloat(getComputedStyle(s.el).borderTopLeftRadius) || 5;
      // where it opens from: the part its first words are about, as a share of the film
      const v = cut(s), c = FILMS[s.key], bx = v && c && v.boxes && v.boxes[c.cues[0][1]];
      s.b0 = bx ? [bx[0] / v.size[0], bx[1] / v.size[1], (bx[0] + bx[2]) / v.size[0], (bx[1] + bx[3]) / v.size[1]] : [.45, .45, .55, .55];
    });
    titles.forEach((t) => {
      const r = pageOf(t.el);
      t.top = r.y; t.rule = r.y + r.h; t.ruleL = r.x; t.ruleW = r.w;
      if (t.ix) { const q = pageOf(t.ix); t.ixB = q.y + q.h; }
      // the word's own width, where the curtain's soft edge ends
      const rg = document.createRange(); rg.selectNodeContents(t.h2.firstChild || t.h2);
      t.ww = rg.getBoundingClientRect().width || t.h2.offsetWidth;
      t.cur.style.width = `${Math.ceil(t.ww * 1.5) + 4}px`;
      t.cw.style.width = `${Math.ceil(t.ww) + 6}px`;
      // (what the page shows as it opens is there as it ends: nothing on the
      // first screen waits for a scroll to be finished — a phone's first word)
      t.pre = t.top - vh * .95 < 0;
      putVar(t.cur, "--ww", `${f1(t.ww)}px`);
      t.sd = sd && !t.pre;
      byScroll(t.el, t.sd, [[t.cur, "transform"], [t.cw, "display"], [t.h2, "transform"]]);
    });
    benches.forEach((b) => {
      const r = pageOf(b.el); b.top = r.y; b.h = r.h; b.pre = b.top - vh * 1.02 < 0;
      b.sd = sd && !b.pre;
      byScroll(b.el, b.sd, [[b.el, "transform"], [b.el, "opacity"]]);
    });
    g.la = la ? pageOf(la).y : 0;
    if (la) { la.sd = sd && g.la - vh >= 0; byScroll(la, la.sd, [[la, "transform"], [la, "opacity"]]); }
    root.style.setProperty("--sv", `${vh}px`);
    specLis.forEach((l) => {
      l.top = pageOf(l.el).y;
      const rg = document.createRange(); rg.selectNodeContents(l.el.firstChild || l.el); l.tw = Math.ceil(rg.getBoundingClientRect().width) + 2;
      l.cur.style.width = `${Math.ceil(l.tw * 1.5) + 4}px`;
    });
    // (a row's curtain as wide as the row, and its soft edge as the word's is,
    // half of what it uncovers — no wider than a long word's, across a row)
    rows.forEach((r) => {
      r.top = pageOf(r.host).y;
      if (r.host === r.el) { const rg = document.createRange(); rg.selectNodeContents(r.el); r.w = Math.ceil(rg.getBoundingClientRect().width) + 2; }
      else r.w = r.host.clientWidth;
      r.e = Math.round(Math.min(r.w * .5, 220));
      r.cur.style.width = `${r.w + r.e + 4}px`;
      putVar(r.cur, "--ce", `${r.e}px`);
      putVar(r.cur, "--rw", `${r.w}px`);
      r.pre = r.top - vh * .95 < 0;
      r.sd = sd && !r.pre;
      byScroll(r.el, r.sd, [[r.cur, "transform"], [r.cw, "display"]]);
    });
    if (dsvg) {
      const r = pageOf(drawing);
      // the lines as thick as ever: 1.15 of the screen's pixels in the drawing's own units
      const k = r.w / 2240;
      drawing.style.setProperty("--sw", (1.15 / Math.max(.05, k)).toFixed(3));
      parts.forEach((pt) => {
        const xs = pt.ms.map((m) => { let x = 0; try { x = m.e.getBBox().x; } catch (e) {} return x; }), lo = Math.min(...xs), hi = Math.max(...xs);
        pt.ms.forEach((m, i) => {
          m.s = ((xs[i] - lo) / Math.max(1, hi - lo)) * .5;
          if (m.st && !m.len) { try { m.len = m.e.getTotalLength(); } catch (e) { m.len = 0; } m.css = ""; }
        });
      });
      // drawn from its top coming up the screen (or the list's, if higher) to
      // its top at the middle of the screen (a little lower on a phone)
      const t0 = Math.min(r.y, specLis.length ? specLis[0].top : r.y);
      g.draw = { top: r.y, h: r.h, a: Math.min(t0 - vh * .9, r.y - vh * .98), b: r.y - vh * (pin ? .46 : .62) };
      if (g.draw.b < g.draw.a + vh * .4) g.draw.b = g.draw.a + vh * .4;
    }
    g.go = go ? pageOf(go).y : 0;
    g.max = document.documentElement.scrollHeight - vh;
    if (coda) {
      const r = pageOf(coda.box);
      const a = r.y - vh * .9;
      g.coda = { a, b: Math.max(a + vh * .4, Math.min(r.y + r.h / 2 - vh * .46, g.max - Math.round(vh * .08))) };
      if (coda.built) coda.measure();
    }
    // where a link lands: its section's word near the top of the screen, and
    // where something is put together there, on it whole
    const M = pin ? 56 : 28, tt = (sel) => { const t = titles.find((x) => x.el === $(sel)); return t ? t.top : null; };
    const fT = tt("#features .ttl"), lT = tt("#listen .ttl"), sT = tt("#specs .ttl");
    g.anchors = {};
    if (fT != null) g.anchors.features = fT - M;
    // (where the two sources fly to their film, it is whole on the screen by
    // then — its foot a little above the screen's — however near the top that
    // takes the word: never nearer than a few pixels)
    if (fT != null && g.fly && SRC) g.anchors.features = Math.min(Math.max(fT - M, SRC.r.y + SRC.r.h - vh + 40), fT - 8);
    if (lT != null) g.anchors.listen = lT - M;
    if (sT != null) g.anchors.specs = Math.min(Math.max(sT - M, g.draw ? g.draw.b : 0), sT - 12);
    // (where the sources' film opens from card A rather than being flown to —
    // a phone, a tablet, a narrow window — it is whole by the time the
    // features' link lands: its word near the top, the film low on the screen)
    g.srcBy = !g.fly && g.anchors.features != null ? Math.max(0, Math.min(g.anchors.features, g.max) - 4) : null;
    // (where the hero is not held — a phone, an upright tablet — how far the
    // object goes down while it comes apart, the name and the tabs going:
    // into the middle of the screen; and how far the page moves meanwhile,
    // lagged by it: until the features' word, coming up from under the
    // fold, is a fifth of a screen under it — then it is on its way)
    const sq = pageOf(scene), sC = sq.y + sq.h / 2, sB = sq.y + sq.h;
    g.sink = pin ? 0 : Math.max(g.heroH * .06, vh * .5 - sC);
    g.lag = pin ? 0 : fT != null ? Math.max(160, Math.min(420, (fT - sB - g.sink - vh * .2) / .94)) : Math.min(260, g.heroH * .55);
    // (held by the page while it comes apart: a runway as long as the hold,
    // the features drawn up by as much — see the style. Measured above with
    // no runway at all, so that what was read is where the page lays it)
    root.classList.toggle("hold", !pin);
    if (!pin) root.style.setProperty("--run", `${Math.round(g.lag)}px`);
    // the object's own clock (see the scroll, "every frame"): how long it is
    // held, and how long it takes to go on its way, in scroll px; and the
    // least time the hold may be played in, at a steady pace
    g.hold = pin ? run : Math.round(g.lag);
    g.depSpan = pin ? vh * .75 : g.heroH * .6;
    // (on a phone, held by the page for only a fifth of a screen, a little
    // sooner: a brisk flick has it off the screen in a quarter of a second)
    g.tHold = pin ? .86 : .75;
    // (and past where nothing it draws changes any more, it is not played at
    // all: gone on a wide screen; on a phone, once it has drifted its last —
    // coming back up, it sets off home as soon as it can be seen)
    g.cMax = pin ? 2 : 2 + Math.max(0, g.heroH - g.depSpan) / vh;
    // (and how closely it follows: on a wide screen a little more loosely,
    // so that a mouse wheel's notches, a few tenths of a second apart, run
    // into one another rather than each start and stop)
    g.ofW = pin ? 9 : 12;
    // where the sources' two plates land: the film, and in it their own boxes;
    // they are in by the time the features' link would bring the page there
    // (they set off as the hold ends, a little before the hero lets go, so the
    // way down is long and slow)
    if (SRC) {
      const r = SRC.r, k = r.w / 779;
      g.land = Object.fromEntries(Object.entries(LAND).map(([key, [x, y]]) => [key, { x: r.x + x * k, y: r.y + y * k, w: 775 * k, h: 202 * k }]));
      g.flyFrom = Math.round(run * .8);
      g.landAt = Math.max(run + vh * .6, Math.min(r.y + r.h / 2 - vh * .54, g.anchors.features != null ? g.anchors.features - 2 : Infinity));
      // (how far above the screen's foot the film's lies as they land, less a
      // clear margin: all they may ride down with the page before it — until
      // then they wait on the screen, however low the film still is)
      g.room = Math.max(2, vh - 20 - (r.y + r.h - g.landAt));
      g.srcCard = benches.find((b) => b.el.contains(SRC.el)) || null;
      const ft = titles.find((t) => t.feat);
      // (how far below the features' rule the plates' upper edge comes to rest)
      g.clear = ft ? Math.max(40, Math.min(140, g.land.a.y - ft.rule - 12)) : 140;
    }
    G = g;
    syncVars();
  }
  root.__landAt = (el) => {
    const y = G && G.anchors[el.id];
    return y == null ? null : Math.round(Math.max(0, Math.min(G.max, y)));
  };

  // ---- every frame the page moves ----------------------------------------------------
  // (the position is read as the page scrolls — the scroll event comes before
  // any frame callback has written a style, so the read costs nothing — and
  // when the page is laid out again; never in a frame, where it would make
  // the browser work its style out again first)
  // The page's position as its scroll event gives it (Yr); followed a little
  // behind for what lies on the page (SF: S); and the object's own place in
  // its choreography (OF: c) and on its way off (DP: d), the coda's (CF), the
  // drawing's (DF) and the two sources' flight down to their film (FL: see
  // before), each followed from where the page really is.
  const SF = follower(18, .2), OF = follower(12, 1e-4), DP = follower(12, 1e-4), CF = follower(12, 1e-4), DF = follower(12, 1e-4), TF = follower(12, 1e-4), FL = follower(12, 1e-4), PA = follower(18, 1e-4), PB = follower(18, 1e-4);
  // (the drawing's turn on a clock of its own, never faster than the slab's, about 2° a 60 Hz frame)
  const dcap = (P) => { const u = seg(P, .08, .62), e = 12 * Math.min(u, 1 - u) ** 2; return Math.min(1, 1.15 / Math.max(e, 1e-3)); };
  let S = SF.jump(window.scrollY), Yr = S, raf = 0, last = 0, dt = 1 / 60, follow = false, tKey = "", kD = 1, awayWas = null, freeWas = null, flyE = 0, railU = 0, kF = 1;
  // (the slab laid aside while it is well above the screen: see before)
  let sceneAway = false, sceneAsked = false, sceneEdge = 0, sceneY = 0, sceneV = 0;
  // the object's place in its choreography, from a page position: 0..1 held
  // and coming apart, 1..2 on its way, 2 and on gone
  const chor = (y) => { const h = G.hold, d = G.depSpan; y = Math.max(0, y); return y <= h ? y / h : y <= h + d ? 1 + (y - h) / d : 2 + (y - h - d) / G.vh; };
  // What the scroll asks of the slab this frame — worked out before the slab
  // is drawn, in the same frame (see the slab's step).
  function before(now) {
    // (a frame after a long pause is taken as one frame)
    dt = last && now - last < 100 ? Math.min(.066, Math.max(0, (now - last) / 1000)) : 1 / 60;
    last = now;
    if (!G) return;
    const y = Yr, vh = G.vh;
    // the page's own things: followed a little behind, and never more than
    // .6 of a screen behind — a long way (a link, a key) is followed at the
    // page's own speed, never jumped, so nothing between is set at once
    S = SF.step(y, dt);
    // (and never faster than it can stop at the page: the way a jump left it going)
    { const Lm = .6 * vh; S = SF.x = y - Lm * Math.tanh((y - S) / Lm); if (SF.v * (y - S) > 0 && Math.abs(SF.v) > 18 * Math.abs(y - S)) SF.v = 18 * (y - S); }
    // the object: never played faster than it can be read — a whole hold in
    // G.tHold at the least (longer from a pose further from the exploded one,
    // so that it never turns faster), its way off in .45 s — from where the
    // page really is
    const cT = Math.min(chor(y), G.cMax), c0 = OF.x;
    if (c0 === 0 && cT > 0) { const g = slab.poseGap(G.pin); kD = Math.max(1, g / 18); kF = Math.max(1, Math.min(1.5, 11.4 / Math.max(1, g))); }   // (as it sets off)
    const cap = c0 < 1 ? 1 / (G.tHold * kD) : 1 / .45;
    // (where the page would have it done coming apart — by the time it has
    // taken the slab's upper edge to the top of the screen: on a wide screen,
    // where the page lets the hero go after its hold and the slab follows at
    // a quarter of its speed, and on a phone, where the page holds the hero)
    const edge = G.pin ? G.hold + G.scene.y / .75 : G.hold + G.scene.y + G.sink, lo0 = c0 < .6 ? .6 * clamp01(y / Math.max(1, edge)) : 0;
    let c = OF.step(cT, dt, cap, G.ofW);
    // (done by then — but on a wide screen never faster than one and a half
    // times its own pace, and less from a pose further off, so that the slab
    // never turns faster for it; on a phone never faster than twice the pace
    // of a whole hold, from whichever pose: the slab's own turn is held to
    // its pace in its frame)
    if (c < lo0) { const lo = Math.min(lo0, c0 + (G.pin ? kF * cap : 2 / G.tHold) * dt); if (c < lo) c = OF.x = lo; }
    // (its way off, on a clock of its own: let go once every part is out —
    // the orb last, at .76 — so that where the clock plays the hold's end
    // and the way off after the page has stopped past them, the last of the
    // turn runs on into the way off. On one clock the object came to a dead
    // stop between the two — each of them eases out and in there — and then
    // set off again. Where the page goes through slowly, the same as ever)
    const d = DP.step(c0 > .8 ? clamp01(cT - 1) : 0, dt, 1 / .45, G.ofW);
    const u = clamp01(c), dep = d, past = d * G.depSpan + Math.max(0, c - 2) * G.vh;
    T.on = y > .5 || S > .5;
    T.x = ease(seg(u, .02, .6));
    T.turn = smooth(seg(u, .45, 1)) * .7 + .3 * smooth(dep);
    T.dep = ease(dep);
    T.pin = G.pin;
    // (held on a wide screen, it follows the page at a quarter of its speed
    // once the hero lets go; on a phone the page holds the hero while it
    // comes apart, and all it does of its own is go a little down into the
    // middle of the screen, drift a hair up, and go on its way a little
    // faster than the page: see layout)
    T.ty = G.pin ? Math.max(0, y - G.run) * .25 : G.sink * ease(seg(u, .02, .6)) - .06 * G.lag * u - .12 * Math.min(past, G.heroH);
    // (and the eye rises over it as it comes apart, as far as the hero would
    // have been taken up the screen by then — see the slab's frame)
    T.eye = G.pin ? 0 : G.lag * u;
    const home = 1 - smooth(seg(dep, 0, .8)), px = T.px;
    // (one after another: the effects from the left, then B, A, and the orb last)
    for (let i = 0; i < 5; i++) px["fx" + i] = ease(seg(u, .08 + i * .045, .4 + i * .045)) * home;
    px.b = ease(seg(u, .26, .6)); px.a = ease(seg(u, .32, .66)); px.orb = ease(seg(u, .4, .76)) * home;
    // (where they do not fly, the sources settle home with the rest)
    // (where they do not fly — a phone — the sources' turn keeps its own pace:
    // a whole turn in .3 s at the fastest, however hard the flick or long the frame)
    if (!G.fly) { px.a = PA.step(px.a * home, dt, 1 / .3); px.b = PB.step(px.b * home, dt, 1 / .3); }
    else { PA.jump(px.a); PB.jump(px.b); }
    // the tabs go as it comes apart (held with the hero) — and, where the
    // page draws the features up under the held hero (a phone), by the time
    // the page itself has gone .6 of the hold, whatever the object's own
    // clock says: a flick brings the features' word up to the tabs long
    // before that clock has them gone
    let ur = G.pin ? u : Math.max(u, .28 * seg(y, 0, .45 * G.hold));
    // (a flick would take them in a frame: on their way out they go over four at least)
    if (!G.pin && ur > railU) ur = Math.min(ur, railU + .28 * dt / .066);
    railU = ur;
    const ro = hold(rail) ? 1 : 1 - smooth(ur / .28);
    moving(rail, (c > 0 && c < .4) || (ro > 0 && ro < 1));
    put(rail, "opacity", f3(ro));
    put(rail, "transform", ro < 1 && ro > 0 ? `translate3d(0, ${f2(u * 26)}px, 0)` : "");
    put(rail, "visibility", ro <= 0 ? "hidden" : "");
    // (a phone: once the page has left its top, a press goes through the held hero)
    const aw = !G.pin && y > 4;
    if (aw !== awayWas) { awayWas = aw; root.classList.toggle("away", aw); }
    // (while the object is played by the scroll — held, and where the page
    // holds the hero, on its way too — a turn or a new window size leaves
    // the page where it is: the browser would keep its place by what lies
    // under the held hero, and throw the page to its top or far down;
    // further on, it keeps the reader's place as it always does)
    const fr = y < G.hold + (G.pin ? 0 : G.depSpan);
    if (fr !== freeWas) { freeWas = fr; document.documentElement.style.overflowAnchor = fr ? "none" : ""; }
    // (where it is drawn now, for whether it can be seen: the hero's place on
    // the screen, the slab's in it)
    const top = Math.min(0, G.hold - y) + G.scene.y + T.ty;
    T.vis = top < vh * 1.25 && top + G.scene.h > -vh * .35;
    // (well above the screen, the page gone on past the hero, the slab is not
    // drawn at all: every plane of it, and the interface in its face, would
    // otherwise be laid out for the compositor again in every frame the page
    // moves anything. It is drawn again from an idle moment as the page comes
    // back toward it, and at once while it is still more than half a screen
    // away — never later: drawn again, its face is painted again)
    // (and as much further as the page, coming back up, would go in the
    // next 150 ms: a flick or a key back to the top never finds it undrawn)
    sceneV = Math.max(Math.max(0, (sceneY - y) / Math.max(dt, .004)), sceneV * Math.exp(-dt / .15)); sceneY = y;
    sceneEdge = top + G.scene.h + sceneV * .15;
    if (!sceneAway && sceneEdge < -vh * .9 && (!G.fly || flyE >= .9)) { sceneAway = true; put(scene, "visibility", "hidden"); }
    else if (sceneAway && sceneEdge > -vh * .6) layScene();
    else if (sceneAway && sceneEdge > -vh * .85) wantScene();
    // (out of sight, nothing is left to play: it is where the page says — but
    // never under a flight still setting off from it)
    if (!T.vis && (!G.fly || flyE >= .9)) { OF.jump(cT); DP.jump(clamp01(cT - 1)); PA.jump(PA.to); PB.jump(PB.to); }
    // (a film finishing at rest: see there)
    if (settling) { settling = false; for (const s of shots) if (s.st != null && s.st < 1) { s.st = Math.min(1, s.st + dt / SETTLE); if (s.st < 1) settling = true; } }
    // which sources the page has carried off the slab — decided before it is
    // drawn, so that in every frame one of the two draws each
    // (the flight on a clock of its own, followed from where the page is:
    // a whole flight in .6 s at the fastest — but never left behind by the
    // page once it is past their landing: at least as far on as the page
    // has gone past it, landed a screen and a half past it, so that the page
    // carries them off with their film rather than they are put away where
    // they can be seen)
    const eT = G.fly && SRC && G.land ? seg(S, G.flyFrom, G.landAt) : 0;
    let e = !G.fly || !G.land ? FL.jump(eT) : FL.step(eT, dt, 1 / .6);
    if (G.fly && G.land) { const lo = seg(y, G.landAt, G.landAt + 1.5 * vh); if (e < lo) { e = FL.x = lo; FL.v = 0; } }
    flyE = e;
    for (const k of ["a", "b"]) { const p = slab.P[k], on = e > 0 && !!p.url[p.shown]; T.gone[k] = on ? 1 : 0; T.away[k] = on ? smooth(seg(e, 0, .2)) : 0; }
    if (e <= 0 && flying) land(false);
    // (the slab draws this frame whenever anything it is asked has changed,
    // wherever it can be seen)
    const tk = `${f1(T.ty)}|${f1(T.eye)}|${f3(T.x)}|${f3(T.turn)}|${f3(T.dep)}|${f3(px.a)}|${f3(px.b)}|${f3(px.orb)}|${f3(px.fx0)}|${f3(px.fx4)}|${T.gone.a}${T.gone.b}|${f2(T.away.a)}|${T.vis}`;
    // (and wherever it is laid out to be)
    if (tk !== tKey) { tKey = tk; if (T.vis || !sceneAway) slab.keep(now); }
  }
  // What follows the slab as it is drawn: the parts carried off it, and the
  // page, from the positions worked out before it.
  function after(now) {
    if (!G) return;
    const y = Yr;
    render(S, y);
  }
  function tick(now) {
    raf = 0;
    slab.step(now);   // (before, the slab, after: once a frame, whichever loop comes to it first)
    if (SF.busy || OF.busy || DP.busy || CF.busy || DF.busy || TF.busy || FL.busy || PA.busy || PB.busy || follow || settling) raf = requestAnimationFrame(tick);
  }
  slab.before = before; slab.after = after;
  const wake = () => { if (!raf) raf = requestAnimationFrame(tick); };
  addEventListener("scroll", () => { Yr = window.scrollY; wake(); restSoon(); }, { passive: true });
  // (and whenever a part of the page comes near — a jump, a link, a resize —
  // so that it is set before it is seen)
  const nearIO = new IntersectionObserver(wake, { rootMargin: "50% 0px" });
  ["#runway", "#features", "#listen", "#specs", "#faq", ".buy"].forEach((q) => { const el = $(q); if (el) nearIO.observe(el); });
  // (the keyboard's focus only: a button or a link a hand has pressed is
  // focused too, in most browsers, and is left to the scroll like the rest —
  // where the browser cannot tell the two apart, it is held as before)
  root.addEventListener("focusin", (e) => { let kb = true; try { kb = e.target.matches(":focus-visible"); } catch (x) {} held = kb ? e.target : null; wake(); });
  root.addEventListener("focusout", () => { held = null; wake(); });
  root.addEventListener("pointerdown", () => { if (held) { held = null; wake(); } }, { passive: true });
  // (the object over the pill: made ready while the page is idle, and shown
  // a moment before it can be seen — each is a great many planes at once)
  let codaAsked = false;
  // (and the slab, laid aside above the screen, laid back)
  const layScene = () => { if (sceneAway) { sceneAway = false; tKey = ""; put(scene, "visibility", ""); } };
  const wantScene = () => { if (sceneAsked) return; sceneAsked = true; idle(() => { sceneAsked = false; if (G && sceneEdge > -G.vh * .9) { layScene(); wake(); } }, 250); };
  const wantCoda = () => { if (codaAsked || !coda) return; codaAsked = true; idle(() => { codaAsked = false; if (G && G.coda && Yr > G.coda.a - G.vh * 1.6 && !coda.shown) { coda.show(true); coda.render(CF.x); } }, 250); };

  // S: where the page is followed to; Y: where it really is; all: every part
  // set, near the screen or not (as the page is laid out)
  function render(S, Y, all) {
    if (!G) return;
    const vh = G.vh;
    // (a part is set whenever it is near the screen, where the page is as
    // well as where it is followed to: a fast scroll brings a part on to the
    // screen well before the followed position does, and a part never set
    // there is shown as the page lays it out — a section word half there,
    // before its curtain has come)
    const dY = (Y - S) / vh, farR = (top, hi, lo) => Math.min(top, top - dY) > hi || Math.max(top, top - dY) < lo, far = (top, hi, lo) => !all && farR(top, hi, lo);
    // (and nothing is left hidden once the page has really brought it well up
    // the screen, however far behind it is followed)
    const up = (pageTop, a, b) => seg((pageTop - Y) / vh, a, b);
    follow = false;

    // ---- the two sources, carried on to their film ----
    const gate = flight(S, Y);

    // ---- the section words ----
    for (const t of titles) {
      const top = (t.top - S) / vh, near = !far(top, 1.6, -1.4);
      t.near = near;
      moving(t.h2, near); moving(t.cur, near);
      if (far(top, 1.2, -1)) continue;
      const q = t.pre ? 1 : Math.max(seg(top, .95, .5), up(t.top, .7, .4)), e = ease(q), E = t.ww * .5;
      // (its curtain, once it has uncovered the word, is gone — not laid out
      // at all, so it never reaches past the page's edge; where the scroll's
      // own animation draws the word and its curtain, only the rule and the
      // index are the script's)
      if (!t.sd) {
        put(t.cur, "transform", q < 1 ? `translate3d(${f1(-E + (t.ww + E + 4) * e)}px, 0, 0)` : "");
        put(t.cw, "display", q < 1 ? "" : "none");
        put(t.h2, "transform", q < 1 ? `translate3d(0, ${f2((1 - out3(q)) * 30)}px, 0)` : "");
      }
      let tr = ease(seg(q, .12, 1)), io = seg(q, .72, 1);
      // (the features' rule and index wait for the two plates to have passed them)
      if (t.feat && gate) { tr = Math.min(tr, gate.rule); io = Math.min(io, gate.ix); }
      if (hold(t.el)) io = tr = 1;
      // (the rule and the index a layer of their own from a little before
      // they move until the page is still again: see moving)
      t.done = q >= 1 && tr >= 1 && (!t.ix || io >= 1);
      if (!t.mv && near && !t.done) { t.mv = true; t.el.classList.add("mv"); }
      putVar(t.el, "--tr", f3(tr));
      if (t.ix) { put(t.ix, "opacity", f3(io)); put(t.ix, "visibility", io > 0 ? "visible" : "hidden"); }
    }

    // ---- the cards come up under their words ----
    for (const b of benches) {
      const top = (b.top - S) / vh;
      if (b.sd) continue;
      moving(b.el, !far(top, 1.7, -1.9));
      if (far(top, 1.3, -1.5)) continue;
      const q = hold(b.el) || b.pre ? 1 : Math.max(seg(top, 1.02, .72), up(b.top, .75, .35)), e = out3(q);
      put(b.el, "transform", q < 1 ? `translate3d(0, ${f2((1 - e) * (G.pin ? 70 : 44))}px, 0)` : "");
      put(b.el, "opacity", q < 1 ? f3(seg(q, 0, .55)) : "");
    }

    // ---- the films laid in ----
    for (const s of shots) {
      if (s === SRC && G.fly) continue;   // (the sources' is the two plates carried down: see flight)
      const c = (s.r.y + s.r.h / 2 - S) / vh, near = !far(c, 2.2, -1.4);
      moving(s.el, near); moving(s.fl, near);
      if (far(c, 1.8, -1)) { s.qc = null; continue; }
      // (never opened, nor shut, faster than OPEN whole: a key or a flick
      // past it shows it opening out of its part, never popping open)
      const qT = latched(s, laidQ(s, S, Y), S), dq = qT - (s.qc ?? qT), mq = dt / OPEN;
      s.qc = all || s.qc == null || Math.abs(dq) <= mq ? qT : s.qc + Math.sign(dq) * mq;
      if (s.qc !== qT) follow = true;
      openFilm(s, s.qc);
    }

    // ---- listen: the player and its list come up as one ----
    if (la && !la.sd) {
      const top = (G.la - S) / vh;
      moving(la, !far(top, 1.7, -1.9));
      if (!far(top, 1.3, -1.5)) {
        const q = hold(la) || G.la - vh < 0 ? 1 : Math.max(seg(top, 1, .7), up(G.la, .75, .35)), e = out3(q);
        put(la, "transform", q < 1 ? `translate3d(0, ${f2((1 - e) * (G.pin ? 56 : 40))}px, 0)` : "");
        put(la, "opacity", q < 1 ? f3(seg(q, 0, .7)) : "");
      }
    }
    // ---- the specifications: the drawing drawn part by part, each line as its part is ----
    // (on its own clock, followed from where the page is, never faster than
    // it can be read — whole in a second at the least: a key or a link to the
    // end passing it draws it in a moment, never in a frame)
    if (G.draw) {
      const top = (G.draw.top - S) / vh, dT = G.draw.a < 0 ? 1 : seg(Y, G.draw.a, G.draw.b), near = !far(top, 2, -1.6);
      moving(drawing, near); specLis.forEach((l) => moving(l.cur, near));
      // (laid out again: drawn where its clock is, near the screen, and where
      // the page is away from it — never moved on a second time in a frame)
      // (and its lines a moment behind it, at a brisk scroll: see there —
      // set at once where the page has come from away from it)
      if (!farR(top, 1.6, -1.2)) { const P = all ? DF.x : DF.step(dT, dt, 1), T = all ? TF.jump(P) : TF.step(P, dt, dcap); specs(P, all || !specs.near ? 0 : dt, T); specs.near = true; if (specs.lag) follow = true; }
      else { DF.jump(dT); TF.jump(dT); specs.near = false; if (all) specs(dT); }
    }

    // ---- the questions: each row uncovered as it comes up (open, or the keyboard's, it is there) ----
    for (const r of rows) {
      if (r.sd) continue;
      const top = (r.top - S) / vh;
      moving(r.cur, !far(top, 1.6, -1.4));
      if (far(top, 1.2, -1)) continue;
      const q = r.pre || r.el.open || hold(r.el) ? 1 : Math.max(seg(top, .97, .74), up(r.top, .7, .4)), e = ease(q);
      put(r.cur, "transform", q < 1 ? `translate3d(${f1(-r.e + (r.w + r.e + 4) * e)}px, 0, 0)` : "");
      put(r.cw, "display", q < 1 ? "" : "none");
    }

    // ---- the object, come back; the pill under it ----
    // (on its own clock too, followed from where the page is, never turned
    // faster than the slab is — a key or a flick to the end brings it home
    // in a moment, never whips it round: see its cap)
    let cT = 1;
    if (coda && G.coda) {
      cT = seg(Y, G.coda.a, G.coda.b); const near = Y > G.coda.a - vh * .35 || S > G.coda.a - vh * .35;
      if (!coda.built && Y > G.coda.a - vh * 1.5) { coda.build(); coda.show(false); coda.measure(); }
      if (coda.built) {
        if (!coda.shown && Y > G.coda.a - vh * 1.6) wantCoda();
        // (about to be seen, and not yet made ready: at once)
        if (!coda.shown && near) coda.show(true);
        if (near) coda.render(all ? CF.x : CF.step(cT, dt, coda.cap)); else CF.jump(cT);
      }
    }
    if (go) {
      const top = (G.go - S) / vh;
      for (const el of rise) moving(el, !far(top, 1.7, -Infinity));
      if (!far(top, 1.3, -Infinity)) {
        let q = hold(pair) || G.go - vh < 0 ? 1 : Math.max(seg(top, 1, .84), up(G.go, .75, .35));
        // (and never before the object over it has risen into its place:
        // come to faster than it rises — a flick, a key — the pill waits
        // under it, rather than be drawn over it)
        // (where the page's foot stops the object short of its last pose — a
        // tall window — its clock's end there is the place it rises to)
        if (coda && coda.built && !hold(pair)) { const k = Math.min(1, seg(G.max, G.coda.a, G.coda.b) / .75); q = Math.min(q, k > 0 ? Math.max(seg(CF.x, .45 * k, .75 * k), 1 - seg(cT - CF.x, .02, .12)) : 1); }
        const e = out3(q);
        for (const el of rise) {
          put(el, "transform", q < 1 ? `translate3d(0, ${f2((1 - e) * 22)}px, 0)` : "");
          put(el, "opacity", q < 1 ? f3(seg(q, 0, .8)) : "");
        }
      }
    }
  }

  // ---- how far a film is laid in, by the scroll alone ----
  // (S: where the page is followed to; Y: where it really is — a film is
  // never left unopened once the page has really brought it well up the
  // screen)
  function laidQ(s, S, Y = S) {
    const c = (s.r.y + s.r.h / 2 - S) / G.vh;
    // (on a phone a film is whole by the time its middle is four fifths of
    // the way down the screen: the index's links land it open)
    let q = narrow.matches ? seg(c, 1.1, .8) : seg(c, 1.06, .7);
    q = Math.max(q, seg((s.r.y + s.r.h / 2 - Y) / G.vh, .75, .45));
    // (and the sources', where it opens, by the features' link: see layout)
    if (s === SRC && G.srcBy != null) q = Math.max(q, seg(S, G.srcBy - .3 * G.vh, G.srcBy));
    return q;
  }

  // ---- at rest, nothing is left half-way ----
  // Once the page has been still a moment, a film the reader has stopped on
  // while it is laid in — most of it on the screen, but not yet whole —
  // finishes on its own, briefly, and plays; it stays whole, however the
  // page is scrolled, until it has left the screen. (The scroll itself is
  // never touched.) And what was given a layer of its own to move gives it
  // back, what is far from the screen is laid aside.
  const REST = 360, SETTLE = .42;
  let restT = 0, settling = false;
  function latched(s, q, S) {
    if (s.st == null) return q;
    if (s.r.y - S > G.vh || s.r.y + s.r.h - S < 0) { s.st = null; return q; }
    return Math.max(q, lerp(s.s0, 1, smooth(s.st)));
  }
  function atRest() {
    restT = 0;
    if (!G) return;
    const Y = Yr;
    for (const s of shots) {
      if ((s === SRC && G.fly) || s.st != null) continue;
      const q = laidQ(s, Y), top = s.r.y - Y, seen = (Math.min(G.vh, top + s.r.h) - Math.max(0, top)) / Math.min(s.r.h, G.vh);
      if (q > 0 && q < 1 && seen > .5) { s.st = 0; s.s0 = clamp01(s.q); settling = true; }
    }
    if (settling) wake();
    // (still, or all but: what is still moving keeps its layer a while longer)
    if (Math.abs(Y - S) < 2 && !OF.busy && !DP.busy && !FL.busy) {
      letGo();
      titles.forEach((t) => { if (t.mv && (!t.near || t.done)) { t.mv = false; t.el.classList.remove("mv"); } });
      if (coda && coda.built && coda.shown && G.coda && Y < G.coda.a - G.vh * 2) coda.show(false);
    } else restSoon();
  }
  // (set once and put off while the page still moves — set again on every
  // scroll event, it is a timer made and dropped in every frame of a scroll)
  let restAt = 0;
  const restCheck = () => { const w = restAt - performance.now(); if (w > 1) restT = setTimeout(restCheck, w); else atRest(); };
  const restSoon = () => { restAt = performance.now() + REST; if (!restT) restT = setTimeout(restCheck, REST); };

  // ---- a film opened out of the part its first words are about --------------
  // (SUMMON's out of its orb; on a phone, the sources' out of card A): a
  // window grows from nothing to that part, then to the whole film. The
  // window is the film's own box, drawn smaller where the window is, and its
  // picture drawn larger by as much inside it, so that the picture never
  // moves: transforms alone, the compositor's. Open, it plays.
  function openFilm(s, q) {
    if (Math.abs(q - s.q) < 1e-4) return;
    s.q = q;
    const open = q >= 1;
    if (s.opening !== !open) { s.opening = !open; s.el.classList.toggle("opening", !open); }
    // (not begun, it is not there at all, not even a point of its shadow)
    put(s.el, "visibility", q > 0 ? "" : "hidden");
    if (open) { put(s.el, "transform", ""); put(s.fl, "transform", ""); }
    else {
      const W = s.r.w, H = s.r.h, b = s.b0, bx0 = b[0] * W, by0 = b[1] * H, bx1 = b[2] * W, by1 = b[3] * H, cx = (bx0 + bx1) / 2, cy = (by0 + by1) / 2;
      const a = out3(seg(q, 0, .2)), e = ease(seg(q, .3, 1));
      const l = lerp(lerp(cx, bx0, a), 0, e), t = lerp(lerp(cy, by0, a), 0, e), r = lerp(lerp(cx, bx1, a), W, e), bt = lerp(lerp(cy, by1, a), H, e);
      const sx = Math.max(.004, (r - l) / W), sy = Math.max(.004, (bt - t) / H);
      put(s.el, "transform", `translate3d(${f2(l)}px, ${f2(t)}px, 0) scale(${sx.toFixed(5)}, ${sy.toFixed(5)})`);
      put(s.fl, "transform", `scale(${(1 / sx).toFixed(5)}, ${(1 / sy).toFixed(5)}) translate3d(${f2(-l)}px, ${f2(-t)}px, 0)`);
    }
    // (in, it plays; a little scroll back and it plays on)
    dock(s, q >= .995 || (s.docked === "1" && q > .6));
  }

  // ---- the specification drawing: come in at the object's slant, straightened, drawn ----
  // (dt: the frame's time; none, each line set where the clock has it)
  // (T: the drawing's turn, on its own capped clock: see render)
  function specs(P, dt = 0, T = P) {
    if (!specs.lag && Math.abs(P - (specs.P ?? -1)) < 1e-4 && Math.abs(T - (specs.T ?? -1)) < 1e-4) return;
    specs.P = P; specs.T = T;
    const ph = narrow.matches, k = 1 - ease(seg(T, .08, .62));
    put(drawing, "transform", k > .001 ? `perspective(1400px) translate3d(0, 0, ${f1(-(ph ? 160 : 240) * k)}px) rotateX(${f2((ph ? 46 : 54) * k)}deg) rotateY(${f2(6 * k)}deg) rotateZ(${f2(-14 * k)}deg)` : "");
    put(drawing, "opacity", P < .16 ? f3(smooth(P / .16)) : "");
    const at = (i) => .1 + .82 * CUM[Math.min(i, WEIGHT.length)], back = seg(P, .93, 1);
    for (const pt of parts) {
      const a0 = at(pt.k), a1 = at(pt.k + 1), u = seg(P, a0, a1 + .02);
      for (const m of pt.ms) {
        const f = out3(seg(u, m.s, m.s + .5));
        if (m.st) {
          if (!m.len) continue;
          // (not begun, it is not drawn at all: a dash of nothing still shows its round caps)
          const css = f >= 1 ? "" : f <= 0 ? "-" : f2(m.len * (1 - f)), st = m.e.style;
          if (css !== m.css) {
            m.css = css;
            st.visibility = css === "-" ? "hidden" : "";
            st.strokeDasharray = css && css !== "-" ? `${f1(m.len)} ${f1(m.len + 2)}` : "";
            st.strokeDashoffset = css === "-" ? "" : css;
          }
        } else put(m.e, "opacity", f >= 1 ? "" : f3(seg(u, .4, 1)));
      }
      // (a part drawn steps back while the next is drawn; all come back at the end)
      const dim = 1 - .5 * seg(P, a1, a1 + .03) * (1 - back);
      put(pt.g, "opacity", dim >= 1 ? "" : f3(dim));
    }
    // (a line's curtain never crosses it faster than LINE: a brisk scroll
    // draws a part in a frame or two, and a line uncovered in as little
    // would only blink on — it follows a moment behind instead, and comes
    // to rest just where the scroll puts it)
    let lag = false;
    for (const l of specLis) {
      const a0 = at(l.k), a1 = at(l.k + 1), a = a0 + (l.j / l.n) * (a1 - a0) * .7, g = seg(P, a, a + (a1 - a0) * (l.n > 1 ? .45 : .7)), E = l.tw * .5;
      const d = g - l.g, m = dt / LINE;
      l.g = dt > 0 && Math.abs(d) > m ? l.g + Math.sign(d) * m : g;
      if (l.g !== g) lag = true;
      const f = ease(l.g);
      put(l.cur, "transform", f < 1 ? `translate3d(${f1(-E + (l.tw + E + 4) * f)}px, 0, 0)` : "");
      put(l.cur, "visibility", f < 1 ? "" : "hidden");
    }
    specs.lag = lag;
  }

  // ---- the flight of the two sources ----
  // They set off as the hold ends and take the whole way to the features'
  // word to come down, on the screen all the way: across, turning and growing
  // till they lie flat, at the film's own size and place across, by FLAT;
  // meanwhile down, slowly, to where they wait for the film — just above its
  // landing place, or as low as the screen lets them where that is still
  // under its foot — and ride the last of the way down with the page. Their
  // rims, the hairline on their faces and their shadow are gone before they
  // lie flat. Then the film's own box comes in under them, carried where
  // they are (BOX0 to BOX1), and once it is whole they are not drawn at all:
  // it is the film that is set down in its place, and nothing of them is
  // left round it.
  let flying = false, boxed = false, flyOff = 0;
  const FLAT = .74, BOX0 = .78, BOX1 = .86;
  const land = (on) => { flying = on; if (!on) { T.gone.a = T.gone.b = T.away.a = T.away.b = 0; Object.values(carried).forEach((c) => { if (c) { c.el.style.display = "none"; c.sh.style.display = "none"; } }); } };
  // (the film's box: how far above its place it is carried, and how much of it shows)
  const box = (dy, op) => {
    if (op <= 0) dy = 0;
    boxed = op < 1 || Math.abs(dy) >= .05;
    put(SRC.el, "opacity", op >= 1 ? "" : f3(op));
    put(SRC.el, "transform", Math.abs(dy) < .05 ? "" : `translate3d(0, ${f2(dy)}px, 0)`);
  };
  const unbox = () => { if (boxed) { boxed = false; put(SRC.el, "opacity", ""); put(SRC.el, "transform", ""); } };
  function flight(S, Y) {
    const src = SRC;
    if (!G.fly || !src || !G.land) { if (flying) land(false); if (src) unbox(); if (src && src.fl) { put(src.fl, "opacity", ""); put(src.fso, "opacity", "0"); } return null; }
    const e = flyE;
    // (in, the film plays; a little way back up and it plays on)
    const landed = e >= .985 || (src.docked === "1" && e > .95);
    // (the film is whole whenever it shows: its socket is never seen empty)
    put(src.fl, "opacity", ""); put(src.fso, "opacity", "0");
    dock(src, landed);
    const ft = titles.find((t) => t.feat);
    if (e <= 0) { if (flying) land(false); box(0, 0); return { rule: 0, ix: 0 }; }
    const dims = slab.dims(), vh = G.vh, vw = G.vw, P = dims.persp;
    // the scene's centre and its eye, in the page — the hero taken as still
    // held at the top of the screen: they set off from their places over
    // the slab as they stand there, and are not taken up the screen with it
    // once it goes on its way (they leave it behind)
    // (where the slab is really drawn, against held at the top of the
    // screen: a quick scroll hands them over once the page has let the hero
    // go — gone up with the page by then, less its own drift down — so they
    // set off from there, eye and all, never a step away, and come down to
    // their own way by the time they lie flat. How far is kept from the
    // moment they set off, so that they are not taken on up the screen with
    // it, and given back as the page comes back, so that they are handed back
    // where it is)
    const off = G.pin ? Math.min(0, G.hold - Y) + (T.ty || 0) : 0;
    if (!flying) flyOff = off;
    // (let go softly: past the hand-over they go on up with the slab a little
    // way at the speed they had, and come to rest Dk above, never stopping dead)
    const Dk = .06 * G.vh, rel = off - flyOff;
    const back = (rel >= 0 ? off : flyOff - Dk * Math.tanh(-rel / Dk)) * (1 - smooth(seg(e, 0, FLAT)));
    const heroTop = Math.max(Y, 0) + back, sc = G.scene;
    const cx0 = sc.x + sc.w / 2, cy0 = heroTop + sc.y + sc.h / 2;
    const eyeX = lerp(cx0, vw / 2, smooth(e)), eyeY = lerp(cy0 - .04 * sc.h, S + vh * .46, smooth(e));
    // how far above their landing place they wait: all the room there is
    // under them, less what is left of the way (a smooth corner between the
    // two, and nothing at all over its last stretch — there they are the film).
    // Where the page is now, not where the scroll's smoothing has it: where
    // they wait is a place on the screen, however fast the page moves under them
    const R = G.room, rr = Math.min(R / 2, 40), over = G.landAt - Y - R;
    const wait = over <= -rr ? 0 : over >= rr ? over : ((over + rr) * (over + rr)) / (4 * rr);
    // across, turned, grown and flat by FLAT; down nearly the whole way, the
    // two as one (their middle), each to its own place in it by FLAT
    const er = smooth(seg(e, 0, FLAT)), ey = smooth(seg(e, 0, .9));
    const hover = vw * .05 * smooth(seg(e, .04, .3)) * (1 - smooth(seg(e, .42, FLAT - .02)));
    // (their rims and hairlines go before they lie flat, and their shadow with them)
    const rim = 1 - smooth(seg(e, .5, FLAT - .02)), so = clamp01(seg(e, .04, .25)) * (1 - smooth(seg(e, .45, FLAT - .04)));
    // the film's box comes in under them once they lie flat — only once its
    // card has come up (it has, by then, on any screen they fly on)
    const cb = G.srcCard, cq = !cb || hold(cb.el) || cb.pre ? 1 : Math.max(seg((cb.top - S) / vh, 1.02, .72), seg((cb.top - Y) / vh, .75, .35));
    const bo = e >= 1 ? 1 : cq >= 1 ? smooth(seg(e, BOX0, BOX1)) : 0, gone = bo >= 1;
    // (the film's box a layer of its own from a little before it comes in: see moving)
    moving(src.el, e > .6 && e < 1);
    const geo = [];
    for (const key of ["a", "b"]) {
      const c = carry(key), pm = slab.plateM(key);
      if (!c || !pm) continue;
      const p0 = pm.m.transformPoint(new DOMPoint(pm.w / 2, pm.h / 2, 0)), L = G.land[key];
      // (and where they set off from, as if the slab had not gone on its way down)
      geo.push({ key, c, pm, p0, L, y0: cy0 + p0.y - pm.ty, y1: L.y + L.h / 2 });
    }
    const n = geo.length || 1, m0 = geo.reduce((a, g) => a + g.y0, 0) / n, m1 = geo.reduce((a, g) => a + g.y1, 0) / n;
    const mid = lerp(m0, m1 - wait, ey);
    let live = false, top = Infinity, left = Infinity;
    for (const { key, c, pm, p0, L, y0, y1 } of geo) {
      live = true;
      // (it is no longer the slab's to draw — T.gone, T.away: decided before
      // the slab is drawn, see "every frame")
      // (the film whole under them, they are not drawn at all — none of their
      // planes left for the compositor — until the page takes them back up)
      const shown = gone ? "none" : "";
      if (c.el.style.display !== shown) { c.el.style.display = shown; c.sh.style.display = shown; }
      // (its own layout size: the slab's, in the slab's pixels)
      if (c.w !== pm.w || c.h !== pm.h) { c.w = pm.w; c.h = pm.h; c.el.style.width = `${f2(pm.w)}px`; c.el.style.height = `${f2(pm.h)}px`; }
      const m = pm.m, sg0 = Math.hypot(m.m11, m.m12, m.m13), q0 = quat(m, sg0);
      const sg1 = L.w / pm.w;
      const x0 = cx0 + p0.x, z0 = p0.z, x1 = L.x + L.w / 2;
      const x = lerp(x0, x1, er), yy = mid + lerp(y0 - m0, y1 - m1, er), z = lerp(z0, 0, out2(seg(e, 0, .5))) + hover;
      const sg = Math.exp(lerp(Math.log(sg0), Math.log(sg1), er));
      const q = slerpId(q0, er), [ax, ay, az, ang] = axisAngle(q);
      if (!gone) {
        const css = `translate3d(${f2(eyeX)}px, ${f2(eyeY)}px, 0) perspective(${f1(P)}px) translate3d(${f2(x - eyeX)}px, ${f2(yy - eyeY)}px, ${f2(z)}px) rotate3d(${ax.toFixed(5)}, ${ay.toFixed(5)}, ${az.toFixed(5)}, ${ang.toFixed(5)}rad) scale3d(${sg.toFixed(5)}, ${sg.toFixed(5)}, ${sg.toFixed(5)}) translate(${f2(-pm.w / 2)}px, ${f2(-pm.h / 2)}px)`;
        if (css !== c.css) { c.css = css; c.el.style.transform = css; }
        // it keeps its own face all the way, and takes the film's first
        // frame only once it lies flat on the film's own place, just before
        // the film's box comes in under it: a short dissolve where it lies
        // still, never a picture changed in the air
        put(c.ff, "opacity", f3(smooth(seg(e, FLAT, BOX0))));
        // its rim takes the light as it turns, and goes as it lies down
        const Rm = new DOMMatrix().rotateAxisAngleSelf(ax, ay, az, (ang * 180) / Math.PI);
        const vx = eyeX - x, vy = eyeY - yy, vz = P - z, vm = Math.hypot(vx, vy, vz) || 1;
        slab.shadeRimAs(c.rim, Rm, [vx / vm, vy / vm, vz / vm], rim);
        putVar(c.pc || c.el, "--hl", f3(rim));
        // and its shadow falls on the page under it, closing in as it comes down
        const h = Math.max(0, z) / (vw * .05);
        if (c.shw !== L.w) { c.shw = L.w; c.sh.style.width = `${f1(L.w * 1.24)}px`; c.sh.style.height = `${f1(L.h * 1.5)}px`; }
        const sk = lerp(sg0 / sg1, 1, er);
        put(c.sh, "visibility", so > 0 ? "" : "hidden");
        put(c.sh, "transform", `translate3d(${f1(x - L.w * 1.24 * sk / 2 + h * 10)}px, ${f1(yy - L.h * 1.5 * sk / 2 + 16 + h * 26)}px, 0) scale(${sk.toFixed(4)})`);
        put(c.sh, "opacity", f3(so * .9));
      }
      // (how far it reaches, as the screen shows it, for the features' line and index)
      const k = P / Math.max(1, P - z), hw = (pm.w * sg * k) / 2, hh = (pm.h * sg * k) / 2, X = eyeX + (x - eyeX) * k, Yc = eyeY + (yy - eyeY) * k;
      top = Math.min(top, Yc - hh * Math.max(.2, Math.cos(Math.min(ang, 1.4)))); left = Math.min(left, X - hw);
    }
    // the film's box, under them, carried where they are (they lie flat on
    // their places in it by then, so the one is exactly the other)
    box(live ? mid - m1 : 0, live ? bo : 1);
    flying = live;
    // (while the slab still settles under the scroll, keep following it)
    follow = live && !gone && slab.running() && slab.settling();
    if (!ft || !live) return null;
    // the features' line is drawn only up to the plates until they are past it,
    // then out behind them; its index comes in once they are below it
    const lim = clamp01((left - 24 - ft.ruleL) / ft.ruleW);
    const pass = top - ft.rule;
    return { rule: lerp(lim, 1, smooth(seg(pass, 4, G.clear * .45))), ix: smooth(seg(pass, G.clear * .3, G.clear * .8)) };
  }

  // ---- when the page changes size ----
  let lay = 0, cWas = null, gWas = null;
  // (every part the scroll moves is put where it is as soon as the page is
  // laid out — below the screen not yet come, above it come — so that a part
  // the compositor brings on before the page's next frame is never shown as
  // the style lays it out; the parts carried down made ready meanwhile)
  // (a window resized, a phone turned, the object still held or on its way
  // off: the browser's scroll anchoring has moved the page by what the hero
  // and the runway changed by, which is not where the reader was in the
  // choreography — they are put back at the same place in it, through the new
  // geometry, before the frame is drawn. Yr is still the page's position from
  // before the change: the scroll event the anchoring sends comes after the
  // resize. Past the hero, the browser's anchoring is left alone)
  const relayout = () => { if (lay) return; gWas = G; cWas = G ? chor(Yr) : null; lay = requestAnimationFrame(() => { lay = 0; layout(); if (gWas && cWas != null && cWas < 2 && (G.vw !== gWas.vw || G.vh !== gWas.vh || G.pin !== gWas.pin)) { const y = Math.round(cWas <= 1 ? cWas * G.hold : G.hold + (cWas - 1) * G.depSpan); if (Math.abs(window.scrollY - y) > .5) scrollTo({ top: y, behavior: "instant" }); } Yr = window.scrollY; Object.values(carried).forEach((c) => { if (c) c.css = ""; }); specs.P = -1; render(S, Yr, true); wake(); if (G.fly) idle(() => { copy("a"); copy("b"); }, 1500); }); };
  // (a phone's bars coming and going are not a new screen: see layout)
  addEventListener("resize", () => { if (G && (narrow.matches || coarse.matches) && document.documentElement.clientWidth === G.vw && Math.abs(window.innerHeight - G.vh) < 160) return; relayout(); });
  narrow.addEventListener("change", relayout);
  board1.addEventListener("change", relayout);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(relayout);
  // (an answer opening or closing changes the page's height on every frame
  // of its slide: that is measured once, when it has stopped — "halo:faq")
  const faqA = [...root.querySelectorAll(".faq .q .a")];
  const sliding = () => faqA.some((a) => a.getAnimations && a.getAnimations().length);
  const still = () => { if (!sliding()) relayout(); };
  if ("ResizeObserver" in window) new ResizeObserver(still).observe(root);
  root.addEventListener("halo:faq", still);
  // A way in from elsewhere — a link to #features, #listen or #specs —
  // lands where the page's own links land, not at the section's top (where
  // what is put together there is not yet whole): the browser's own glide
  // there, a moment after the page has loaded, is taken over as it sets off
  // by one to that place. (A place the browser restores — a reload, back or
  // forward — is left as it is.) Only while the page is still the link's:
  // a reader who has done anything at all before then — a wheel, a touch, a
  // key, a press — has it, and it is never taken back from them; nor is it
  // where the page no longer lies where the link put it (or, the browser
  // not there yet, on its way there from the top), whatever moved it. And a
  // glide there under way, the browser's or the page's, stops where it is
  // the moment the reader does anything, and the page is theirs from there.
  let moved = false, arriving = false;
  const TOLD = ["wheel", "touchstart", "keydown", "pointerdown"];
  const halt = () => {
    const h = document.documentElement.style, was = h.scrollBehavior;
    h.scrollBehavior = "auto"; scrollTo(window.scrollX, window.scrollY); h.scrollBehavior = was;
  };
  const told = (e) => {
    if (e.type === "keydown" && /^(Shift|Control|Alt|Meta|CapsLock|OS|Fn)$/.test(e.key)) return;
    moved = true;
    TOLD.forEach((t) => removeEventListener(t, told, true));
    if (arriving) { arriving = false; halt(); }
  };
  TOLD.forEach((t) => addEventListener(t, told, { passive: true, capture: true }));
  const wayTo = () => {
    let id = "";
    try { id = decodeURIComponent(location.hash.slice(1)); } catch (e) {}
    return (["features", "listen", "specs"].includes(id) && document.getElementById(id)) || null;
  };
  const wayIn = () => { const el = wayTo(); return el && G ? root.__landAt(el) : null; };
  const glideIn = () => { const y = wayIn(); if (y != null && Math.abs(window.scrollY - y) > 1) scrollTo({ top: y, behavior: "smooth" }); };
  const untouched = (y0) => {
    const el = wayTo();
    if (moved || !el || !G) return false;
    const y = window.scrollY, at = pageOf(el).y - (parseFloat(getComputedStyle(el).scrollMarginTop) || 0), near = G.vh * .25;
    return Math.abs(y - at) < near || (y0 < near && y > y0 - near && y < at + near);
  };
  addEventListener("hashchange", glideIn);
  addEventListener("load", () => {
    relayout(); restSoon();
    let how = "navigate";
    try { how = performance.getEntriesByType("navigation")[0].type; } catch (e) {}
    const y0 = window.scrollY;
    if (how !== "navigate" || wayIn() == null || !untouched(y0)) return;
    // (as the browser's glide sets off — or, where it went there at once or
    // not at all, a moment later)
    let done = false;
    arriving = true;
    const take = () => {
      if (done) return;
      done = true; removeEventListener("scroll", take);
      if (!untouched(y0)) { arriving = false; return; }
      requestAnimationFrame(() => { if (!moved) glideIn(); });
      // (the glide's own length at most: the page is the reader's again after it)
      setTimeout(() => { arriving = false; }, 2500);
    };
    addEventListener("scroll", take, { passive: true });
    setTimeout(take, 900);
  });
  layout();
  // (as the page opens: everything where the page is, at once)
  Yr = window.scrollY; S = SF.jump(Yr); OF.jump(Math.min(chor(Yr), G.cMax)); DP.jump(clamp01(OF.x - 1));
  flyE = FL.jump(G.fly && SRC && G.land ? seg(S, G.flyFrom, G.landAt) : 0);
  if (G.draw) { const d0 = G.draw.a < 0 ? 1 : seg(Yr, G.draw.a, G.draw.b); DF.jump(d0); TF.jump(d0); }
  if (G.coda) CF.jump(seg(Yr, G.coda.a, G.coda.b));
  render(S, Yr, true);
  wake();
  // (the object over the pill, and the parts carried down, made ready once
  // the page has come and is idle)
  addEventListener("load", () => idle(() => {
    if (coda && !coda.built) { coda.build(); coda.show(false); coda.measure(); }
    if (G && G.fly) { copy("a"); copy("b"); }
  }, 2000));
  // (for the motion lab: where the page is, where it is followed to, and the
  // object's place in its choreography — read only)
  root.__scroll = { state: () => ({ S, Y: Yr, c: OF.x, cT: OF.to, cv: OF.v, d: DP.x, fl: FL.x, cd: CF.x, dr: DF.x }), G: () => G };
})();
// ==/scroll js==
